/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type ReportRunSchedule = {
  __typename: "ReportRunSchedule",
  id: string,
  reportId: string,
  scheduleExpression: string,
  enabled: boolean,
  subscribers: Array< string >,
  createdAt: string,
  updatedAt: string,
};

export type BoughtList = {
  __typename: "BoughtList",
  id: string,
  saluation?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  gender?: string | null,
  age?: number | null,
  address?: string | null,
  city?: string | null,
  state?: string | null,
  zipcode?: string | null,
  county?: string | null,
  householdIncome?: string | null,
  householdIncomeBottom?: number | null,
  householdIncomeTop?: number | null,
  homeValue?: string | null,
  homeValueBottom?: number | null,
  homeValueTop?: number | null,
  boatingSailing?: string | null,
  tennis?: string | null,
  golf?: string | null,
  boatOwner?: string | null,
  upscaleLiving?: string | null,
  suppress?: string | null,
  doNotMail?: string | null,
  dropDate?: string | null,
  zip5?: string | null,
  batchCode?: string | null,
  listDate?: string | null,
  listName?: string | null,
  listNameId?: string | null,
  qseq?: number | null,
  expirationDate?: string | null,
  lastUpdated?: string | null,
  site1?: string | null,
  siteDistance1?: number | null,
  epm3Decile1?: number | null,
  epm3Score1?: number | null,
  epm3Tier1?: string | null,
  site2?: string | null,
  siteDistance2?: string | null,
  epm3Decile2?: number | null,
  epm3Score2?: number | null,
  epm3Tier2?: string | null,
  blSelect?: string | null,
  hlMatch?: string | null,
  randomNumber?: number | null,
  randomFlag?: number | null,
  netNewFlag?: number | null,
  staticControlFlag?: string | null,
  hlGrpRowList?: string | null,
  hlODateList?: string | null,
  optOut?: boolean | null,
  optOutDateTime?: string | null,
  optOutUpdatedBy?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  expirationUnixTime?: number | null,
};

export type CreateBLConcurrencyLockInput = {
  community: string,
  lockToken?: string | null,
  createdAt?: string | null,
  expirationUnixTime?: number | null,
};

export type ModelBLConcurrencyLockConditionInput = {
  lockToken?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  expirationUnixTime?: ModelIntInput | null,
  and?: Array< ModelBLConcurrencyLockConditionInput | null > | null,
  or?: Array< ModelBLConcurrencyLockConditionInput | null > | null,
  not?: ModelBLConcurrencyLockConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type BLConcurrencyLock = {
  __typename: "BLConcurrencyLock",
  community: string,
  lockToken?: string | null,
  createdAt?: string | null,
  expirationUnixTime?: number | null,
  updatedAt: string,
};

export type UpdateBLConcurrencyLockInput = {
  community: string,
  lockToken?: string | null,
  createdAt?: string | null,
  expirationUnixTime?: number | null,
};

export type DeleteBLConcurrencyLockInput = {
  community: string,
};

export type CreateBoughtListInput = {
  id?: string | null,
  saluation?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  gender?: string | null,
  age?: number | null,
  address?: string | null,
  city?: string | null,
  state?: string | null,
  zipcode?: string | null,
  county?: string | null,
  householdIncome?: string | null,
  householdIncomeBottom?: number | null,
  householdIncomeTop?: number | null,
  homeValue?: string | null,
  homeValueBottom?: number | null,
  homeValueTop?: number | null,
  boatingSailing?: string | null,
  tennis?: string | null,
  golf?: string | null,
  boatOwner?: string | null,
  upscaleLiving?: string | null,
  suppress?: string | null,
  doNotMail?: string | null,
  dropDate?: string | null,
  zip5?: string | null,
  batchCode?: string | null,
  listDate?: string | null,
  listName?: string | null,
  listNameId?: string | null,
  qseq?: number | null,
  expirationDate?: string | null,
  lastUpdated?: string | null,
  site1?: string | null,
  siteDistance1?: number | null,
  epm3Decile1?: number | null,
  epm3Score1?: number | null,
  epm3Tier1?: string | null,
  site2?: string | null,
  siteDistance2?: string | null,
  epm3Decile2?: number | null,
  epm3Score2?: number | null,
  epm3Tier2?: string | null,
  blSelect?: string | null,
  hlMatch?: string | null,
  randomNumber?: number | null,
  randomFlag?: number | null,
  netNewFlag?: number | null,
  staticControlFlag?: string | null,
  hlGrpRowList?: string | null,
  hlODateList?: string | null,
  optOut?: boolean | null,
  optOutDateTime?: string | null,
  optOutUpdatedBy?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  expirationUnixTime?: number | null,
};

export type ModelBoughtListConditionInput = {
  saluation?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  gender?: ModelStringInput | null,
  age?: ModelIntInput | null,
  address?: ModelStringInput | null,
  city?: ModelStringInput | null,
  state?: ModelStringInput | null,
  zipcode?: ModelStringInput | null,
  county?: ModelStringInput | null,
  householdIncome?: ModelStringInput | null,
  householdIncomeBottom?: ModelFloatInput | null,
  householdIncomeTop?: ModelFloatInput | null,
  homeValue?: ModelStringInput | null,
  homeValueBottom?: ModelFloatInput | null,
  homeValueTop?: ModelFloatInput | null,
  boatingSailing?: ModelStringInput | null,
  tennis?: ModelStringInput | null,
  golf?: ModelStringInput | null,
  boatOwner?: ModelStringInput | null,
  upscaleLiving?: ModelStringInput | null,
  suppress?: ModelStringInput | null,
  doNotMail?: ModelStringInput | null,
  dropDate?: ModelStringInput | null,
  zip5?: ModelStringInput | null,
  batchCode?: ModelStringInput | null,
  listDate?: ModelStringInput | null,
  listName?: ModelStringInput | null,
  listNameId?: ModelStringInput | null,
  qseq?: ModelIntInput | null,
  expirationDate?: ModelStringInput | null,
  lastUpdated?: ModelStringInput | null,
  site1?: ModelStringInput | null,
  siteDistance1?: ModelFloatInput | null,
  epm3Decile1?: ModelIntInput | null,
  epm3Score1?: ModelFloatInput | null,
  epm3Tier1?: ModelStringInput | null,
  site2?: ModelStringInput | null,
  siteDistance2?: ModelStringInput | null,
  epm3Decile2?: ModelIntInput | null,
  epm3Score2?: ModelFloatInput | null,
  epm3Tier2?: ModelStringInput | null,
  blSelect?: ModelStringInput | null,
  hlMatch?: ModelStringInput | null,
  randomNumber?: ModelFloatInput | null,
  randomFlag?: ModelIntInput | null,
  netNewFlag?: ModelIntInput | null,
  staticControlFlag?: ModelStringInput | null,
  hlGrpRowList?: ModelStringInput | null,
  hlODateList?: ModelStringInput | null,
  optOut?: ModelBooleanInput | null,
  optOutDateTime?: ModelStringInput | null,
  optOutUpdatedBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  expirationUnixTime?: ModelIntInput | null,
  and?: Array< ModelBoughtListConditionInput | null > | null,
  or?: Array< ModelBoughtListConditionInput | null > | null,
  not?: ModelBoughtListConditionInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type UpdateBoughtListInput = {
  id: string,
  saluation?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  gender?: string | null,
  age?: number | null,
  address?: string | null,
  city?: string | null,
  state?: string | null,
  zipcode?: string | null,
  county?: string | null,
  householdIncome?: string | null,
  householdIncomeBottom?: number | null,
  householdIncomeTop?: number | null,
  homeValue?: string | null,
  homeValueBottom?: number | null,
  homeValueTop?: number | null,
  boatingSailing?: string | null,
  tennis?: string | null,
  golf?: string | null,
  boatOwner?: string | null,
  upscaleLiving?: string | null,
  suppress?: string | null,
  doNotMail?: string | null,
  dropDate?: string | null,
  zip5?: string | null,
  batchCode?: string | null,
  listDate?: string | null,
  listName?: string | null,
  listNameId?: string | null,
  qseq?: number | null,
  expirationDate?: string | null,
  lastUpdated?: string | null,
  site1?: string | null,
  siteDistance1?: number | null,
  epm3Decile1?: number | null,
  epm3Score1?: number | null,
  epm3Tier1?: string | null,
  site2?: string | null,
  siteDistance2?: string | null,
  epm3Decile2?: number | null,
  epm3Score2?: number | null,
  epm3Tier2?: string | null,
  blSelect?: string | null,
  hlMatch?: string | null,
  randomNumber?: number | null,
  randomFlag?: number | null,
  netNewFlag?: number | null,
  staticControlFlag?: string | null,
  hlGrpRowList?: string | null,
  hlODateList?: string | null,
  optOut?: boolean | null,
  optOutDateTime?: string | null,
  optOutUpdatedBy?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  expirationUnixTime?: number | null,
};

export type DeleteBoughtListInput = {
  id: string,
};

export type CreateUserFilterInput = {
  id?: string | null,
  listType: string,
  name: string,
  filterDefinitions: string,
  filterSelections: string,
};

export type ModelUserFilterConditionInput = {
  listType?: ModelStringInput | null,
  name?: ModelStringInput | null,
  filterDefinitions?: ModelStringInput | null,
  filterSelections?: ModelStringInput | null,
  and?: Array< ModelUserFilterConditionInput | null > | null,
  or?: Array< ModelUserFilterConditionInput | null > | null,
  not?: ModelUserFilterConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type UserFilter = {
  __typename: "UserFilter",
  id: string,
  listType: string,
  name: string,
  filterDefinitions: string,
  filterSelections: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateUserFilterInput = {
  id: string,
  listType?: string | null,
  name?: string | null,
  filterDefinitions?: string | null,
  filterSelections?: string | null,
};

export type DeleteUserFilterInput = {
  id: string,
};

export type CreateExportJobInput = {
  id?: string | null,
  exportName: string,
  listType: string,
  reportId?: string | null,
  status: string,
  statusMessage?: string | null,
  filterInput: string,
  filterFields?: string | null,
  outputFormat?: string | null,
  s3Key?: string | null,
  totalRecords?: number | null,
  fileSize?: number | null,
  startedAt?: string | null,
  expiresAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  owner?: string | null,
  authorizedReaders?: Array< string > | null,
  debugInfo?: string | null,
};

export type ModelExportJobConditionInput = {
  exportName?: ModelStringInput | null,
  listType?: ModelStringInput | null,
  reportId?: ModelStringInput | null,
  status?: ModelStringInput | null,
  statusMessage?: ModelStringInput | null,
  filterInput?: ModelStringInput | null,
  filterFields?: ModelStringInput | null,
  outputFormat?: ModelStringInput | null,
  s3Key?: ModelStringInput | null,
  totalRecords?: ModelIntInput | null,
  fileSize?: ModelFloatInput | null,
  startedAt?: ModelStringInput | null,
  expiresAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  authorizedReaders?: ModelStringInput | null,
  debugInfo?: ModelStringInput | null,
  and?: Array< ModelExportJobConditionInput | null > | null,
  or?: Array< ModelExportJobConditionInput | null > | null,
  not?: ModelExportJobConditionInput | null,
};

export type ExportJob = {
  __typename: "ExportJob",
  id: string,
  exportName: string,
  listType: string,
  reportId?: string | null,
  status: string,
  statusMessage?: string | null,
  filterInput: string,
  filterFields?: string | null,
  outputFormat?: string | null,
  s3Key?: string | null,
  totalRecords?: number | null,
  fileSize?: number | null,
  startedAt?: string | null,
  expiresAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  owner?: string | null,
  authorizedReaders?: Array< string > | null,
  debugInfo?: string | null,
};

export type UpdateExportJobInput = {
  id: string,
  exportName?: string | null,
  listType?: string | null,
  reportId?: string | null,
  status?: string | null,
  statusMessage?: string | null,
  filterInput?: string | null,
  filterFields?: string | null,
  outputFormat?: string | null,
  s3Key?: string | null,
  totalRecords?: number | null,
  fileSize?: number | null,
  startedAt?: string | null,
  expiresAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  owner?: string | null,
  authorizedReaders?: Array< string > | null,
  debugInfo?: string | null,
};

export type DeleteExportJobInput = {
  id: string,
};

export type CreateReportRunScheduleInput = {
  id?: string | null,
  reportId: string,
  scheduleExpression: string,
  enabled: boolean,
  subscribers: Array< string >,
};

export type ModelReportRunScheduleConditionInput = {
  reportId?: ModelStringInput | null,
  scheduleExpression?: ModelStringInput | null,
  enabled?: ModelBooleanInput | null,
  subscribers?: ModelStringInput | null,
  and?: Array< ModelReportRunScheduleConditionInput | null > | null,
  or?: Array< ModelReportRunScheduleConditionInput | null > | null,
  not?: ModelReportRunScheduleConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateReportRunScheduleInput = {
  id: string,
  reportId?: string | null,
  scheduleExpression?: string | null,
  enabled?: boolean | null,
  subscribers?: Array< string > | null,
};

export type DeleteReportRunScheduleInput = {
  id: string,
};

export type CreateHouselistNewInput = {
  id?: string | null,
  accountID?: string | null,
  listName?: string | null,
  listNameId?: string | null,
  control?: string | null,
  homeValue?: string | null,
  homeValueBottom?: number | null,
  homeValueTop?: number | null,
  hohIncome?: string | null,
  hohIncomeBottom?: number | null,
  hohIncomeTop?: number | null,
  hohNetWorth?: string | null,
  hohNetWorthBottom?: number | null,
  hohNetWorthTop?: number | null,
  groupName?: string | null,
  birthDate?: string | null,
  deceasedDate?: string | null,
  distanceToSite?: number | null,
  doNotCall?: boolean | null,
  email?: string | null,
  emailBounceDate?: string | null,
  epm2Grade?: number | null,
  epm2Score?: number | null,
  epm2Tier?: string | null,
  firstName?: string | null,
  gender?: string | null,
  hasOptedOutOfEmail?: boolean | null,
  hohAge?: number | null,
  homePhone?: string | null,
  contactId?: string | null,
  ilContactStatus?: string | null,
  labelSalutation?: string | null,
  lastName?: string | null,
  letterSalutation?: string | null,
  neighborhood?: string | null,
  city?: string | null,
  zip5?: string | null,
  zipcode?: string | null,
  state?: string | null,
  address?: string | null,
  maritalStatus?: string | null,
  mlActive?: boolean | null,
  cellPhone?: string | null,
  primaryContact?: string | null,
  primarySite?: string | null,
  latitude?: number | null,
  longitude?: number | null,
  qasValidationStatus?: string | null,
  contactType?: string | null,
  returnedMail?: boolean | null,
  ccContactStatus?: string | null,
  opportunitySite?: string | null,
  opportunityId?: string | null,
  loc?: string | null,
  ltsGrade?: number | null,
  ltsScore?: number | null,
  primaryMotivation?: string | null,
  communityName?: string | null,
  rating?: string | null,
  segmentation?: string | null,
  settledDate?: string | null,
  salesStage?: string | null,
  priorityDate?: string | null,
  reservationDate?: string | null,
  businessType?: string | null,
  salesOptionDate?: string | null,
  apartmentName?: string | null,
  optOut?: boolean | null,
  optOutDateTime?: string | null,
  mlContactInactiveReasons?: Array< string > | null,
  mlSOInactiveReasons?: Array< string > | null,
  mlInactiveReasons?: Array< string > | null,
  priorityType?: string | null,
  nextStep?: string | null,
  salesCounselor?: string | null,
  salesCounselorName?: string | null,
  timeframe?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelHouselistNewConditionInput = {
  accountID?: ModelStringInput | null,
  listName?: ModelStringInput | null,
  listNameId?: ModelStringInput | null,
  control?: ModelStringInput | null,
  homeValue?: ModelStringInput | null,
  homeValueBottom?: ModelFloatInput | null,
  homeValueTop?: ModelFloatInput | null,
  hohIncome?: ModelStringInput | null,
  hohIncomeBottom?: ModelFloatInput | null,
  hohIncomeTop?: ModelFloatInput | null,
  hohNetWorth?: ModelStringInput | null,
  hohNetWorthBottom?: ModelFloatInput | null,
  hohNetWorthTop?: ModelFloatInput | null,
  groupName?: ModelStringInput | null,
  birthDate?: ModelStringInput | null,
  deceasedDate?: ModelStringInput | null,
  distanceToSite?: ModelFloatInput | null,
  doNotCall?: ModelBooleanInput | null,
  email?: ModelStringInput | null,
  emailBounceDate?: ModelStringInput | null,
  epm2Grade?: ModelIntInput | null,
  epm2Score?: ModelFloatInput | null,
  epm2Tier?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  gender?: ModelStringInput | null,
  hasOptedOutOfEmail?: ModelBooleanInput | null,
  hohAge?: ModelIntInput | null,
  homePhone?: ModelStringInput | null,
  contactId?: ModelStringInput | null,
  ilContactStatus?: ModelStringInput | null,
  labelSalutation?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  letterSalutation?: ModelStringInput | null,
  neighborhood?: ModelStringInput | null,
  city?: ModelStringInput | null,
  zip5?: ModelStringInput | null,
  zipcode?: ModelStringInput | null,
  state?: ModelStringInput | null,
  address?: ModelStringInput | null,
  maritalStatus?: ModelStringInput | null,
  mlActive?: ModelBooleanInput | null,
  cellPhone?: ModelStringInput | null,
  primaryContact?: ModelStringInput | null,
  primarySite?: ModelStringInput | null,
  latitude?: ModelFloatInput | null,
  longitude?: ModelFloatInput | null,
  qasValidationStatus?: ModelStringInput | null,
  contactType?: ModelStringInput | null,
  returnedMail?: ModelBooleanInput | null,
  ccContactStatus?: ModelStringInput | null,
  opportunitySite?: ModelStringInput | null,
  opportunityId?: ModelStringInput | null,
  loc?: ModelStringInput | null,
  ltsGrade?: ModelIntInput | null,
  ltsScore?: ModelFloatInput | null,
  primaryMotivation?: ModelStringInput | null,
  communityName?: ModelStringInput | null,
  rating?: ModelStringInput | null,
  segmentation?: ModelStringInput | null,
  settledDate?: ModelStringInput | null,
  salesStage?: ModelStringInput | null,
  priorityDate?: ModelStringInput | null,
  reservationDate?: ModelStringInput | null,
  businessType?: ModelStringInput | null,
  salesOptionDate?: ModelStringInput | null,
  apartmentName?: ModelStringInput | null,
  optOut?: ModelBooleanInput | null,
  optOutDateTime?: ModelStringInput | null,
  mlContactInactiveReasons?: ModelStringInput | null,
  mlSOInactiveReasons?: ModelStringInput | null,
  mlInactiveReasons?: ModelStringInput | null,
  priorityType?: ModelStringInput | null,
  nextStep?: ModelStringInput | null,
  salesCounselor?: ModelStringInput | null,
  salesCounselorName?: ModelStringInput | null,
  timeframe?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHouselistNewConditionInput | null > | null,
  or?: Array< ModelHouselistNewConditionInput | null > | null,
  not?: ModelHouselistNewConditionInput | null,
};

export type HouselistNew = {
  __typename: "HouselistNew",
  id: string,
  accountID?: string | null,
  listName?: string | null,
  listNameId?: string | null,
  control?: string | null,
  homeValue?: string | null,
  homeValueBottom?: number | null,
  homeValueTop?: number | null,
  hohIncome?: string | null,
  hohIncomeBottom?: number | null,
  hohIncomeTop?: number | null,
  hohNetWorth?: string | null,
  hohNetWorthBottom?: number | null,
  hohNetWorthTop?: number | null,
  groupName?: string | null,
  birthDate?: string | null,
  deceasedDate?: string | null,
  distanceToSite?: number | null,
  doNotCall?: boolean | null,
  email?: string | null,
  emailBounceDate?: string | null,
  epm2Grade?: number | null,
  epm2Score?: number | null,
  epm2Tier?: string | null,
  firstName?: string | null,
  gender?: string | null,
  hasOptedOutOfEmail?: boolean | null,
  hohAge?: number | null,
  homePhone?: string | null,
  contactId?: string | null,
  ilContactStatus?: string | null,
  labelSalutation?: string | null,
  lastName?: string | null,
  letterSalutation?: string | null,
  neighborhood?: string | null,
  city?: string | null,
  zip5?: string | null,
  zipcode?: string | null,
  state?: string | null,
  address?: string | null,
  maritalStatus?: string | null,
  mlActive?: boolean | null,
  cellPhone?: string | null,
  primaryContact?: string | null,
  primarySite?: string | null,
  latitude?: number | null,
  longitude?: number | null,
  qasValidationStatus?: string | null,
  contactType?: string | null,
  returnedMail?: boolean | null,
  ccContactStatus?: string | null,
  opportunitySite?: string | null,
  opportunityId?: string | null,
  loc?: string | null,
  ltsGrade?: number | null,
  ltsScore?: number | null,
  primaryMotivation?: string | null,
  communityName?: string | null,
  rating?: string | null,
  segmentation?: string | null,
  settledDate?: string | null,
  salesStage?: string | null,
  priorityDate?: string | null,
  reservationDate?: string | null,
  businessType?: string | null,
  salesOptionDate?: string | null,
  apartmentName?: string | null,
  optOut?: boolean | null,
  optOutDateTime?: string | null,
  mlContactInactiveReasons?: Array< string > | null,
  mlSOInactiveReasons?: Array< string > | null,
  mlInactiveReasons?: Array< string > | null,
  priorityType?: string | null,
  nextStep?: string | null,
  salesCounselor?: string | null,
  salesCounselorName?: string | null,
  timeframe?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateHouselistNewInput = {
  id: string,
  accountID?: string | null,
  listName?: string | null,
  listNameId?: string | null,
  control?: string | null,
  homeValue?: string | null,
  homeValueBottom?: number | null,
  homeValueTop?: number | null,
  hohIncome?: string | null,
  hohIncomeBottom?: number | null,
  hohIncomeTop?: number | null,
  hohNetWorth?: string | null,
  hohNetWorthBottom?: number | null,
  hohNetWorthTop?: number | null,
  groupName?: string | null,
  birthDate?: string | null,
  deceasedDate?: string | null,
  distanceToSite?: number | null,
  doNotCall?: boolean | null,
  email?: string | null,
  emailBounceDate?: string | null,
  epm2Grade?: number | null,
  epm2Score?: number | null,
  epm2Tier?: string | null,
  firstName?: string | null,
  gender?: string | null,
  hasOptedOutOfEmail?: boolean | null,
  hohAge?: number | null,
  homePhone?: string | null,
  contactId?: string | null,
  ilContactStatus?: string | null,
  labelSalutation?: string | null,
  lastName?: string | null,
  letterSalutation?: string | null,
  neighborhood?: string | null,
  city?: string | null,
  zip5?: string | null,
  zipcode?: string | null,
  state?: string | null,
  address?: string | null,
  maritalStatus?: string | null,
  mlActive?: boolean | null,
  cellPhone?: string | null,
  primaryContact?: string | null,
  primarySite?: string | null,
  latitude?: number | null,
  longitude?: number | null,
  qasValidationStatus?: string | null,
  contactType?: string | null,
  returnedMail?: boolean | null,
  ccContactStatus?: string | null,
  opportunitySite?: string | null,
  opportunityId?: string | null,
  loc?: string | null,
  ltsGrade?: number | null,
  ltsScore?: number | null,
  primaryMotivation?: string | null,
  communityName?: string | null,
  rating?: string | null,
  segmentation?: string | null,
  settledDate?: string | null,
  salesStage?: string | null,
  priorityDate?: string | null,
  reservationDate?: string | null,
  businessType?: string | null,
  salesOptionDate?: string | null,
  apartmentName?: string | null,
  optOut?: boolean | null,
  optOutDateTime?: string | null,
  mlContactInactiveReasons?: Array< string > | null,
  mlSOInactiveReasons?: Array< string > | null,
  mlInactiveReasons?: Array< string > | null,
  priorityType?: string | null,
  nextStep?: string | null,
  salesCounselor?: string | null,
  salesCounselorName?: string | null,
  timeframe?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteHouselistNewInput = {
  id: string,
};

export type CreateAccountInput = {
  updateHash?: string | null,
  accountID: string,
  isDeleted: boolean,
  labelSaluation: string,
  homeValueBottom?: number | null,
  accountNameId: string,
  homeValueTop?: string | null,
  letterSaluation: string,
  numberOfParticipants: number,
  primaryContact: string,
  lastModifiedDate: string,
  otherInterestsMotivation?: string | null,
  createdDate: string,
  controlFlag: boolean,
  hobbiesInterest?: string | null,
  primarySite?: string | null,
  hohNetRange?: string | null,
  homeValueRange?: string | null,
  hohNetWorthTop?: number | null,
  hohIncomeRange?: string | null,
  hohIncomeBottom?: number | null,
  accountName: string,
  hohIncomeTop?: number | null,
  hohNetWorthBottom?: number | null,
  parentAccountID?: string | null,
  returnedMail: boolean,
  type: string,
  id?: string | null,
};

export type ModelAccountConditionInput = {
  updateHash?: ModelStringInput | null,
  accountID?: ModelIDInput | null,
  isDeleted?: ModelBooleanInput | null,
  labelSaluation?: ModelStringInput | null,
  homeValueBottom?: ModelFloatInput | null,
  accountNameId?: ModelStringInput | null,
  homeValueTop?: ModelStringInput | null,
  letterSaluation?: ModelStringInput | null,
  numberOfParticipants?: ModelIntInput | null,
  primaryContact?: ModelStringInput | null,
  lastModifiedDate?: ModelStringInput | null,
  otherInterestsMotivation?: ModelStringInput | null,
  createdDate?: ModelStringInput | null,
  controlFlag?: ModelBooleanInput | null,
  hobbiesInterest?: ModelStringInput | null,
  primarySite?: ModelStringInput | null,
  hohNetRange?: ModelStringInput | null,
  homeValueRange?: ModelStringInput | null,
  hohNetWorthTop?: ModelFloatInput | null,
  hohIncomeRange?: ModelStringInput | null,
  hohIncomeBottom?: ModelFloatInput | null,
  accountName?: ModelStringInput | null,
  hohIncomeTop?: ModelFloatInput | null,
  hohNetWorthBottom?: ModelFloatInput | null,
  parentAccountID?: ModelStringInput | null,
  returnedMail?: ModelBooleanInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelAccountConditionInput | null > | null,
  or?: Array< ModelAccountConditionInput | null > | null,
  not?: ModelAccountConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type Account = {
  __typename: "Account",
  updateHash?: string | null,
  accountID: string,
  isDeleted: boolean,
  labelSaluation: string,
  homeValueBottom?: number | null,
  accountNameId: string,
  homeValueTop?: string | null,
  letterSaluation: string,
  numberOfParticipants: number,
  primaryContact: string,
  lastModifiedDate: string,
  otherInterestsMotivation?: string | null,
  createdDate: string,
  controlFlag: boolean,
  hobbiesInterest?: string | null,
  primarySite?: string | null,
  hohNetRange?: string | null,
  homeValueRange?: string | null,
  hohNetWorthTop?: number | null,
  hohIncomeRange?: string | null,
  hohIncomeBottom?: number | null,
  accountName: string,
  hohIncomeTop?: number | null,
  hohNetWorthBottom?: number | null,
  parentAccountID?: string | null,
  returnedMail: boolean,
  type: string,
  id: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateAccountInput = {
  updateHash?: string | null,
  accountID?: string | null,
  isDeleted?: boolean | null,
  labelSaluation?: string | null,
  homeValueBottom?: number | null,
  accountNameId?: string | null,
  homeValueTop?: string | null,
  letterSaluation?: string | null,
  numberOfParticipants?: number | null,
  primaryContact?: string | null,
  lastModifiedDate?: string | null,
  otherInterestsMotivation?: string | null,
  createdDate?: string | null,
  controlFlag?: boolean | null,
  hobbiesInterest?: string | null,
  primarySite?: string | null,
  hohNetRange?: string | null,
  homeValueRange?: string | null,
  hohNetWorthTop?: number | null,
  hohIncomeRange?: string | null,
  hohIncomeBottom?: number | null,
  accountName?: string | null,
  hohIncomeTop?: number | null,
  hohNetWorthBottom?: number | null,
  parentAccountID?: string | null,
  returnedMail?: boolean | null,
  type?: string | null,
  id: string,
};

export type DeleteAccountInput = {
  id: string,
};

export type CreateContactInput = {
  doNotMail: boolean,
  deceasedDate?: string | null,
  birthDate?: string | null,
  lastName: string,
  status: string,
  emailBounceBack: boolean,
  isDeleted: boolean,
  labelSaluation: string,
  homeValueBottom?: number | null,
  letterSaluation: string,
  hohNetWorth?: string | null,
  contactID: string,
  hohAge?: number | null,
  primaryFlag: string,
  lastModifiedDate: string,
  mailingStreet: string,
  mailingState: string,
  preferredContactMethod?: string | null,
  epm2Score?: number | null,
  ilContactStatus: string,
  emailBounceBackDate?: string | null,
  fullName: string,
  primarySite?: string | null,
  homeValueRange?: string | null,
  maritalStatus?: string | null,
  mailingCountry: string,
  militaryService?: boolean | null,
  hohIncomeRange?: string | null,
  hohIncomeBottom?: number | null,
  hohIncomeTop?: number | null,
  qasLongitude?: string | null,
  hasOptedOutOfEmail: boolean,
  mailingCountryCode: string,
  returnedMail: boolean,
  mobilePhone?: string | null,
  accountID: string,
  qasMailingValidationStatus: string,
  email?: string | null,
  homeValueTop?: number | null,
  firstName: string,
  mailingCity: string,
  doNotCall: boolean,
  salutation?: string | null,
  mlActive?: boolean | null,
  homePhone?: string | null,
  placeOfBirth?: string | null,
  masterRecordID?: string | null,
  emailOptOutDate?: string | null,
  gender?: string | null,
  qasLatitude?: string | null,
  hohNetWorthTop?: number | null,
  mailingZipCode: string,
  mailingNeighborhood?: string | null,
  contactType: string,
  hohNetWorthBottom?: number | null,
  epm2Decile?: number | null,
  mailingStateCode: string,
  id?: string | null,
};

export type ModelContactConditionInput = {
  doNotMail?: ModelBooleanInput | null,
  deceasedDate?: ModelStringInput | null,
  birthDate?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  status?: ModelStringInput | null,
  emailBounceBack?: ModelBooleanInput | null,
  isDeleted?: ModelBooleanInput | null,
  labelSaluation?: ModelStringInput | null,
  homeValueBottom?: ModelFloatInput | null,
  letterSaluation?: ModelStringInput | null,
  hohNetWorth?: ModelStringInput | null,
  contactID?: ModelIDInput | null,
  hohAge?: ModelIntInput | null,
  primaryFlag?: ModelStringInput | null,
  lastModifiedDate?: ModelStringInput | null,
  mailingStreet?: ModelStringInput | null,
  mailingState?: ModelStringInput | null,
  preferredContactMethod?: ModelStringInput | null,
  epm2Score?: ModelFloatInput | null,
  ilContactStatus?: ModelStringInput | null,
  emailBounceBackDate?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  primarySite?: ModelStringInput | null,
  homeValueRange?: ModelStringInput | null,
  maritalStatus?: ModelStringInput | null,
  mailingCountry?: ModelStringInput | null,
  militaryService?: ModelBooleanInput | null,
  hohIncomeRange?: ModelStringInput | null,
  hohIncomeBottom?: ModelFloatInput | null,
  hohIncomeTop?: ModelFloatInput | null,
  qasLongitude?: ModelStringInput | null,
  hasOptedOutOfEmail?: ModelBooleanInput | null,
  mailingCountryCode?: ModelStringInput | null,
  returnedMail?: ModelBooleanInput | null,
  mobilePhone?: ModelStringInput | null,
  accountID?: ModelIDInput | null,
  qasMailingValidationStatus?: ModelStringInput | null,
  email?: ModelStringInput | null,
  homeValueTop?: ModelFloatInput | null,
  firstName?: ModelStringInput | null,
  mailingCity?: ModelStringInput | null,
  doNotCall?: ModelBooleanInput | null,
  salutation?: ModelStringInput | null,
  mlActive?: ModelBooleanInput | null,
  homePhone?: ModelStringInput | null,
  placeOfBirth?: ModelStringInput | null,
  masterRecordID?: ModelStringInput | null,
  emailOptOutDate?: ModelStringInput | null,
  gender?: ModelStringInput | null,
  qasLatitude?: ModelStringInput | null,
  hohNetWorthTop?: ModelFloatInput | null,
  mailingZipCode?: ModelStringInput | null,
  mailingNeighborhood?: ModelStringInput | null,
  contactType?: ModelStringInput | null,
  hohNetWorthBottom?: ModelFloatInput | null,
  epm2Decile?: ModelFloatInput | null,
  mailingStateCode?: ModelStringInput | null,
  and?: Array< ModelContactConditionInput | null > | null,
  or?: Array< ModelContactConditionInput | null > | null,
  not?: ModelContactConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type Contact = {
  __typename: "Contact",
  doNotMail: boolean,
  deceasedDate?: string | null,
  birthDate?: string | null,
  lastName: string,
  status: string,
  emailBounceBack: boolean,
  isDeleted: boolean,
  labelSaluation: string,
  homeValueBottom?: number | null,
  letterSaluation: string,
  hohNetWorth?: string | null,
  contactID: string,
  hohAge?: number | null,
  primaryFlag: string,
  lastModifiedDate: string,
  mailingStreet: string,
  mailingState: string,
  preferredContactMethod?: string | null,
  epm2Score?: number | null,
  ilContactStatus: string,
  emailBounceBackDate?: string | null,
  fullName: string,
  primarySite?: string | null,
  homeValueRange?: string | null,
  maritalStatus?: string | null,
  mailingCountry: string,
  militaryService?: boolean | null,
  hohIncomeRange?: string | null,
  hohIncomeBottom?: number | null,
  hohIncomeTop?: number | null,
  qasLongitude?: string | null,
  hasOptedOutOfEmail: boolean,
  mailingCountryCode: string,
  returnedMail: boolean,
  mobilePhone?: string | null,
  accountID: string,
  qasMailingValidationStatus: string,
  email?: string | null,
  homeValueTop?: number | null,
  firstName: string,
  mailingCity: string,
  doNotCall: boolean,
  salutation?: string | null,
  mlActive?: boolean | null,
  homePhone?: string | null,
  placeOfBirth?: string | null,
  masterRecordID?: string | null,
  emailOptOutDate?: string | null,
  gender?: string | null,
  qasLatitude?: string | null,
  hohNetWorthTop?: number | null,
  mailingZipCode: string,
  mailingNeighborhood?: string | null,
  contactType: string,
  hohNetWorthBottom?: number | null,
  epm2Decile?: number | null,
  mailingStateCode: string,
  id: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateContactInput = {
  doNotMail?: boolean | null,
  deceasedDate?: string | null,
  birthDate?: string | null,
  lastName?: string | null,
  status?: string | null,
  emailBounceBack?: boolean | null,
  isDeleted?: boolean | null,
  labelSaluation?: string | null,
  homeValueBottom?: number | null,
  letterSaluation?: string | null,
  hohNetWorth?: string | null,
  contactID?: string | null,
  hohAge?: number | null,
  primaryFlag?: string | null,
  lastModifiedDate?: string | null,
  mailingStreet?: string | null,
  mailingState?: string | null,
  preferredContactMethod?: string | null,
  epm2Score?: number | null,
  ilContactStatus?: string | null,
  emailBounceBackDate?: string | null,
  fullName?: string | null,
  primarySite?: string | null,
  homeValueRange?: string | null,
  maritalStatus?: string | null,
  mailingCountry?: string | null,
  militaryService?: boolean | null,
  hohIncomeRange?: string | null,
  hohIncomeBottom?: number | null,
  hohIncomeTop?: number | null,
  qasLongitude?: string | null,
  hasOptedOutOfEmail?: boolean | null,
  mailingCountryCode?: string | null,
  returnedMail?: boolean | null,
  mobilePhone?: string | null,
  accountID?: string | null,
  qasMailingValidationStatus?: string | null,
  email?: string | null,
  homeValueTop?: number | null,
  firstName?: string | null,
  mailingCity?: string | null,
  doNotCall?: boolean | null,
  salutation?: string | null,
  mlActive?: boolean | null,
  homePhone?: string | null,
  placeOfBirth?: string | null,
  masterRecordID?: string | null,
  emailOptOutDate?: string | null,
  gender?: string | null,
  qasLatitude?: string | null,
  hohNetWorthTop?: number | null,
  mailingZipCode?: string | null,
  mailingNeighborhood?: string | null,
  contactType?: string | null,
  hohNetWorthBottom?: number | null,
  epm2Decile?: number | null,
  mailingStateCode?: string | null,
  id: string,
};

export type DeleteContactInput = {
  id: string,
};

export type CreateSalesOptionInput = {
  lossReason?: string | null,
  createdDate: string,
  accountID: string,
  apartment?: string | null,
  apartmentName?: string | null,
  rating?: string | null,
  community: string,
  settledDate?: string | null,
  requestedMailOfBrochure: boolean,
  isDeleted: boolean,
  sourceID: string,
  reservationDate?: string | null,
  reservedMSP?: string | null,
  salesOptionName: string,
  priorityDepCommunity?: string | null,
  ltsScore?: number | null,
  ltsGrade?: number | null,
  lastModifiedDate: string,
  campaignID?: string | null,
  priorityDate?: string | null,
  segmentation?: string | null,
  levelOfCare: string,
  mergeFlag: boolean,
  id?: string | null,
};

export type ModelSalesOptionConditionInput = {
  lossReason?: ModelStringInput | null,
  createdDate?: ModelStringInput | null,
  accountID?: ModelIDInput | null,
  apartment?: ModelStringInput | null,
  apartmentName?: ModelStringInput | null,
  rating?: ModelStringInput | null,
  community?: ModelStringInput | null,
  settledDate?: ModelStringInput | null,
  requestedMailOfBrochure?: ModelBooleanInput | null,
  isDeleted?: ModelBooleanInput | null,
  sourceID?: ModelStringInput | null,
  reservationDate?: ModelStringInput | null,
  reservedMSP?: ModelStringInput | null,
  salesOptionName?: ModelStringInput | null,
  priorityDepCommunity?: ModelStringInput | null,
  ltsScore?: ModelFloatInput | null,
  ltsGrade?: ModelFloatInput | null,
  lastModifiedDate?: ModelStringInput | null,
  campaignID?: ModelStringInput | null,
  priorityDate?: ModelStringInput | null,
  segmentation?: ModelStringInput | null,
  levelOfCare?: ModelStringInput | null,
  mergeFlag?: ModelBooleanInput | null,
  and?: Array< ModelSalesOptionConditionInput | null > | null,
  or?: Array< ModelSalesOptionConditionInput | null > | null,
  not?: ModelSalesOptionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type SalesOption = {
  __typename: "SalesOption",
  lossReason?: string | null,
  createdDate: string,
  accountID: string,
  apartment?: string | null,
  apartmentName?: string | null,
  rating?: string | null,
  community: string,
  settledDate?: string | null,
  requestedMailOfBrochure: boolean,
  isDeleted: boolean,
  sourceID: string,
  reservationDate?: string | null,
  reservedMSP?: string | null,
  salesOptionName: string,
  priorityDepCommunity?: string | null,
  ltsScore?: number | null,
  ltsGrade?: number | null,
  lastModifiedDate: string,
  campaignID?: string | null,
  priorityDate?: string | null,
  segmentation?: string | null,
  levelOfCare: string,
  mergeFlag: boolean,
  id: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateSalesOptionInput = {
  lossReason?: string | null,
  createdDate?: string | null,
  accountID?: string | null,
  apartment?: string | null,
  apartmentName?: string | null,
  rating?: string | null,
  community?: string | null,
  settledDate?: string | null,
  requestedMailOfBrochure?: boolean | null,
  isDeleted?: boolean | null,
  sourceID?: string | null,
  reservationDate?: string | null,
  reservedMSP?: string | null,
  salesOptionName?: string | null,
  priorityDepCommunity?: string | null,
  ltsScore?: number | null,
  ltsGrade?: number | null,
  lastModifiedDate?: string | null,
  campaignID?: string | null,
  priorityDate?: string | null,
  segmentation?: string | null,
  levelOfCare?: string | null,
  mergeFlag?: boolean | null,
  id: string,
};

export type DeleteSalesOptionInput = {
  id: string,
};

export type CreateStaffSeedInput = {
  id?: string | null,
  address?: string | null,
  city?: string | null,
  community?: string | null,
  createdby?: string | null,
  email?: string | null,
  firstName?: string | null,
  labelSalutation?: string | null,
  lastModifiedBy?: string | null,
  lastName?: string | null,
  letterSalutation?: string | null,
  loc?: string | null,
  owner?: string | null,
  postalCode?: string | null,
  seedDataName?: string | null,
  state?: string | null,
};

export type ModelStaffSeedConditionInput = {
  id?: ModelStringInput | null,
  address?: ModelStringInput | null,
  city?: ModelStringInput | null,
  community?: ModelStringInput | null,
  createdby?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  labelSalutation?: ModelStringInput | null,
  lastModifiedBy?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  letterSalutation?: ModelStringInput | null,
  loc?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  postalCode?: ModelStringInput | null,
  seedDataName?: ModelStringInput | null,
  state?: ModelStringInput | null,
  and?: Array< ModelStaffSeedConditionInput | null > | null,
  or?: Array< ModelStaffSeedConditionInput | null > | null,
  not?: ModelStaffSeedConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type StaffSeed = {
  __typename: "StaffSeed",
  id?: string | null,
  address?: string | null,
  city?: string | null,
  community?: string | null,
  createdby?: string | null,
  email?: string | null,
  firstName?: string | null,
  labelSalutation?: string | null,
  lastModifiedBy?: string | null,
  lastName?: string | null,
  letterSalutation?: string | null,
  loc?: string | null,
  owner?: string | null,
  postalCode?: string | null,
  seedDataName?: string | null,
  state?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateStaffSeedInput = {
  id: string,
  address?: string | null,
  city?: string | null,
  community?: string | null,
  createdby?: string | null,
  email?: string | null,
  firstName?: string | null,
  labelSalutation?: string | null,
  lastModifiedBy?: string | null,
  lastName?: string | null,
  letterSalutation?: string | null,
  loc?: string | null,
  owner?: string | null,
  postalCode?: string | null,
  seedDataName?: string | null,
  state?: string | null,
};

export type DeleteStaffSeedInput = {
  id: string,
};

export type CreateDistanceToSiteInput = {
  distanceToSiteId?: string | null,
  distance?: number | null,
  site?: string | null,
  communityId?: string | null,
  createdDate?: string | null,
  isDeleted?: string | null,
  lastModifiedDate?: string | null,
  contactId?: string | null,
  name?: string | null,
  id?: string | null,
};

export type ModelDistanceToSiteConditionInput = {
  distanceToSiteId?: ModelStringInput | null,
  distance?: ModelFloatInput | null,
  site?: ModelStringInput | null,
  communityId?: ModelStringInput | null,
  createdDate?: ModelStringInput | null,
  isDeleted?: ModelStringInput | null,
  lastModifiedDate?: ModelStringInput | null,
  contactId?: ModelStringInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelDistanceToSiteConditionInput | null > | null,
  or?: Array< ModelDistanceToSiteConditionInput | null > | null,
  not?: ModelDistanceToSiteConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type DistanceToSite = {
  __typename: "DistanceToSite",
  distanceToSiteId?: string | null,
  distance?: number | null,
  site?: string | null,
  communityId?: string | null,
  createdDate?: string | null,
  isDeleted?: string | null,
  lastModifiedDate?: string | null,
  contactId?: string | null,
  name?: string | null,
  id: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateDistanceToSiteInput = {
  distanceToSiteId?: string | null,
  distance?: number | null,
  site?: string | null,
  communityId?: string | null,
  createdDate?: string | null,
  isDeleted?: string | null,
  lastModifiedDate?: string | null,
  contactId?: string | null,
  name?: string | null,
  id: string,
};

export type DeleteDistanceToSiteInput = {
  id: string,
};

export type CreateFilterValueInput = {
  listType: string,
  fieldId: string,
  version: string,
  selectedValues: Array< string >,
  relationalOperator?: string | null,
  description?: string | null,
  changeReason?: string | null,
  changedBy: string,
  id?: string | null,
};

export type ModelFilterValueConditionInput = {
  listType?: ModelIDInput | null,
  fieldId?: ModelIDInput | null,
  version?: ModelIDInput | null,
  selectedValues?: ModelStringInput | null,
  relationalOperator?: ModelStringInput | null,
  description?: ModelStringInput | null,
  changeReason?: ModelStringInput | null,
  changedBy?: ModelStringInput | null,
  and?: Array< ModelFilterValueConditionInput | null > | null,
  or?: Array< ModelFilterValueConditionInput | null > | null,
  not?: ModelFilterValueConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type FilterValue = {
  __typename: "FilterValue",
  listType: string,
  fieldId: string,
  version: string,
  selectedValues: Array< string >,
  relationalOperator?: string | null,
  description?: string | null,
  changeReason?: string | null,
  changedBy: string,
  id: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateFilterValueInput = {
  listType?: string | null,
  fieldId?: string | null,
  version?: string | null,
  selectedValues?: Array< string > | null,
  relationalOperator?: string | null,
  description?: string | null,
  changeReason?: string | null,
  changedBy?: string | null,
  id: string,
};

export type DeleteFilterValueInput = {
  id: string,
};

export type CreateFlagDefinitionInput = {
  id?: string | null,
  listType: string,
  fieldName: string,
  flagValue: string,
  friendlyName: string,
  description?: string | null,
};

export type ModelFlagDefinitionConditionInput = {
  listType?: ModelStringInput | null,
  fieldName?: ModelStringInput | null,
  flagValue?: ModelStringInput | null,
  friendlyName?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelFlagDefinitionConditionInput | null > | null,
  or?: Array< ModelFlagDefinitionConditionInput | null > | null,
  not?: ModelFlagDefinitionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type FlagDefinition = {
  __typename: "FlagDefinition",
  id: string,
  listType: string,
  fieldName: string,
  flagValue: string,
  friendlyName: string,
  description?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateFlagDefinitionInput = {
  id: string,
  listType?: string | null,
  fieldName?: string | null,
  flagValue?: string | null,
  friendlyName?: string | null,
  description?: string | null,
};

export type DeleteFlagDefinitionInput = {
  id: string,
};

export type CreateDataTransferStageInput = {
  id?: string | null,
  traceId: string,
  fileKey?: string | null,
  totalInputRecords?: number | null,
  indexStart?: number | null,
  indexEnd?: number | null,
  addedCount?: number | null,
  updatedCount?: number | null,
  failedCount?: number | null,
  failureReason?: string | null,
  source?: string | null,
  expirationUnixTime?: number | null,
};

export type ModelDataTransferStageConditionInput = {
  traceId?: ModelStringInput | null,
  fileKey?: ModelStringInput | null,
  totalInputRecords?: ModelIntInput | null,
  indexStart?: ModelIntInput | null,
  indexEnd?: ModelIntInput | null,
  addedCount?: ModelIntInput | null,
  updatedCount?: ModelIntInput | null,
  failedCount?: ModelIntInput | null,
  failureReason?: ModelStringInput | null,
  source?: ModelStringInput | null,
  expirationUnixTime?: ModelIntInput | null,
  and?: Array< ModelDataTransferStageConditionInput | null > | null,
  or?: Array< ModelDataTransferStageConditionInput | null > | null,
  not?: ModelDataTransferStageConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type DataTransferStage = {
  __typename: "DataTransferStage",
  id: string,
  traceId: string,
  fileKey?: string | null,
  totalInputRecords?: number | null,
  indexStart?: number | null,
  indexEnd?: number | null,
  addedCount?: number | null,
  updatedCount?: number | null,
  failedCount?: number | null,
  failureReason?: string | null,
  source?: string | null,
  expirationUnixTime?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateDataTransferStageInput = {
  id: string,
  traceId?: string | null,
  fileKey?: string | null,
  totalInputRecords?: number | null,
  indexStart?: number | null,
  indexEnd?: number | null,
  addedCount?: number | null,
  updatedCount?: number | null,
  failedCount?: number | null,
  failureReason?: string | null,
  source?: string | null,
  expirationUnixTime?: number | null,
};

export type DeleteDataTransferStageInput = {
  id: string,
};

export type CreateExclusionRuleInput = {
  id?: string | null,
  listType: string,
  fieldName: string,
  excludedValues: Array< string >,
  operator: string,
};

export type ModelExclusionRuleConditionInput = {
  listType?: ModelStringInput | null,
  fieldName?: ModelStringInput | null,
  excludedValues?: ModelStringInput | null,
  operator?: ModelStringInput | null,
  and?: Array< ModelExclusionRuleConditionInput | null > | null,
  or?: Array< ModelExclusionRuleConditionInput | null > | null,
  not?: ModelExclusionRuleConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ExclusionRule = {
  __typename: "ExclusionRule",
  id: string,
  listType: string,
  fieldName: string,
  excludedValues: Array< string >,
  operator: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateExclusionRuleInput = {
  id: string,
  listType?: string | null,
  fieldName?: string | null,
  excludedValues?: Array< string > | null,
  operator?: string | null,
};

export type DeleteExclusionRuleInput = {
  id: string,
};

export type AggregatedResult = {
  __typename: "AggregatedResult",
  items?:  Array<AggregationBucket | null > | null,
  nextToken?: string | null,
};

export type AggregationBucket = {
  __typename: "AggregationBucket",
  key?: string | null,
  doc_count?: number | null,
};

export type ModelBLConcurrencyLockFilterInput = {
  community?: ModelIDInput | null,
  lockToken?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  expirationUnixTime?: ModelIntInput | null,
  id?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBLConcurrencyLockFilterInput | null > | null,
  or?: Array< ModelBLConcurrencyLockFilterInput | null > | null,
  not?: ModelBLConcurrencyLockFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelBLConcurrencyLockConnection = {
  __typename: "ModelBLConcurrencyLockConnection",
  items:  Array<BLConcurrencyLock | null >,
  nextToken?: string | null,
};

export type ModelBoughtListFilterInput = {
  id?: ModelIDInput | null,
  saluation?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  gender?: ModelStringInput | null,
  age?: ModelIntInput | null,
  address?: ModelStringInput | null,
  city?: ModelStringInput | null,
  state?: ModelStringInput | null,
  zipcode?: ModelStringInput | null,
  county?: ModelStringInput | null,
  householdIncome?: ModelStringInput | null,
  householdIncomeBottom?: ModelFloatInput | null,
  householdIncomeTop?: ModelFloatInput | null,
  homeValue?: ModelStringInput | null,
  homeValueBottom?: ModelFloatInput | null,
  homeValueTop?: ModelFloatInput | null,
  boatingSailing?: ModelStringInput | null,
  tennis?: ModelStringInput | null,
  golf?: ModelStringInput | null,
  boatOwner?: ModelStringInput | null,
  upscaleLiving?: ModelStringInput | null,
  suppress?: ModelStringInput | null,
  doNotMail?: ModelStringInput | null,
  dropDate?: ModelStringInput | null,
  zip5?: ModelStringInput | null,
  batchCode?: ModelStringInput | null,
  listDate?: ModelStringInput | null,
  listName?: ModelStringInput | null,
  listNameId?: ModelStringInput | null,
  qseq?: ModelIntInput | null,
  expirationDate?: ModelStringInput | null,
  lastUpdated?: ModelStringInput | null,
  site1?: ModelStringInput | null,
  siteDistance1?: ModelFloatInput | null,
  epm3Decile1?: ModelIntInput | null,
  epm3Score1?: ModelFloatInput | null,
  epm3Tier1?: ModelStringInput | null,
  site2?: ModelStringInput | null,
  siteDistance2?: ModelStringInput | null,
  epm3Decile2?: ModelIntInput | null,
  epm3Score2?: ModelFloatInput | null,
  epm3Tier2?: ModelStringInput | null,
  blSelect?: ModelStringInput | null,
  hlMatch?: ModelStringInput | null,
  randomNumber?: ModelFloatInput | null,
  randomFlag?: ModelIntInput | null,
  netNewFlag?: ModelIntInput | null,
  staticControlFlag?: ModelStringInput | null,
  hlGrpRowList?: ModelStringInput | null,
  hlODateList?: ModelStringInput | null,
  optOut?: ModelBooleanInput | null,
  optOutDateTime?: ModelStringInput | null,
  optOutUpdatedBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  expirationUnixTime?: ModelIntInput | null,
  and?: Array< ModelBoughtListFilterInput | null > | null,
  or?: Array< ModelBoughtListFilterInput | null > | null,
  not?: ModelBoughtListFilterInput | null,
};

export type ModelBoughtListConnection = {
  __typename: "ModelBoughtListConnection",
  items:  Array<BoughtList | null >,
  nextToken?: string | null,
};

export type SearchableBoughtListFilterInput = {
  id?: SearchableIDFilterInput | null,
  saluation?: SearchableStringFilterInput | null,
  firstName?: SearchableStringFilterInput | null,
  lastName?: SearchableStringFilterInput | null,
  gender?: SearchableStringFilterInput | null,
  age?: SearchableIntFilterInput | null,
  address?: SearchableStringFilterInput | null,
  city?: SearchableStringFilterInput | null,
  state?: SearchableStringFilterInput | null,
  zipcode?: SearchableStringFilterInput | null,
  county?: SearchableStringFilterInput | null,
  householdIncome?: SearchableStringFilterInput | null,
  householdIncomeBottom?: SearchableFloatFilterInput | null,
  householdIncomeTop?: SearchableFloatFilterInput | null,
  homeValue?: SearchableStringFilterInput | null,
  homeValueBottom?: SearchableFloatFilterInput | null,
  homeValueTop?: SearchableFloatFilterInput | null,
  boatingSailing?: SearchableStringFilterInput | null,
  tennis?: SearchableStringFilterInput | null,
  golf?: SearchableStringFilterInput | null,
  boatOwner?: SearchableStringFilterInput | null,
  upscaleLiving?: SearchableStringFilterInput | null,
  suppress?: SearchableStringFilterInput | null,
  doNotMail?: SearchableStringFilterInput | null,
  dropDate?: SearchableStringFilterInput | null,
  zip5?: SearchableStringFilterInput | null,
  batchCode?: SearchableStringFilterInput | null,
  listDate?: SearchableStringFilterInput | null,
  listName?: SearchableStringFilterInput | null,
  listNameId?: SearchableStringFilterInput | null,
  qseq?: SearchableIntFilterInput | null,
  expirationDate?: SearchableStringFilterInput | null,
  lastUpdated?: SearchableStringFilterInput | null,
  site1?: SearchableStringFilterInput | null,
  siteDistance1?: SearchableFloatFilterInput | null,
  epm3Decile1?: SearchableIntFilterInput | null,
  epm3Score1?: SearchableFloatFilterInput | null,
  epm3Tier1?: SearchableStringFilterInput | null,
  site2?: SearchableStringFilterInput | null,
  siteDistance2?: SearchableStringFilterInput | null,
  epm3Decile2?: SearchableIntFilterInput | null,
  epm3Score2?: SearchableFloatFilterInput | null,
  epm3Tier2?: SearchableStringFilterInput | null,
  blSelect?: SearchableStringFilterInput | null,
  hlMatch?: SearchableStringFilterInput | null,
  randomNumber?: SearchableFloatFilterInput | null,
  randomFlag?: SearchableIntFilterInput | null,
  netNewFlag?: SearchableIntFilterInput | null,
  staticControlFlag?: SearchableStringFilterInput | null,
  hlGrpRowList?: SearchableStringFilterInput | null,
  hlODateList?: SearchableStringFilterInput | null,
  optOut?: SearchableBooleanFilterInput | null,
  optOutDateTime?: SearchableStringFilterInput | null,
  optOutUpdatedBy?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  expirationUnixTime?: SearchableIntFilterInput | null,
  and?: Array< SearchableBoughtListFilterInput | null > | null,
  or?: Array< SearchableBoughtListFilterInput | null > | null,
  not?: SearchableBoughtListFilterInput | null,
};

export type SearchableIDFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableStringFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableIntFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableFloatFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableBooleanFilterInput = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type SearchableBoughtListSortInput = {
  field?: SearchableBoughtListSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableBoughtListSortableFields {
  id = "id",
  saluation = "saluation",
  firstName = "firstName",
  lastName = "lastName",
  gender = "gender",
  age = "age",
  address = "address",
  city = "city",
  state = "state",
  zipcode = "zipcode",
  county = "county",
  householdIncome = "householdIncome",
  householdIncomeBottom = "householdIncomeBottom",
  householdIncomeTop = "householdIncomeTop",
  homeValue = "homeValue",
  homeValueBottom = "homeValueBottom",
  homeValueTop = "homeValueTop",
  boatingSailing = "boatingSailing",
  tennis = "tennis",
  golf = "golf",
  boatOwner = "boatOwner",
  upscaleLiving = "upscaleLiving",
  suppress = "suppress",
  doNotMail = "doNotMail",
  dropDate = "dropDate",
  zip5 = "zip5",
  batchCode = "batchCode",
  listDate = "listDate",
  listName = "listName",
  listNameId = "listNameId",
  qseq = "qseq",
  expirationDate = "expirationDate",
  lastUpdated = "lastUpdated",
  site1 = "site1",
  siteDistance1 = "siteDistance1",
  epm3Decile1 = "epm3Decile1",
  epm3Score1 = "epm3Score1",
  epm3Tier1 = "epm3Tier1",
  site2 = "site2",
  siteDistance2 = "siteDistance2",
  epm3Decile2 = "epm3Decile2",
  epm3Score2 = "epm3Score2",
  epm3Tier2 = "epm3Tier2",
  blSelect = "blSelect",
  hlMatch = "hlMatch",
  randomNumber = "randomNumber",
  randomFlag = "randomFlag",
  netNewFlag = "netNewFlag",
  staticControlFlag = "staticControlFlag",
  hlGrpRowList = "hlGrpRowList",
  hlODateList = "hlODateList",
  optOut = "optOut",
  optOutDateTime = "optOutDateTime",
  optOutUpdatedBy = "optOutUpdatedBy",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  expirationUnixTime = "expirationUnixTime",
}


export enum SearchableSortDirection {
  asc = "asc",
  desc = "desc",
}


export type SearchableBoughtListAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableBoughtListAggregateField,
};

export enum SearchableAggregateType {
  terms = "terms",
  avg = "avg",
  min = "min",
  max = "max",
  sum = "sum",
  cardinality = "cardinality",
}


export enum SearchableBoughtListAggregateField {
  id = "id",
  saluation = "saluation",
  firstName = "firstName",
  lastName = "lastName",
  gender = "gender",
  age = "age",
  address = "address",
  city = "city",
  state = "state",
  zipcode = "zipcode",
  county = "county",
  householdIncome = "householdIncome",
  householdIncomeBottom = "householdIncomeBottom",
  householdIncomeTop = "householdIncomeTop",
  homeValue = "homeValue",
  homeValueBottom = "homeValueBottom",
  homeValueTop = "homeValueTop",
  boatingSailing = "boatingSailing",
  tennis = "tennis",
  golf = "golf",
  boatOwner = "boatOwner",
  upscaleLiving = "upscaleLiving",
  suppress = "suppress",
  doNotMail = "doNotMail",
  dropDate = "dropDate",
  zip5 = "zip5",
  batchCode = "batchCode",
  listDate = "listDate",
  listName = "listName",
  listNameId = "listNameId",
  qseq = "qseq",
  expirationDate = "expirationDate",
  lastUpdated = "lastUpdated",
  site1 = "site1",
  siteDistance1 = "siteDistance1",
  epm3Decile1 = "epm3Decile1",
  epm3Score1 = "epm3Score1",
  epm3Tier1 = "epm3Tier1",
  site2 = "site2",
  siteDistance2 = "siteDistance2",
  epm3Decile2 = "epm3Decile2",
  epm3Score2 = "epm3Score2",
  epm3Tier2 = "epm3Tier2",
  blSelect = "blSelect",
  hlMatch = "hlMatch",
  randomNumber = "randomNumber",
  randomFlag = "randomFlag",
  netNewFlag = "netNewFlag",
  staticControlFlag = "staticControlFlag",
  hlGrpRowList = "hlGrpRowList",
  hlODateList = "hlODateList",
  optOut = "optOut",
  optOutDateTime = "optOutDateTime",
  optOutUpdatedBy = "optOutUpdatedBy",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  expirationUnixTime = "expirationUnixTime",
}


export type SearchableBoughtListConnection = {
  __typename: "SearchableBoughtListConnection",
  items:  Array<BoughtList | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type SearchableAggregateResult = {
  __typename: "SearchableAggregateResult",
  name: string,
  result?: SearchableAggregateGenericResult | null,
};

export type SearchableAggregateGenericResult = SearchableAggregateScalarResult | SearchableAggregateBucketResult


export type SearchableAggregateScalarResult = {
  __typename: "SearchableAggregateScalarResult",
  value: number,
};

export type SearchableAggregateBucketResult = {
  __typename: "SearchableAggregateBucketResult",
  buckets?:  Array<SearchableAggregateBucketResultItem | null > | null,
};

export type SearchableAggregateBucketResultItem = {
  __typename: "SearchableAggregateBucketResultItem",
  key: string,
  doc_count: number,
};

export type ModelUserFilterFilterInput = {
  id?: ModelIDInput | null,
  listType?: ModelStringInput | null,
  name?: ModelStringInput | null,
  filterDefinitions?: ModelStringInput | null,
  filterSelections?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterFilterInput | null > | null,
  or?: Array< ModelUserFilterFilterInput | null > | null,
  not?: ModelUserFilterFilterInput | null,
  owner?: ModelStringInput | null,
};

export type ModelUserFilterConnection = {
  __typename: "ModelUserFilterConnection",
  items:  Array<UserFilter | null >,
  nextToken?: string | null,
};

export type SearchableUserFilterFilterInput = {
  id?: SearchableIDFilterInput | null,
  listType?: SearchableStringFilterInput | null,
  name?: SearchableStringFilterInput | null,
  filterDefinitions?: SearchableStringFilterInput | null,
  filterSelections?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableUserFilterFilterInput | null > | null,
  or?: Array< SearchableUserFilterFilterInput | null > | null,
  not?: SearchableUserFilterFilterInput | null,
};

export type SearchableUserFilterSortInput = {
  field?: SearchableUserFilterSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableUserFilterSortableFields {
  id = "id",
  listType = "listType",
  name = "name",
  filterDefinitions = "filterDefinitions",
  filterSelections = "filterSelections",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserFilterAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableUserFilterAggregateField,
};

export enum SearchableUserFilterAggregateField {
  id = "id",
  listType = "listType",
  name = "name",
  filterDefinitions = "filterDefinitions",
  filterSelections = "filterSelections",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserFilterConnection = {
  __typename: "SearchableUserFilterConnection",
  items:  Array<UserFilter | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelExportJobFilterInput = {
  id?: ModelIDInput | null,
  exportName?: ModelStringInput | null,
  listType?: ModelStringInput | null,
  reportId?: ModelStringInput | null,
  status?: ModelStringInput | null,
  statusMessage?: ModelStringInput | null,
  filterInput?: ModelStringInput | null,
  filterFields?: ModelStringInput | null,
  outputFormat?: ModelStringInput | null,
  s3Key?: ModelStringInput | null,
  totalRecords?: ModelIntInput | null,
  fileSize?: ModelFloatInput | null,
  startedAt?: ModelStringInput | null,
  expiresAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  authorizedReaders?: ModelStringInput | null,
  debugInfo?: ModelStringInput | null,
  and?: Array< ModelExportJobFilterInput | null > | null,
  or?: Array< ModelExportJobFilterInput | null > | null,
  not?: ModelExportJobFilterInput | null,
};

export type ModelExportJobConnection = {
  __typename: "ModelExportJobConnection",
  items:  Array<ExportJob | null >,
  nextToken?: string | null,
};

export type SearchableExportJobFilterInput = {
  id?: SearchableIDFilterInput | null,
  exportName?: SearchableStringFilterInput | null,
  listType?: SearchableStringFilterInput | null,
  reportId?: SearchableStringFilterInput | null,
  status?: SearchableStringFilterInput | null,
  statusMessage?: SearchableStringFilterInput | null,
  filterInput?: SearchableStringFilterInput | null,
  filterFields?: SearchableStringFilterInput | null,
  outputFormat?: SearchableStringFilterInput | null,
  s3Key?: SearchableStringFilterInput | null,
  totalRecords?: SearchableIntFilterInput | null,
  fileSize?: SearchableFloatFilterInput | null,
  startedAt?: SearchableStringFilterInput | null,
  expiresAt?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  owner?: SearchableStringFilterInput | null,
  authorizedReaders?: SearchableStringFilterInput | null,
  debugInfo?: SearchableStringFilterInput | null,
  and?: Array< SearchableExportJobFilterInput | null > | null,
  or?: Array< SearchableExportJobFilterInput | null > | null,
  not?: SearchableExportJobFilterInput | null,
};

export type SearchableExportJobSortInput = {
  field?: SearchableExportJobSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableExportJobSortableFields {
  id = "id",
  exportName = "exportName",
  listType = "listType",
  reportId = "reportId",
  status = "status",
  statusMessage = "statusMessage",
  filterInput = "filterInput",
  filterFields = "filterFields",
  outputFormat = "outputFormat",
  s3Key = "s3Key",
  totalRecords = "totalRecords",
  fileSize = "fileSize",
  startedAt = "startedAt",
  expiresAt = "expiresAt",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  owner = "owner",
  authorizedReaders = "authorizedReaders",
  debugInfo = "debugInfo",
}


export type SearchableExportJobAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableExportJobAggregateField,
};

export enum SearchableExportJobAggregateField {
  id = "id",
  exportName = "exportName",
  listType = "listType",
  reportId = "reportId",
  status = "status",
  statusMessage = "statusMessage",
  filterInput = "filterInput",
  filterFields = "filterFields",
  outputFormat = "outputFormat",
  s3Key = "s3Key",
  totalRecords = "totalRecords",
  fileSize = "fileSize",
  startedAt = "startedAt",
  expiresAt = "expiresAt",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  owner = "owner",
  authorizedReaders = "authorizedReaders",
  debugInfo = "debugInfo",
}


export type SearchableExportJobConnection = {
  __typename: "SearchableExportJobConnection",
  items:  Array<ExportJob | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelReportRunScheduleFilterInput = {
  id?: ModelIDInput | null,
  reportId?: ModelStringInput | null,
  scheduleExpression?: ModelStringInput | null,
  enabled?: ModelBooleanInput | null,
  subscribers?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReportRunScheduleFilterInput | null > | null,
  or?: Array< ModelReportRunScheduleFilterInput | null > | null,
  not?: ModelReportRunScheduleFilterInput | null,
};

export type ModelReportRunScheduleConnection = {
  __typename: "ModelReportRunScheduleConnection",
  items:  Array<ReportRunSchedule | null >,
  nextToken?: string | null,
};

export type ModelHouselistNewFilterInput = {
  id?: ModelIDInput | null,
  accountID?: ModelStringInput | null,
  listName?: ModelStringInput | null,
  listNameId?: ModelStringInput | null,
  control?: ModelStringInput | null,
  homeValue?: ModelStringInput | null,
  homeValueBottom?: ModelFloatInput | null,
  homeValueTop?: ModelFloatInput | null,
  hohIncome?: ModelStringInput | null,
  hohIncomeBottom?: ModelFloatInput | null,
  hohIncomeTop?: ModelFloatInput | null,
  hohNetWorth?: ModelStringInput | null,
  hohNetWorthBottom?: ModelFloatInput | null,
  hohNetWorthTop?: ModelFloatInput | null,
  groupName?: ModelStringInput | null,
  birthDate?: ModelStringInput | null,
  deceasedDate?: ModelStringInput | null,
  distanceToSite?: ModelFloatInput | null,
  doNotCall?: ModelBooleanInput | null,
  email?: ModelStringInput | null,
  emailBounceDate?: ModelStringInput | null,
  epm2Grade?: ModelIntInput | null,
  epm2Score?: ModelFloatInput | null,
  epm2Tier?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  gender?: ModelStringInput | null,
  hasOptedOutOfEmail?: ModelBooleanInput | null,
  hohAge?: ModelIntInput | null,
  homePhone?: ModelStringInput | null,
  contactId?: ModelStringInput | null,
  ilContactStatus?: ModelStringInput | null,
  labelSalutation?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  letterSalutation?: ModelStringInput | null,
  neighborhood?: ModelStringInput | null,
  city?: ModelStringInput | null,
  zip5?: ModelStringInput | null,
  zipcode?: ModelStringInput | null,
  state?: ModelStringInput | null,
  address?: ModelStringInput | null,
  maritalStatus?: ModelStringInput | null,
  mlActive?: ModelBooleanInput | null,
  cellPhone?: ModelStringInput | null,
  primaryContact?: ModelStringInput | null,
  primarySite?: ModelStringInput | null,
  latitude?: ModelFloatInput | null,
  longitude?: ModelFloatInput | null,
  qasValidationStatus?: ModelStringInput | null,
  contactType?: ModelStringInput | null,
  returnedMail?: ModelBooleanInput | null,
  ccContactStatus?: ModelStringInput | null,
  opportunitySite?: ModelStringInput | null,
  opportunityId?: ModelStringInput | null,
  loc?: ModelStringInput | null,
  ltsGrade?: ModelIntInput | null,
  ltsScore?: ModelFloatInput | null,
  primaryMotivation?: ModelStringInput | null,
  communityName?: ModelStringInput | null,
  rating?: ModelStringInput | null,
  segmentation?: ModelStringInput | null,
  settledDate?: ModelStringInput | null,
  salesStage?: ModelStringInput | null,
  priorityDate?: ModelStringInput | null,
  reservationDate?: ModelStringInput | null,
  businessType?: ModelStringInput | null,
  salesOptionDate?: ModelStringInput | null,
  apartmentName?: ModelStringInput | null,
  optOut?: ModelBooleanInput | null,
  optOutDateTime?: ModelStringInput | null,
  mlContactInactiveReasons?: ModelStringInput | null,
  mlSOInactiveReasons?: ModelStringInput | null,
  mlInactiveReasons?: ModelStringInput | null,
  priorityType?: ModelStringInput | null,
  nextStep?: ModelStringInput | null,
  salesCounselor?: ModelStringInput | null,
  salesCounselorName?: ModelStringInput | null,
  timeframe?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHouselistNewFilterInput | null > | null,
  or?: Array< ModelHouselistNewFilterInput | null > | null,
  not?: ModelHouselistNewFilterInput | null,
};

export type ModelHouselistNewConnection = {
  __typename: "ModelHouselistNewConnection",
  items:  Array<HouselistNew | null >,
  nextToken?: string | null,
};

export type SearchableHouselistNewFilterInput = {
  id?: SearchableIDFilterInput | null,
  accountID?: SearchableStringFilterInput | null,
  listName?: SearchableStringFilterInput | null,
  listNameId?: SearchableStringFilterInput | null,
  control?: SearchableStringFilterInput | null,
  homeValue?: SearchableStringFilterInput | null,
  homeValueBottom?: SearchableFloatFilterInput | null,
  homeValueTop?: SearchableFloatFilterInput | null,
  hohIncome?: SearchableStringFilterInput | null,
  hohIncomeBottom?: SearchableFloatFilterInput | null,
  hohIncomeTop?: SearchableFloatFilterInput | null,
  hohNetWorth?: SearchableStringFilterInput | null,
  hohNetWorthBottom?: SearchableFloatFilterInput | null,
  hohNetWorthTop?: SearchableFloatFilterInput | null,
  groupName?: SearchableStringFilterInput | null,
  birthDate?: SearchableStringFilterInput | null,
  deceasedDate?: SearchableStringFilterInput | null,
  distanceToSite?: SearchableFloatFilterInput | null,
  doNotCall?: SearchableBooleanFilterInput | null,
  email?: SearchableStringFilterInput | null,
  emailBounceDate?: SearchableStringFilterInput | null,
  epm2Grade?: SearchableIntFilterInput | null,
  epm2Score?: SearchableFloatFilterInput | null,
  epm2Tier?: SearchableStringFilterInput | null,
  firstName?: SearchableStringFilterInput | null,
  gender?: SearchableStringFilterInput | null,
  hasOptedOutOfEmail?: SearchableBooleanFilterInput | null,
  hohAge?: SearchableIntFilterInput | null,
  homePhone?: SearchableStringFilterInput | null,
  contactId?: SearchableStringFilterInput | null,
  ilContactStatus?: SearchableStringFilterInput | null,
  labelSalutation?: SearchableStringFilterInput | null,
  lastName?: SearchableStringFilterInput | null,
  letterSalutation?: SearchableStringFilterInput | null,
  neighborhood?: SearchableStringFilterInput | null,
  city?: SearchableStringFilterInput | null,
  zip5?: SearchableStringFilterInput | null,
  zipcode?: SearchableStringFilterInput | null,
  state?: SearchableStringFilterInput | null,
  address?: SearchableStringFilterInput | null,
  maritalStatus?: SearchableStringFilterInput | null,
  mlActive?: SearchableBooleanFilterInput | null,
  cellPhone?: SearchableStringFilterInput | null,
  primaryContact?: SearchableStringFilterInput | null,
  primarySite?: SearchableStringFilterInput | null,
  latitude?: SearchableFloatFilterInput | null,
  longitude?: SearchableFloatFilterInput | null,
  qasValidationStatus?: SearchableStringFilterInput | null,
  contactType?: SearchableStringFilterInput | null,
  returnedMail?: SearchableBooleanFilterInput | null,
  ccContactStatus?: SearchableStringFilterInput | null,
  opportunitySite?: SearchableStringFilterInput | null,
  opportunityId?: SearchableStringFilterInput | null,
  loc?: SearchableStringFilterInput | null,
  ltsGrade?: SearchableIntFilterInput | null,
  ltsScore?: SearchableFloatFilterInput | null,
  primaryMotivation?: SearchableStringFilterInput | null,
  communityName?: SearchableStringFilterInput | null,
  rating?: SearchableStringFilterInput | null,
  segmentation?: SearchableStringFilterInput | null,
  settledDate?: SearchableStringFilterInput | null,
  salesStage?: SearchableStringFilterInput | null,
  priorityDate?: SearchableStringFilterInput | null,
  reservationDate?: SearchableStringFilterInput | null,
  businessType?: SearchableStringFilterInput | null,
  salesOptionDate?: SearchableStringFilterInput | null,
  apartmentName?: SearchableStringFilterInput | null,
  optOut?: SearchableBooleanFilterInput | null,
  optOutDateTime?: SearchableStringFilterInput | null,
  mlContactInactiveReasons?: SearchableStringFilterInput | null,
  mlSOInactiveReasons?: SearchableStringFilterInput | null,
  mlInactiveReasons?: SearchableStringFilterInput | null,
  priorityType?: SearchableStringFilterInput | null,
  nextStep?: SearchableStringFilterInput | null,
  salesCounselor?: SearchableStringFilterInput | null,
  salesCounselorName?: SearchableStringFilterInput | null,
  timeframe?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableHouselistNewFilterInput | null > | null,
  or?: Array< SearchableHouselistNewFilterInput | null > | null,
  not?: SearchableHouselistNewFilterInput | null,
};

export type SearchableHouselistNewSortInput = {
  field?: SearchableHouselistNewSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableHouselistNewSortableFields {
  id = "id",
  accountID = "accountID",
  listName = "listName",
  listNameId = "listNameId",
  control = "control",
  homeValue = "homeValue",
  homeValueBottom = "homeValueBottom",
  homeValueTop = "homeValueTop",
  hohIncome = "hohIncome",
  hohIncomeBottom = "hohIncomeBottom",
  hohIncomeTop = "hohIncomeTop",
  hohNetWorth = "hohNetWorth",
  hohNetWorthBottom = "hohNetWorthBottom",
  hohNetWorthTop = "hohNetWorthTop",
  groupName = "groupName",
  birthDate = "birthDate",
  deceasedDate = "deceasedDate",
  distanceToSite = "distanceToSite",
  doNotCall = "doNotCall",
  email = "email",
  emailBounceDate = "emailBounceDate",
  epm2Grade = "epm2Grade",
  epm2Score = "epm2Score",
  epm2Tier = "epm2Tier",
  firstName = "firstName",
  gender = "gender",
  hasOptedOutOfEmail = "hasOptedOutOfEmail",
  hohAge = "hohAge",
  homePhone = "homePhone",
  contactId = "contactId",
  ilContactStatus = "ilContactStatus",
  labelSalutation = "labelSalutation",
  lastName = "lastName",
  letterSalutation = "letterSalutation",
  neighborhood = "neighborhood",
  city = "city",
  zip5 = "zip5",
  zipcode = "zipcode",
  state = "state",
  address = "address",
  maritalStatus = "maritalStatus",
  mlActive = "mlActive",
  cellPhone = "cellPhone",
  primaryContact = "primaryContact",
  primarySite = "primarySite",
  latitude = "latitude",
  longitude = "longitude",
  qasValidationStatus = "qasValidationStatus",
  contactType = "contactType",
  returnedMail = "returnedMail",
  ccContactStatus = "ccContactStatus",
  opportunitySite = "opportunitySite",
  opportunityId = "opportunityId",
  loc = "loc",
  ltsGrade = "ltsGrade",
  ltsScore = "ltsScore",
  primaryMotivation = "primaryMotivation",
  communityName = "communityName",
  rating = "rating",
  segmentation = "segmentation",
  settledDate = "settledDate",
  salesStage = "salesStage",
  priorityDate = "priorityDate",
  reservationDate = "reservationDate",
  businessType = "businessType",
  salesOptionDate = "salesOptionDate",
  apartmentName = "apartmentName",
  optOut = "optOut",
  optOutDateTime = "optOutDateTime",
  mlContactInactiveReasons = "mlContactInactiveReasons",
  mlSOInactiveReasons = "mlSOInactiveReasons",
  mlInactiveReasons = "mlInactiveReasons",
  priorityType = "priorityType",
  nextStep = "nextStep",
  salesCounselor = "salesCounselor",
  salesCounselorName = "salesCounselorName",
  timeframe = "timeframe",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableHouselistNewAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableHouselistNewAggregateField,
};

export enum SearchableHouselistNewAggregateField {
  id = "id",
  accountID = "accountID",
  listName = "listName",
  listNameId = "listNameId",
  control = "control",
  homeValue = "homeValue",
  homeValueBottom = "homeValueBottom",
  homeValueTop = "homeValueTop",
  hohIncome = "hohIncome",
  hohIncomeBottom = "hohIncomeBottom",
  hohIncomeTop = "hohIncomeTop",
  hohNetWorth = "hohNetWorth",
  hohNetWorthBottom = "hohNetWorthBottom",
  hohNetWorthTop = "hohNetWorthTop",
  groupName = "groupName",
  birthDate = "birthDate",
  deceasedDate = "deceasedDate",
  distanceToSite = "distanceToSite",
  doNotCall = "doNotCall",
  email = "email",
  emailBounceDate = "emailBounceDate",
  epm2Grade = "epm2Grade",
  epm2Score = "epm2Score",
  epm2Tier = "epm2Tier",
  firstName = "firstName",
  gender = "gender",
  hasOptedOutOfEmail = "hasOptedOutOfEmail",
  hohAge = "hohAge",
  homePhone = "homePhone",
  contactId = "contactId",
  ilContactStatus = "ilContactStatus",
  labelSalutation = "labelSalutation",
  lastName = "lastName",
  letterSalutation = "letterSalutation",
  neighborhood = "neighborhood",
  city = "city",
  zip5 = "zip5",
  zipcode = "zipcode",
  state = "state",
  address = "address",
  maritalStatus = "maritalStatus",
  mlActive = "mlActive",
  cellPhone = "cellPhone",
  primaryContact = "primaryContact",
  primarySite = "primarySite",
  latitude = "latitude",
  longitude = "longitude",
  qasValidationStatus = "qasValidationStatus",
  contactType = "contactType",
  returnedMail = "returnedMail",
  ccContactStatus = "ccContactStatus",
  opportunitySite = "opportunitySite",
  opportunityId = "opportunityId",
  loc = "loc",
  ltsGrade = "ltsGrade",
  ltsScore = "ltsScore",
  primaryMotivation = "primaryMotivation",
  communityName = "communityName",
  rating = "rating",
  segmentation = "segmentation",
  settledDate = "settledDate",
  salesStage = "salesStage",
  priorityDate = "priorityDate",
  reservationDate = "reservationDate",
  businessType = "businessType",
  salesOptionDate = "salesOptionDate",
  apartmentName = "apartmentName",
  optOut = "optOut",
  optOutDateTime = "optOutDateTime",
  mlContactInactiveReasons = "mlContactInactiveReasons",
  mlSOInactiveReasons = "mlSOInactiveReasons",
  mlInactiveReasons = "mlInactiveReasons",
  priorityType = "priorityType",
  nextStep = "nextStep",
  salesCounselor = "salesCounselor",
  salesCounselorName = "salesCounselorName",
  timeframe = "timeframe",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableHouselistNewConnection = {
  __typename: "SearchableHouselistNewConnection",
  items:  Array<HouselistNew | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelAccountFilterInput = {
  updateHash?: ModelStringInput | null,
  accountID?: ModelIDInput | null,
  isDeleted?: ModelBooleanInput | null,
  labelSaluation?: ModelStringInput | null,
  homeValueBottom?: ModelFloatInput | null,
  accountNameId?: ModelStringInput | null,
  homeValueTop?: ModelStringInput | null,
  letterSaluation?: ModelStringInput | null,
  numberOfParticipants?: ModelIntInput | null,
  primaryContact?: ModelStringInput | null,
  lastModifiedDate?: ModelStringInput | null,
  otherInterestsMotivation?: ModelStringInput | null,
  createdDate?: ModelStringInput | null,
  controlFlag?: ModelBooleanInput | null,
  hobbiesInterest?: ModelStringInput | null,
  primarySite?: ModelStringInput | null,
  hohNetRange?: ModelStringInput | null,
  homeValueRange?: ModelStringInput | null,
  hohNetWorthTop?: ModelFloatInput | null,
  hohIncomeRange?: ModelStringInput | null,
  hohIncomeBottom?: ModelFloatInput | null,
  accountName?: ModelStringInput | null,
  hohIncomeTop?: ModelFloatInput | null,
  hohNetWorthBottom?: ModelFloatInput | null,
  parentAccountID?: ModelStringInput | null,
  returnedMail?: ModelBooleanInput | null,
  type?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAccountFilterInput | null > | null,
  or?: Array< ModelAccountFilterInput | null > | null,
  not?: ModelAccountFilterInput | null,
  owner?: ModelStringInput | null,
};

export type ModelAccountConnection = {
  __typename: "ModelAccountConnection",
  items:  Array<Account | null >,
  nextToken?: string | null,
};

export type ModelContactFilterInput = {
  doNotMail?: ModelBooleanInput | null,
  deceasedDate?: ModelStringInput | null,
  birthDate?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  status?: ModelStringInput | null,
  emailBounceBack?: ModelBooleanInput | null,
  isDeleted?: ModelBooleanInput | null,
  labelSaluation?: ModelStringInput | null,
  homeValueBottom?: ModelFloatInput | null,
  letterSaluation?: ModelStringInput | null,
  hohNetWorth?: ModelStringInput | null,
  contactID?: ModelIDInput | null,
  hohAge?: ModelIntInput | null,
  primaryFlag?: ModelStringInput | null,
  lastModifiedDate?: ModelStringInput | null,
  mailingStreet?: ModelStringInput | null,
  mailingState?: ModelStringInput | null,
  preferredContactMethod?: ModelStringInput | null,
  epm2Score?: ModelFloatInput | null,
  ilContactStatus?: ModelStringInput | null,
  emailBounceBackDate?: ModelStringInput | null,
  fullName?: ModelStringInput | null,
  primarySite?: ModelStringInput | null,
  homeValueRange?: ModelStringInput | null,
  maritalStatus?: ModelStringInput | null,
  mailingCountry?: ModelStringInput | null,
  militaryService?: ModelBooleanInput | null,
  hohIncomeRange?: ModelStringInput | null,
  hohIncomeBottom?: ModelFloatInput | null,
  hohIncomeTop?: ModelFloatInput | null,
  qasLongitude?: ModelStringInput | null,
  hasOptedOutOfEmail?: ModelBooleanInput | null,
  mailingCountryCode?: ModelStringInput | null,
  returnedMail?: ModelBooleanInput | null,
  mobilePhone?: ModelStringInput | null,
  accountID?: ModelIDInput | null,
  qasMailingValidationStatus?: ModelStringInput | null,
  email?: ModelStringInput | null,
  homeValueTop?: ModelFloatInput | null,
  firstName?: ModelStringInput | null,
  mailingCity?: ModelStringInput | null,
  doNotCall?: ModelBooleanInput | null,
  salutation?: ModelStringInput | null,
  mlActive?: ModelBooleanInput | null,
  homePhone?: ModelStringInput | null,
  placeOfBirth?: ModelStringInput | null,
  masterRecordID?: ModelStringInput | null,
  emailOptOutDate?: ModelStringInput | null,
  gender?: ModelStringInput | null,
  qasLatitude?: ModelStringInput | null,
  hohNetWorthTop?: ModelFloatInput | null,
  mailingZipCode?: ModelStringInput | null,
  mailingNeighborhood?: ModelStringInput | null,
  contactType?: ModelStringInput | null,
  hohNetWorthBottom?: ModelFloatInput | null,
  epm2Decile?: ModelFloatInput | null,
  mailingStateCode?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelContactFilterInput | null > | null,
  or?: Array< ModelContactFilterInput | null > | null,
  not?: ModelContactFilterInput | null,
  owner?: ModelStringInput | null,
};

export type ModelContactConnection = {
  __typename: "ModelContactConnection",
  items:  Array<Contact | null >,
  nextToken?: string | null,
};

export type ModelSalesOptionFilterInput = {
  lossReason?: ModelStringInput | null,
  createdDate?: ModelStringInput | null,
  accountID?: ModelIDInput | null,
  apartment?: ModelStringInput | null,
  apartmentName?: ModelStringInput | null,
  rating?: ModelStringInput | null,
  community?: ModelStringInput | null,
  settledDate?: ModelStringInput | null,
  requestedMailOfBrochure?: ModelBooleanInput | null,
  isDeleted?: ModelBooleanInput | null,
  sourceID?: ModelStringInput | null,
  reservationDate?: ModelStringInput | null,
  reservedMSP?: ModelStringInput | null,
  salesOptionName?: ModelStringInput | null,
  priorityDepCommunity?: ModelStringInput | null,
  ltsScore?: ModelFloatInput | null,
  ltsGrade?: ModelFloatInput | null,
  lastModifiedDate?: ModelStringInput | null,
  campaignID?: ModelStringInput | null,
  priorityDate?: ModelStringInput | null,
  segmentation?: ModelStringInput | null,
  levelOfCare?: ModelStringInput | null,
  mergeFlag?: ModelBooleanInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSalesOptionFilterInput | null > | null,
  or?: Array< ModelSalesOptionFilterInput | null > | null,
  not?: ModelSalesOptionFilterInput | null,
  owner?: ModelStringInput | null,
};

export type ModelSalesOptionConnection = {
  __typename: "ModelSalesOptionConnection",
  items:  Array<SalesOption | null >,
  nextToken?: string | null,
};

export type ModelStaffSeedFilterInput = {
  id?: ModelStringInput | null,
  address?: ModelStringInput | null,
  city?: ModelStringInput | null,
  community?: ModelStringInput | null,
  createdby?: ModelStringInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  labelSalutation?: ModelStringInput | null,
  lastModifiedBy?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  letterSalutation?: ModelStringInput | null,
  loc?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  postalCode?: ModelStringInput | null,
  seedDataName?: ModelStringInput | null,
  state?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelStaffSeedFilterInput | null > | null,
  or?: Array< ModelStaffSeedFilterInput | null > | null,
  not?: ModelStaffSeedFilterInput | null,
};

export type ModelStaffSeedConnection = {
  __typename: "ModelStaffSeedConnection",
  items:  Array<StaffSeed | null >,
  nextToken?: string | null,
};

export type SearchableStaffSeedFilterInput = {
  id?: SearchableStringFilterInput | null,
  address?: SearchableStringFilterInput | null,
  city?: SearchableStringFilterInput | null,
  community?: SearchableStringFilterInput | null,
  createdby?: SearchableStringFilterInput | null,
  email?: SearchableStringFilterInput | null,
  firstName?: SearchableStringFilterInput | null,
  labelSalutation?: SearchableStringFilterInput | null,
  lastModifiedBy?: SearchableStringFilterInput | null,
  lastName?: SearchableStringFilterInput | null,
  letterSalutation?: SearchableStringFilterInput | null,
  loc?: SearchableStringFilterInput | null,
  owner?: SearchableStringFilterInput | null,
  postalCode?: SearchableStringFilterInput | null,
  seedDataName?: SearchableStringFilterInput | null,
  state?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableStaffSeedFilterInput | null > | null,
  or?: Array< SearchableStaffSeedFilterInput | null > | null,
  not?: SearchableStaffSeedFilterInput | null,
};

export type SearchableStaffSeedSortInput = {
  field?: SearchableStaffSeedSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableStaffSeedSortableFields {
  id = "id",
  address = "address",
  city = "city",
  community = "community",
  createdby = "createdby",
  email = "email",
  firstName = "firstName",
  labelSalutation = "labelSalutation",
  lastModifiedBy = "lastModifiedBy",
  lastName = "lastName",
  letterSalutation = "letterSalutation",
  loc = "loc",
  owner = "owner",
  postalCode = "postalCode",
  seedDataName = "seedDataName",
  state = "state",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableStaffSeedAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableStaffSeedAggregateField,
};

export enum SearchableStaffSeedAggregateField {
  id = "id",
  address = "address",
  city = "city",
  community = "community",
  createdby = "createdby",
  email = "email",
  firstName = "firstName",
  labelSalutation = "labelSalutation",
  lastModifiedBy = "lastModifiedBy",
  lastName = "lastName",
  letterSalutation = "letterSalutation",
  loc = "loc",
  owner = "owner",
  postalCode = "postalCode",
  seedDataName = "seedDataName",
  state = "state",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableStaffSeedConnection = {
  __typename: "SearchableStaffSeedConnection",
  items:  Array<StaffSeed | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelDistanceToSiteFilterInput = {
  distanceToSiteId?: ModelStringInput | null,
  distance?: ModelFloatInput | null,
  site?: ModelStringInput | null,
  communityId?: ModelStringInput | null,
  createdDate?: ModelStringInput | null,
  isDeleted?: ModelStringInput | null,
  lastModifiedDate?: ModelStringInput | null,
  contactId?: ModelStringInput | null,
  name?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDistanceToSiteFilterInput | null > | null,
  or?: Array< ModelDistanceToSiteFilterInput | null > | null,
  not?: ModelDistanceToSiteFilterInput | null,
  owner?: ModelStringInput | null,
};

export type ModelDistanceToSiteConnection = {
  __typename: "ModelDistanceToSiteConnection",
  items:  Array<DistanceToSite | null >,
  nextToken?: string | null,
};

export type ModelFilterValueFilterInput = {
  listType?: ModelIDInput | null,
  fieldId?: ModelIDInput | null,
  version?: ModelIDInput | null,
  selectedValues?: ModelStringInput | null,
  relationalOperator?: ModelStringInput | null,
  description?: ModelStringInput | null,
  changeReason?: ModelStringInput | null,
  changedBy?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFilterValueFilterInput | null > | null,
  or?: Array< ModelFilterValueFilterInput | null > | null,
  not?: ModelFilterValueFilterInput | null,
};

export type ModelFilterValueConnection = {
  __typename: "ModelFilterValueConnection",
  items:  Array<FilterValue | null >,
  nextToken?: string | null,
};

export type SearchableFilterValueFilterInput = {
  listType?: SearchableIDFilterInput | null,
  fieldId?: SearchableIDFilterInput | null,
  version?: SearchableIDFilterInput | null,
  selectedValues?: SearchableStringFilterInput | null,
  relationalOperator?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  changeReason?: SearchableStringFilterInput | null,
  changedBy?: SearchableStringFilterInput | null,
  id?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableFilterValueFilterInput | null > | null,
  or?: Array< SearchableFilterValueFilterInput | null > | null,
  not?: SearchableFilterValueFilterInput | null,
};

export type SearchableFilterValueSortInput = {
  field?: SearchableFilterValueSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableFilterValueSortableFields {
  listType = "listType",
  fieldId = "fieldId",
  version = "version",
  selectedValues = "selectedValues",
  relationalOperator = "relationalOperator",
  description = "description",
  changeReason = "changeReason",
  changedBy = "changedBy",
  id = "id",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFilterValueAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableFilterValueAggregateField,
};

export enum SearchableFilterValueAggregateField {
  listType = "listType",
  fieldId = "fieldId",
  version = "version",
  selectedValues = "selectedValues",
  relationalOperator = "relationalOperator",
  description = "description",
  changeReason = "changeReason",
  changedBy = "changedBy",
  id = "id",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFilterValueConnection = {
  __typename: "SearchableFilterValueConnection",
  items:  Array<FilterValue | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelFlagDefinitionFilterInput = {
  id?: ModelIDInput | null,
  listType?: ModelStringInput | null,
  fieldName?: ModelStringInput | null,
  flagValue?: ModelStringInput | null,
  friendlyName?: ModelStringInput | null,
  description?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFlagDefinitionFilterInput | null > | null,
  or?: Array< ModelFlagDefinitionFilterInput | null > | null,
  not?: ModelFlagDefinitionFilterInput | null,
};

export type ModelFlagDefinitionConnection = {
  __typename: "ModelFlagDefinitionConnection",
  items:  Array<FlagDefinition | null >,
  nextToken?: string | null,
};

export type SearchableFlagDefinitionFilterInput = {
  id?: SearchableIDFilterInput | null,
  listType?: SearchableStringFilterInput | null,
  fieldName?: SearchableStringFilterInput | null,
  flagValue?: SearchableStringFilterInput | null,
  friendlyName?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableFlagDefinitionFilterInput | null > | null,
  or?: Array< SearchableFlagDefinitionFilterInput | null > | null,
  not?: SearchableFlagDefinitionFilterInput | null,
};

export type SearchableFlagDefinitionSortInput = {
  field?: SearchableFlagDefinitionSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableFlagDefinitionSortableFields {
  id = "id",
  listType = "listType",
  fieldName = "fieldName",
  flagValue = "flagValue",
  friendlyName = "friendlyName",
  description = "description",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlagDefinitionAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableFlagDefinitionAggregateField,
};

export enum SearchableFlagDefinitionAggregateField {
  id = "id",
  listType = "listType",
  fieldName = "fieldName",
  flagValue = "flagValue",
  friendlyName = "friendlyName",
  description = "description",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableFlagDefinitionConnection = {
  __typename: "SearchableFlagDefinitionConnection",
  items:  Array<FlagDefinition | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelDataTransferStageFilterInput = {
  id?: ModelIDInput | null,
  traceId?: ModelStringInput | null,
  fileKey?: ModelStringInput | null,
  totalInputRecords?: ModelIntInput | null,
  indexStart?: ModelIntInput | null,
  indexEnd?: ModelIntInput | null,
  addedCount?: ModelIntInput | null,
  updatedCount?: ModelIntInput | null,
  failedCount?: ModelIntInput | null,
  failureReason?: ModelStringInput | null,
  source?: ModelStringInput | null,
  expirationUnixTime?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDataTransferStageFilterInput | null > | null,
  or?: Array< ModelDataTransferStageFilterInput | null > | null,
  not?: ModelDataTransferStageFilterInput | null,
};

export type ModelDataTransferStageConnection = {
  __typename: "ModelDataTransferStageConnection",
  items:  Array<DataTransferStage | null >,
  nextToken?: string | null,
};

export type ModelExclusionRuleFilterInput = {
  id?: ModelIDInput | null,
  listType?: ModelStringInput | null,
  fieldName?: ModelStringInput | null,
  excludedValues?: ModelStringInput | null,
  operator?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelExclusionRuleFilterInput | null > | null,
  or?: Array< ModelExclusionRuleFilterInput | null > | null,
  not?: ModelExclusionRuleFilterInput | null,
};

export type ModelExclusionRuleConnection = {
  __typename: "ModelExclusionRuleConnection",
  items:  Array<ExclusionRule | null >,
  nextToken?: string | null,
};

export type SearchableExclusionRuleFilterInput = {
  id?: SearchableIDFilterInput | null,
  listType?: SearchableStringFilterInput | null,
  fieldName?: SearchableStringFilterInput | null,
  excludedValues?: SearchableStringFilterInput | null,
  operator?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableExclusionRuleFilterInput | null > | null,
  or?: Array< SearchableExclusionRuleFilterInput | null > | null,
  not?: SearchableExclusionRuleFilterInput | null,
};

export type SearchableExclusionRuleSortInput = {
  field?: SearchableExclusionRuleSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableExclusionRuleSortableFields {
  id = "id",
  listType = "listType",
  fieldName = "fieldName",
  excludedValues = "excludedValues",
  operator = "operator",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableExclusionRuleAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableExclusionRuleAggregateField,
};

export enum SearchableExclusionRuleAggregateField {
  id = "id",
  listType = "listType",
  fieldName = "fieldName",
  excludedValues = "excludedValues",
  operator = "operator",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableExclusionRuleConnection = {
  __typename: "SearchableExclusionRuleConnection",
  items:  Array<ExclusionRule | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelSubscriptionBLConcurrencyLockFilterInput = {
  community?: ModelSubscriptionIDInput | null,
  lockToken?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  expirationUnixTime?: ModelSubscriptionIntInput | null,
  id?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBLConcurrencyLockFilterInput | null > | null,
  or?: Array< ModelSubscriptionBLConcurrencyLockFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionBoughtListFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  saluation?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  gender?: ModelSubscriptionStringInput | null,
  age?: ModelSubscriptionIntInput | null,
  address?: ModelSubscriptionStringInput | null,
  city?: ModelSubscriptionStringInput | null,
  state?: ModelSubscriptionStringInput | null,
  zipcode?: ModelSubscriptionStringInput | null,
  county?: ModelSubscriptionStringInput | null,
  householdIncome?: ModelSubscriptionStringInput | null,
  householdIncomeBottom?: ModelSubscriptionFloatInput | null,
  householdIncomeTop?: ModelSubscriptionFloatInput | null,
  homeValue?: ModelSubscriptionStringInput | null,
  homeValueBottom?: ModelSubscriptionFloatInput | null,
  homeValueTop?: ModelSubscriptionFloatInput | null,
  boatingSailing?: ModelSubscriptionStringInput | null,
  tennis?: ModelSubscriptionStringInput | null,
  golf?: ModelSubscriptionStringInput | null,
  boatOwner?: ModelSubscriptionStringInput | null,
  upscaleLiving?: ModelSubscriptionStringInput | null,
  suppress?: ModelSubscriptionStringInput | null,
  doNotMail?: ModelSubscriptionStringInput | null,
  dropDate?: ModelSubscriptionStringInput | null,
  zip5?: ModelSubscriptionStringInput | null,
  batchCode?: ModelSubscriptionStringInput | null,
  listDate?: ModelSubscriptionStringInput | null,
  listName?: ModelSubscriptionStringInput | null,
  listNameId?: ModelSubscriptionStringInput | null,
  qseq?: ModelSubscriptionIntInput | null,
  expirationDate?: ModelSubscriptionStringInput | null,
  lastUpdated?: ModelSubscriptionStringInput | null,
  site1?: ModelSubscriptionStringInput | null,
  siteDistance1?: ModelSubscriptionFloatInput | null,
  epm3Decile1?: ModelSubscriptionIntInput | null,
  epm3Score1?: ModelSubscriptionFloatInput | null,
  epm3Tier1?: ModelSubscriptionStringInput | null,
  site2?: ModelSubscriptionStringInput | null,
  siteDistance2?: ModelSubscriptionStringInput | null,
  epm3Decile2?: ModelSubscriptionIntInput | null,
  epm3Score2?: ModelSubscriptionFloatInput | null,
  epm3Tier2?: ModelSubscriptionStringInput | null,
  blSelect?: ModelSubscriptionStringInput | null,
  hlMatch?: ModelSubscriptionStringInput | null,
  randomNumber?: ModelSubscriptionFloatInput | null,
  randomFlag?: ModelSubscriptionIntInput | null,
  netNewFlag?: ModelSubscriptionIntInput | null,
  staticControlFlag?: ModelSubscriptionStringInput | null,
  hlGrpRowList?: ModelSubscriptionStringInput | null,
  hlODateList?: ModelSubscriptionStringInput | null,
  optOut?: ModelSubscriptionBooleanInput | null,
  optOutDateTime?: ModelSubscriptionStringInput | null,
  optOutUpdatedBy?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  expirationUnixTime?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionBoughtListFilterInput | null > | null,
  or?: Array< ModelSubscriptionBoughtListFilterInput | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionUserFilterFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  listType?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  filterDefinitions?: ModelSubscriptionStringInput | null,
  filterSelections?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionExportJobFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  exportName?: ModelSubscriptionStringInput | null,
  listType?: ModelSubscriptionStringInput | null,
  reportId?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  statusMessage?: ModelSubscriptionStringInput | null,
  filterInput?: ModelSubscriptionStringInput | null,
  filterFields?: ModelSubscriptionStringInput | null,
  outputFormat?: ModelSubscriptionStringInput | null,
  s3Key?: ModelSubscriptionStringInput | null,
  totalRecords?: ModelSubscriptionIntInput | null,
  fileSize?: ModelSubscriptionFloatInput | null,
  startedAt?: ModelSubscriptionStringInput | null,
  expiresAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  debugInfo?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionExportJobFilterInput | null > | null,
  or?: Array< ModelSubscriptionExportJobFilterInput | null > | null,
  owner?: ModelStringInput | null,
  authorizedReaders?: ModelStringInput | null,
};

export type ModelSubscriptionReportRunScheduleFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  reportId?: ModelSubscriptionStringInput | null,
  scheduleExpression?: ModelSubscriptionStringInput | null,
  enabled?: ModelSubscriptionBooleanInput | null,
  subscribers?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionReportRunScheduleFilterInput | null > | null,
  or?: Array< ModelSubscriptionReportRunScheduleFilterInput | null > | null,
};

export type ModelSubscriptionHouselistNewFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  accountID?: ModelSubscriptionStringInput | null,
  listName?: ModelSubscriptionStringInput | null,
  listNameId?: ModelSubscriptionStringInput | null,
  control?: ModelSubscriptionStringInput | null,
  homeValue?: ModelSubscriptionStringInput | null,
  homeValueBottom?: ModelSubscriptionFloatInput | null,
  homeValueTop?: ModelSubscriptionFloatInput | null,
  hohIncome?: ModelSubscriptionStringInput | null,
  hohIncomeBottom?: ModelSubscriptionFloatInput | null,
  hohIncomeTop?: ModelSubscriptionFloatInput | null,
  hohNetWorth?: ModelSubscriptionStringInput | null,
  hohNetWorthBottom?: ModelSubscriptionFloatInput | null,
  hohNetWorthTop?: ModelSubscriptionFloatInput | null,
  groupName?: ModelSubscriptionStringInput | null,
  birthDate?: ModelSubscriptionStringInput | null,
  deceasedDate?: ModelSubscriptionStringInput | null,
  distanceToSite?: ModelSubscriptionFloatInput | null,
  doNotCall?: ModelSubscriptionBooleanInput | null,
  email?: ModelSubscriptionStringInput | null,
  emailBounceDate?: ModelSubscriptionStringInput | null,
  epm2Grade?: ModelSubscriptionIntInput | null,
  epm2Score?: ModelSubscriptionFloatInput | null,
  epm2Tier?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  gender?: ModelSubscriptionStringInput | null,
  hasOptedOutOfEmail?: ModelSubscriptionBooleanInput | null,
  hohAge?: ModelSubscriptionIntInput | null,
  homePhone?: ModelSubscriptionStringInput | null,
  contactId?: ModelSubscriptionStringInput | null,
  ilContactStatus?: ModelSubscriptionStringInput | null,
  labelSalutation?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  letterSalutation?: ModelSubscriptionStringInput | null,
  neighborhood?: ModelSubscriptionStringInput | null,
  city?: ModelSubscriptionStringInput | null,
  zip5?: ModelSubscriptionStringInput | null,
  zipcode?: ModelSubscriptionStringInput | null,
  state?: ModelSubscriptionStringInput | null,
  address?: ModelSubscriptionStringInput | null,
  maritalStatus?: ModelSubscriptionStringInput | null,
  mlActive?: ModelSubscriptionBooleanInput | null,
  cellPhone?: ModelSubscriptionStringInput | null,
  primaryContact?: ModelSubscriptionStringInput | null,
  primarySite?: ModelSubscriptionStringInput | null,
  latitude?: ModelSubscriptionFloatInput | null,
  longitude?: ModelSubscriptionFloatInput | null,
  qasValidationStatus?: ModelSubscriptionStringInput | null,
  contactType?: ModelSubscriptionStringInput | null,
  returnedMail?: ModelSubscriptionBooleanInput | null,
  ccContactStatus?: ModelSubscriptionStringInput | null,
  opportunitySite?: ModelSubscriptionStringInput | null,
  opportunityId?: ModelSubscriptionStringInput | null,
  loc?: ModelSubscriptionStringInput | null,
  ltsGrade?: ModelSubscriptionIntInput | null,
  ltsScore?: ModelSubscriptionFloatInput | null,
  primaryMotivation?: ModelSubscriptionStringInput | null,
  communityName?: ModelSubscriptionStringInput | null,
  rating?: ModelSubscriptionStringInput | null,
  segmentation?: ModelSubscriptionStringInput | null,
  settledDate?: ModelSubscriptionStringInput | null,
  salesStage?: ModelSubscriptionStringInput | null,
  priorityDate?: ModelSubscriptionStringInput | null,
  reservationDate?: ModelSubscriptionStringInput | null,
  businessType?: ModelSubscriptionStringInput | null,
  salesOptionDate?: ModelSubscriptionStringInput | null,
  apartmentName?: ModelSubscriptionStringInput | null,
  optOut?: ModelSubscriptionBooleanInput | null,
  optOutDateTime?: ModelSubscriptionStringInput | null,
  mlContactInactiveReasons?: ModelSubscriptionStringInput | null,
  mlSOInactiveReasons?: ModelSubscriptionStringInput | null,
  mlInactiveReasons?: ModelSubscriptionStringInput | null,
  priorityType?: ModelSubscriptionStringInput | null,
  nextStep?: ModelSubscriptionStringInput | null,
  salesCounselor?: ModelSubscriptionStringInput | null,
  salesCounselorName?: ModelSubscriptionStringInput | null,
  timeframe?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionHouselistNewFilterInput | null > | null,
  or?: Array< ModelSubscriptionHouselistNewFilterInput | null > | null,
};

export type ModelSubscriptionAccountFilterInput = {
  updateHash?: ModelSubscriptionStringInput | null,
  accountID?: ModelSubscriptionIDInput | null,
  isDeleted?: ModelSubscriptionBooleanInput | null,
  labelSaluation?: ModelSubscriptionStringInput | null,
  homeValueBottom?: ModelSubscriptionFloatInput | null,
  accountNameId?: ModelSubscriptionStringInput | null,
  homeValueTop?: ModelSubscriptionStringInput | null,
  letterSaluation?: ModelSubscriptionStringInput | null,
  numberOfParticipants?: ModelSubscriptionIntInput | null,
  primaryContact?: ModelSubscriptionStringInput | null,
  lastModifiedDate?: ModelSubscriptionStringInput | null,
  otherInterestsMotivation?: ModelSubscriptionStringInput | null,
  createdDate?: ModelSubscriptionStringInput | null,
  controlFlag?: ModelSubscriptionBooleanInput | null,
  hobbiesInterest?: ModelSubscriptionStringInput | null,
  primarySite?: ModelSubscriptionStringInput | null,
  hohNetRange?: ModelSubscriptionStringInput | null,
  homeValueRange?: ModelSubscriptionStringInput | null,
  hohNetWorthTop?: ModelSubscriptionFloatInput | null,
  hohIncomeRange?: ModelSubscriptionStringInput | null,
  hohIncomeBottom?: ModelSubscriptionFloatInput | null,
  accountName?: ModelSubscriptionStringInput | null,
  hohIncomeTop?: ModelSubscriptionFloatInput | null,
  hohNetWorthBottom?: ModelSubscriptionFloatInput | null,
  parentAccountID?: ModelSubscriptionStringInput | null,
  returnedMail?: ModelSubscriptionBooleanInput | null,
  type?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAccountFilterInput | null > | null,
  or?: Array< ModelSubscriptionAccountFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionContactFilterInput = {
  doNotMail?: ModelSubscriptionBooleanInput | null,
  deceasedDate?: ModelSubscriptionStringInput | null,
  birthDate?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  emailBounceBack?: ModelSubscriptionBooleanInput | null,
  isDeleted?: ModelSubscriptionBooleanInput | null,
  labelSaluation?: ModelSubscriptionStringInput | null,
  homeValueBottom?: ModelSubscriptionFloatInput | null,
  letterSaluation?: ModelSubscriptionStringInput | null,
  hohNetWorth?: ModelSubscriptionStringInput | null,
  contactID?: ModelSubscriptionIDInput | null,
  hohAge?: ModelSubscriptionIntInput | null,
  primaryFlag?: ModelSubscriptionStringInput | null,
  lastModifiedDate?: ModelSubscriptionStringInput | null,
  mailingStreet?: ModelSubscriptionStringInput | null,
  mailingState?: ModelSubscriptionStringInput | null,
  preferredContactMethod?: ModelSubscriptionStringInput | null,
  epm2Score?: ModelSubscriptionFloatInput | null,
  ilContactStatus?: ModelSubscriptionStringInput | null,
  emailBounceBackDate?: ModelSubscriptionStringInput | null,
  fullName?: ModelSubscriptionStringInput | null,
  primarySite?: ModelSubscriptionStringInput | null,
  homeValueRange?: ModelSubscriptionStringInput | null,
  maritalStatus?: ModelSubscriptionStringInput | null,
  mailingCountry?: ModelSubscriptionStringInput | null,
  militaryService?: ModelSubscriptionBooleanInput | null,
  hohIncomeRange?: ModelSubscriptionStringInput | null,
  hohIncomeBottom?: ModelSubscriptionFloatInput | null,
  hohIncomeTop?: ModelSubscriptionFloatInput | null,
  qasLongitude?: ModelSubscriptionStringInput | null,
  hasOptedOutOfEmail?: ModelSubscriptionBooleanInput | null,
  mailingCountryCode?: ModelSubscriptionStringInput | null,
  returnedMail?: ModelSubscriptionBooleanInput | null,
  mobilePhone?: ModelSubscriptionStringInput | null,
  accountID?: ModelSubscriptionIDInput | null,
  qasMailingValidationStatus?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  homeValueTop?: ModelSubscriptionFloatInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  mailingCity?: ModelSubscriptionStringInput | null,
  doNotCall?: ModelSubscriptionBooleanInput | null,
  salutation?: ModelSubscriptionStringInput | null,
  mlActive?: ModelSubscriptionBooleanInput | null,
  homePhone?: ModelSubscriptionStringInput | null,
  placeOfBirth?: ModelSubscriptionStringInput | null,
  masterRecordID?: ModelSubscriptionStringInput | null,
  emailOptOutDate?: ModelSubscriptionStringInput | null,
  gender?: ModelSubscriptionStringInput | null,
  qasLatitude?: ModelSubscriptionStringInput | null,
  hohNetWorthTop?: ModelSubscriptionFloatInput | null,
  mailingZipCode?: ModelSubscriptionStringInput | null,
  mailingNeighborhood?: ModelSubscriptionStringInput | null,
  contactType?: ModelSubscriptionStringInput | null,
  hohNetWorthBottom?: ModelSubscriptionFloatInput | null,
  epm2Decile?: ModelSubscriptionFloatInput | null,
  mailingStateCode?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionContactFilterInput | null > | null,
  or?: Array< ModelSubscriptionContactFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionSalesOptionFilterInput = {
  lossReason?: ModelSubscriptionStringInput | null,
  createdDate?: ModelSubscriptionStringInput | null,
  accountID?: ModelSubscriptionIDInput | null,
  apartment?: ModelSubscriptionStringInput | null,
  apartmentName?: ModelSubscriptionStringInput | null,
  rating?: ModelSubscriptionStringInput | null,
  community?: ModelSubscriptionStringInput | null,
  settledDate?: ModelSubscriptionStringInput | null,
  requestedMailOfBrochure?: ModelSubscriptionBooleanInput | null,
  isDeleted?: ModelSubscriptionBooleanInput | null,
  sourceID?: ModelSubscriptionStringInput | null,
  reservationDate?: ModelSubscriptionStringInput | null,
  reservedMSP?: ModelSubscriptionStringInput | null,
  salesOptionName?: ModelSubscriptionStringInput | null,
  priorityDepCommunity?: ModelSubscriptionStringInput | null,
  ltsScore?: ModelSubscriptionFloatInput | null,
  ltsGrade?: ModelSubscriptionFloatInput | null,
  lastModifiedDate?: ModelSubscriptionStringInput | null,
  campaignID?: ModelSubscriptionStringInput | null,
  priorityDate?: ModelSubscriptionStringInput | null,
  segmentation?: ModelSubscriptionStringInput | null,
  levelOfCare?: ModelSubscriptionStringInput | null,
  mergeFlag?: ModelSubscriptionBooleanInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSalesOptionFilterInput | null > | null,
  or?: Array< ModelSubscriptionSalesOptionFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionStaffSeedFilterInput = {
  id?: ModelSubscriptionStringInput | null,
  address?: ModelSubscriptionStringInput | null,
  city?: ModelSubscriptionStringInput | null,
  community?: ModelSubscriptionStringInput | null,
  createdby?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  labelSalutation?: ModelSubscriptionStringInput | null,
  lastModifiedBy?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  letterSalutation?: ModelSubscriptionStringInput | null,
  loc?: ModelSubscriptionStringInput | null,
  postalCode?: ModelSubscriptionStringInput | null,
  seedDataName?: ModelSubscriptionStringInput | null,
  state?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionStaffSeedFilterInput | null > | null,
  or?: Array< ModelSubscriptionStaffSeedFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionDistanceToSiteFilterInput = {
  distanceToSiteId?: ModelSubscriptionStringInput | null,
  distance?: ModelSubscriptionFloatInput | null,
  site?: ModelSubscriptionStringInput | null,
  communityId?: ModelSubscriptionStringInput | null,
  createdDate?: ModelSubscriptionStringInput | null,
  isDeleted?: ModelSubscriptionStringInput | null,
  lastModifiedDate?: ModelSubscriptionStringInput | null,
  contactId?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDistanceToSiteFilterInput | null > | null,
  or?: Array< ModelSubscriptionDistanceToSiteFilterInput | null > | null,
  owner?: ModelStringInput | null,
};

export type ModelSubscriptionFilterValueFilterInput = {
  listType?: ModelSubscriptionIDInput | null,
  fieldId?: ModelSubscriptionIDInput | null,
  version?: ModelSubscriptionIDInput | null,
  selectedValues?: ModelSubscriptionStringInput | null,
  relationalOperator?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  changeReason?: ModelSubscriptionStringInput | null,
  changedBy?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFilterValueFilterInput | null > | null,
  or?: Array< ModelSubscriptionFilterValueFilterInput | null > | null,
};

export type ModelSubscriptionFlagDefinitionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  listType?: ModelSubscriptionStringInput | null,
  fieldName?: ModelSubscriptionStringInput | null,
  flagValue?: ModelSubscriptionStringInput | null,
  friendlyName?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFlagDefinitionFilterInput | null > | null,
  or?: Array< ModelSubscriptionFlagDefinitionFilterInput | null > | null,
};

export type ModelSubscriptionDataTransferStageFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  traceId?: ModelSubscriptionStringInput | null,
  fileKey?: ModelSubscriptionStringInput | null,
  totalInputRecords?: ModelSubscriptionIntInput | null,
  indexStart?: ModelSubscriptionIntInput | null,
  indexEnd?: ModelSubscriptionIntInput | null,
  addedCount?: ModelSubscriptionIntInput | null,
  updatedCount?: ModelSubscriptionIntInput | null,
  failedCount?: ModelSubscriptionIntInput | null,
  failureReason?: ModelSubscriptionStringInput | null,
  source?: ModelSubscriptionStringInput | null,
  expirationUnixTime?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDataTransferStageFilterInput | null > | null,
  or?: Array< ModelSubscriptionDataTransferStageFilterInput | null > | null,
};

export type ModelSubscriptionExclusionRuleFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  listType?: ModelSubscriptionStringInput | null,
  fieldName?: ModelSubscriptionStringInput | null,
  excludedValues?: ModelSubscriptionStringInput | null,
  operator?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionExclusionRuleFilterInput | null > | null,
  or?: Array< ModelSubscriptionExclusionRuleFilterInput | null > | null,
};

export type UpdateReportSubscriptionMutationVariables = {
  reportId: string,
  subscribe: boolean,
};

export type UpdateReportSubscriptionMutation = {
  updateReportSubscription?:  {
    __typename: "ReportRunSchedule",
    id: string,
    reportId: string,
    scheduleExpression: string,
    enabled: boolean,
    subscribers: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBoughtListOptOutMutationVariables = {
  id: string,
  optOut: boolean,
};

export type UpdateBoughtListOptOutMutation = {
  updateBoughtListOptOut?:  {
    __typename: "BoughtList",
    id: string,
    saluation?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    gender?: string | null,
    age?: number | null,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    county?: string | null,
    householdIncome?: string | null,
    householdIncomeBottom?: number | null,
    householdIncomeTop?: number | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    boatingSailing?: string | null,
    tennis?: string | null,
    golf?: string | null,
    boatOwner?: string | null,
    upscaleLiving?: string | null,
    suppress?: string | null,
    doNotMail?: string | null,
    dropDate?: string | null,
    zip5?: string | null,
    batchCode?: string | null,
    listDate?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    qseq?: number | null,
    expirationDate?: string | null,
    lastUpdated?: string | null,
    site1?: string | null,
    siteDistance1?: number | null,
    epm3Decile1?: number | null,
    epm3Score1?: number | null,
    epm3Tier1?: string | null,
    site2?: string | null,
    siteDistance2?: string | null,
    epm3Decile2?: number | null,
    epm3Score2?: number | null,
    epm3Tier2?: string | null,
    blSelect?: string | null,
    hlMatch?: string | null,
    randomNumber?: number | null,
    randomFlag?: number | null,
    netNewFlag?: number | null,
    staticControlFlag?: string | null,
    hlGrpRowList?: string | null,
    hlODateList?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    optOutUpdatedBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    expirationUnixTime?: number | null,
  } | null,
};

export type CreateBLConcurrencyLockMutationVariables = {
  input: CreateBLConcurrencyLockInput,
  condition?: ModelBLConcurrencyLockConditionInput | null,
};

export type CreateBLConcurrencyLockMutation = {
  createBLConcurrencyLock?:  {
    __typename: "BLConcurrencyLock",
    community: string,
    lockToken?: string | null,
    createdAt?: string | null,
    expirationUnixTime?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateBLConcurrencyLockMutationVariables = {
  input: UpdateBLConcurrencyLockInput,
  condition?: ModelBLConcurrencyLockConditionInput | null,
};

export type UpdateBLConcurrencyLockMutation = {
  updateBLConcurrencyLock?:  {
    __typename: "BLConcurrencyLock",
    community: string,
    lockToken?: string | null,
    createdAt?: string | null,
    expirationUnixTime?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteBLConcurrencyLockMutationVariables = {
  input: DeleteBLConcurrencyLockInput,
  condition?: ModelBLConcurrencyLockConditionInput | null,
};

export type DeleteBLConcurrencyLockMutation = {
  deleteBLConcurrencyLock?:  {
    __typename: "BLConcurrencyLock",
    community: string,
    lockToken?: string | null,
    createdAt?: string | null,
    expirationUnixTime?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateBoughtListMutationVariables = {
  input: CreateBoughtListInput,
  condition?: ModelBoughtListConditionInput | null,
};

export type CreateBoughtListMutation = {
  createBoughtList?:  {
    __typename: "BoughtList",
    id: string,
    saluation?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    gender?: string | null,
    age?: number | null,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    county?: string | null,
    householdIncome?: string | null,
    householdIncomeBottom?: number | null,
    householdIncomeTop?: number | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    boatingSailing?: string | null,
    tennis?: string | null,
    golf?: string | null,
    boatOwner?: string | null,
    upscaleLiving?: string | null,
    suppress?: string | null,
    doNotMail?: string | null,
    dropDate?: string | null,
    zip5?: string | null,
    batchCode?: string | null,
    listDate?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    qseq?: number | null,
    expirationDate?: string | null,
    lastUpdated?: string | null,
    site1?: string | null,
    siteDistance1?: number | null,
    epm3Decile1?: number | null,
    epm3Score1?: number | null,
    epm3Tier1?: string | null,
    site2?: string | null,
    siteDistance2?: string | null,
    epm3Decile2?: number | null,
    epm3Score2?: number | null,
    epm3Tier2?: string | null,
    blSelect?: string | null,
    hlMatch?: string | null,
    randomNumber?: number | null,
    randomFlag?: number | null,
    netNewFlag?: number | null,
    staticControlFlag?: string | null,
    hlGrpRowList?: string | null,
    hlODateList?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    optOutUpdatedBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    expirationUnixTime?: number | null,
  } | null,
};

export type UpdateBoughtListMutationVariables = {
  input: UpdateBoughtListInput,
  condition?: ModelBoughtListConditionInput | null,
};

export type UpdateBoughtListMutation = {
  updateBoughtList?:  {
    __typename: "BoughtList",
    id: string,
    saluation?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    gender?: string | null,
    age?: number | null,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    county?: string | null,
    householdIncome?: string | null,
    householdIncomeBottom?: number | null,
    householdIncomeTop?: number | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    boatingSailing?: string | null,
    tennis?: string | null,
    golf?: string | null,
    boatOwner?: string | null,
    upscaleLiving?: string | null,
    suppress?: string | null,
    doNotMail?: string | null,
    dropDate?: string | null,
    zip5?: string | null,
    batchCode?: string | null,
    listDate?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    qseq?: number | null,
    expirationDate?: string | null,
    lastUpdated?: string | null,
    site1?: string | null,
    siteDistance1?: number | null,
    epm3Decile1?: number | null,
    epm3Score1?: number | null,
    epm3Tier1?: string | null,
    site2?: string | null,
    siteDistance2?: string | null,
    epm3Decile2?: number | null,
    epm3Score2?: number | null,
    epm3Tier2?: string | null,
    blSelect?: string | null,
    hlMatch?: string | null,
    randomNumber?: number | null,
    randomFlag?: number | null,
    netNewFlag?: number | null,
    staticControlFlag?: string | null,
    hlGrpRowList?: string | null,
    hlODateList?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    optOutUpdatedBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    expirationUnixTime?: number | null,
  } | null,
};

export type DeleteBoughtListMutationVariables = {
  input: DeleteBoughtListInput,
  condition?: ModelBoughtListConditionInput | null,
};

export type DeleteBoughtListMutation = {
  deleteBoughtList?:  {
    __typename: "BoughtList",
    id: string,
    saluation?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    gender?: string | null,
    age?: number | null,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    county?: string | null,
    householdIncome?: string | null,
    householdIncomeBottom?: number | null,
    householdIncomeTop?: number | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    boatingSailing?: string | null,
    tennis?: string | null,
    golf?: string | null,
    boatOwner?: string | null,
    upscaleLiving?: string | null,
    suppress?: string | null,
    doNotMail?: string | null,
    dropDate?: string | null,
    zip5?: string | null,
    batchCode?: string | null,
    listDate?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    qseq?: number | null,
    expirationDate?: string | null,
    lastUpdated?: string | null,
    site1?: string | null,
    siteDistance1?: number | null,
    epm3Decile1?: number | null,
    epm3Score1?: number | null,
    epm3Tier1?: string | null,
    site2?: string | null,
    siteDistance2?: string | null,
    epm3Decile2?: number | null,
    epm3Score2?: number | null,
    epm3Tier2?: string | null,
    blSelect?: string | null,
    hlMatch?: string | null,
    randomNumber?: number | null,
    randomFlag?: number | null,
    netNewFlag?: number | null,
    staticControlFlag?: string | null,
    hlGrpRowList?: string | null,
    hlODateList?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    optOutUpdatedBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    expirationUnixTime?: number | null,
  } | null,
};

export type CreateUserFilterMutationVariables = {
  input: CreateUserFilterInput,
  condition?: ModelUserFilterConditionInput | null,
};

export type CreateUserFilterMutation = {
  createUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    listType: string,
    name: string,
    filterDefinitions: string,
    filterSelections: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateUserFilterMutationVariables = {
  input: UpdateUserFilterInput,
  condition?: ModelUserFilterConditionInput | null,
};

export type UpdateUserFilterMutation = {
  updateUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    listType: string,
    name: string,
    filterDefinitions: string,
    filterSelections: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteUserFilterMutationVariables = {
  input: DeleteUserFilterInput,
  condition?: ModelUserFilterConditionInput | null,
};

export type DeleteUserFilterMutation = {
  deleteUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    listType: string,
    name: string,
    filterDefinitions: string,
    filterSelections: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateExportJobMutationVariables = {
  input: CreateExportJobInput,
  condition?: ModelExportJobConditionInput | null,
};

export type CreateExportJobMutation = {
  createExportJob?:  {
    __typename: "ExportJob",
    id: string,
    exportName: string,
    listType: string,
    reportId?: string | null,
    status: string,
    statusMessage?: string | null,
    filterInput: string,
    filterFields?: string | null,
    outputFormat?: string | null,
    s3Key?: string | null,
    totalRecords?: number | null,
    fileSize?: number | null,
    startedAt?: string | null,
    expiresAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
    authorizedReaders?: Array< string > | null,
    debugInfo?: string | null,
  } | null,
};

export type UpdateExportJobMutationVariables = {
  input: UpdateExportJobInput,
  condition?: ModelExportJobConditionInput | null,
};

export type UpdateExportJobMutation = {
  updateExportJob?:  {
    __typename: "ExportJob",
    id: string,
    exportName: string,
    listType: string,
    reportId?: string | null,
    status: string,
    statusMessage?: string | null,
    filterInput: string,
    filterFields?: string | null,
    outputFormat?: string | null,
    s3Key?: string | null,
    totalRecords?: number | null,
    fileSize?: number | null,
    startedAt?: string | null,
    expiresAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
    authorizedReaders?: Array< string > | null,
    debugInfo?: string | null,
  } | null,
};

export type DeleteExportJobMutationVariables = {
  input: DeleteExportJobInput,
  condition?: ModelExportJobConditionInput | null,
};

export type DeleteExportJobMutation = {
  deleteExportJob?:  {
    __typename: "ExportJob",
    id: string,
    exportName: string,
    listType: string,
    reportId?: string | null,
    status: string,
    statusMessage?: string | null,
    filterInput: string,
    filterFields?: string | null,
    outputFormat?: string | null,
    s3Key?: string | null,
    totalRecords?: number | null,
    fileSize?: number | null,
    startedAt?: string | null,
    expiresAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
    authorizedReaders?: Array< string > | null,
    debugInfo?: string | null,
  } | null,
};

export type CreateReportRunScheduleMutationVariables = {
  input: CreateReportRunScheduleInput,
  condition?: ModelReportRunScheduleConditionInput | null,
};

export type CreateReportRunScheduleMutation = {
  createReportRunSchedule?:  {
    __typename: "ReportRunSchedule",
    id: string,
    reportId: string,
    scheduleExpression: string,
    enabled: boolean,
    subscribers: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateReportRunScheduleMutationVariables = {
  input: UpdateReportRunScheduleInput,
  condition?: ModelReportRunScheduleConditionInput | null,
};

export type UpdateReportRunScheduleMutation = {
  updateReportRunSchedule?:  {
    __typename: "ReportRunSchedule",
    id: string,
    reportId: string,
    scheduleExpression: string,
    enabled: boolean,
    subscribers: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteReportRunScheduleMutationVariables = {
  input: DeleteReportRunScheduleInput,
  condition?: ModelReportRunScheduleConditionInput | null,
};

export type DeleteReportRunScheduleMutation = {
  deleteReportRunSchedule?:  {
    __typename: "ReportRunSchedule",
    id: string,
    reportId: string,
    scheduleExpression: string,
    enabled: boolean,
    subscribers: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateHouselistNewMutationVariables = {
  input: CreateHouselistNewInput,
  condition?: ModelHouselistNewConditionInput | null,
};

export type CreateHouselistNewMutation = {
  createHouselistNew?:  {
    __typename: "HouselistNew",
    id: string,
    accountID?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    control?: string | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    hohIncome?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    hohNetWorth?: string | null,
    hohNetWorthBottom?: number | null,
    hohNetWorthTop?: number | null,
    groupName?: string | null,
    birthDate?: string | null,
    deceasedDate?: string | null,
    distanceToSite?: number | null,
    doNotCall?: boolean | null,
    email?: string | null,
    emailBounceDate?: string | null,
    epm2Grade?: number | null,
    epm2Score?: number | null,
    epm2Tier?: string | null,
    firstName?: string | null,
    gender?: string | null,
    hasOptedOutOfEmail?: boolean | null,
    hohAge?: number | null,
    homePhone?: string | null,
    contactId?: string | null,
    ilContactStatus?: string | null,
    labelSalutation?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    neighborhood?: string | null,
    city?: string | null,
    zip5?: string | null,
    zipcode?: string | null,
    state?: string | null,
    address?: string | null,
    maritalStatus?: string | null,
    mlActive?: boolean | null,
    cellPhone?: string | null,
    primaryContact?: string | null,
    primarySite?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    qasValidationStatus?: string | null,
    contactType?: string | null,
    returnedMail?: boolean | null,
    ccContactStatus?: string | null,
    opportunitySite?: string | null,
    opportunityId?: string | null,
    loc?: string | null,
    ltsGrade?: number | null,
    ltsScore?: number | null,
    primaryMotivation?: string | null,
    communityName?: string | null,
    rating?: string | null,
    segmentation?: string | null,
    settledDate?: string | null,
    salesStage?: string | null,
    priorityDate?: string | null,
    reservationDate?: string | null,
    businessType?: string | null,
    salesOptionDate?: string | null,
    apartmentName?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    mlContactInactiveReasons?: Array< string > | null,
    mlSOInactiveReasons?: Array< string > | null,
    mlInactiveReasons?: Array< string > | null,
    priorityType?: string | null,
    nextStep?: string | null,
    salesCounselor?: string | null,
    salesCounselorName?: string | null,
    timeframe?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateHouselistNewMutationVariables = {
  input: UpdateHouselistNewInput,
  condition?: ModelHouselistNewConditionInput | null,
};

export type UpdateHouselistNewMutation = {
  updateHouselistNew?:  {
    __typename: "HouselistNew",
    id: string,
    accountID?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    control?: string | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    hohIncome?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    hohNetWorth?: string | null,
    hohNetWorthBottom?: number | null,
    hohNetWorthTop?: number | null,
    groupName?: string | null,
    birthDate?: string | null,
    deceasedDate?: string | null,
    distanceToSite?: number | null,
    doNotCall?: boolean | null,
    email?: string | null,
    emailBounceDate?: string | null,
    epm2Grade?: number | null,
    epm2Score?: number | null,
    epm2Tier?: string | null,
    firstName?: string | null,
    gender?: string | null,
    hasOptedOutOfEmail?: boolean | null,
    hohAge?: number | null,
    homePhone?: string | null,
    contactId?: string | null,
    ilContactStatus?: string | null,
    labelSalutation?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    neighborhood?: string | null,
    city?: string | null,
    zip5?: string | null,
    zipcode?: string | null,
    state?: string | null,
    address?: string | null,
    maritalStatus?: string | null,
    mlActive?: boolean | null,
    cellPhone?: string | null,
    primaryContact?: string | null,
    primarySite?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    qasValidationStatus?: string | null,
    contactType?: string | null,
    returnedMail?: boolean | null,
    ccContactStatus?: string | null,
    opportunitySite?: string | null,
    opportunityId?: string | null,
    loc?: string | null,
    ltsGrade?: number | null,
    ltsScore?: number | null,
    primaryMotivation?: string | null,
    communityName?: string | null,
    rating?: string | null,
    segmentation?: string | null,
    settledDate?: string | null,
    salesStage?: string | null,
    priorityDate?: string | null,
    reservationDate?: string | null,
    businessType?: string | null,
    salesOptionDate?: string | null,
    apartmentName?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    mlContactInactiveReasons?: Array< string > | null,
    mlSOInactiveReasons?: Array< string > | null,
    mlInactiveReasons?: Array< string > | null,
    priorityType?: string | null,
    nextStep?: string | null,
    salesCounselor?: string | null,
    salesCounselorName?: string | null,
    timeframe?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteHouselistNewMutationVariables = {
  input: DeleteHouselistNewInput,
  condition?: ModelHouselistNewConditionInput | null,
};

export type DeleteHouselistNewMutation = {
  deleteHouselistNew?:  {
    __typename: "HouselistNew",
    id: string,
    accountID?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    control?: string | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    hohIncome?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    hohNetWorth?: string | null,
    hohNetWorthBottom?: number | null,
    hohNetWorthTop?: number | null,
    groupName?: string | null,
    birthDate?: string | null,
    deceasedDate?: string | null,
    distanceToSite?: number | null,
    doNotCall?: boolean | null,
    email?: string | null,
    emailBounceDate?: string | null,
    epm2Grade?: number | null,
    epm2Score?: number | null,
    epm2Tier?: string | null,
    firstName?: string | null,
    gender?: string | null,
    hasOptedOutOfEmail?: boolean | null,
    hohAge?: number | null,
    homePhone?: string | null,
    contactId?: string | null,
    ilContactStatus?: string | null,
    labelSalutation?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    neighborhood?: string | null,
    city?: string | null,
    zip5?: string | null,
    zipcode?: string | null,
    state?: string | null,
    address?: string | null,
    maritalStatus?: string | null,
    mlActive?: boolean | null,
    cellPhone?: string | null,
    primaryContact?: string | null,
    primarySite?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    qasValidationStatus?: string | null,
    contactType?: string | null,
    returnedMail?: boolean | null,
    ccContactStatus?: string | null,
    opportunitySite?: string | null,
    opportunityId?: string | null,
    loc?: string | null,
    ltsGrade?: number | null,
    ltsScore?: number | null,
    primaryMotivation?: string | null,
    communityName?: string | null,
    rating?: string | null,
    segmentation?: string | null,
    settledDate?: string | null,
    salesStage?: string | null,
    priorityDate?: string | null,
    reservationDate?: string | null,
    businessType?: string | null,
    salesOptionDate?: string | null,
    apartmentName?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    mlContactInactiveReasons?: Array< string > | null,
    mlSOInactiveReasons?: Array< string > | null,
    mlInactiveReasons?: Array< string > | null,
    priorityType?: string | null,
    nextStep?: string | null,
    salesCounselor?: string | null,
    salesCounselorName?: string | null,
    timeframe?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateAccountMutationVariables = {
  input: CreateAccountInput,
  condition?: ModelAccountConditionInput | null,
};

export type CreateAccountMutation = {
  createAccount?:  {
    __typename: "Account",
    updateHash?: string | null,
    accountID: string,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    accountNameId: string,
    homeValueTop?: string | null,
    letterSaluation: string,
    numberOfParticipants: number,
    primaryContact: string,
    lastModifiedDate: string,
    otherInterestsMotivation?: string | null,
    createdDate: string,
    controlFlag: boolean,
    hobbiesInterest?: string | null,
    primarySite?: string | null,
    hohNetRange?: string | null,
    homeValueRange?: string | null,
    hohNetWorthTop?: number | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    accountName: string,
    hohIncomeTop?: number | null,
    hohNetWorthBottom?: number | null,
    parentAccountID?: string | null,
    returnedMail: boolean,
    type: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateAccountMutationVariables = {
  input: UpdateAccountInput,
  condition?: ModelAccountConditionInput | null,
};

export type UpdateAccountMutation = {
  updateAccount?:  {
    __typename: "Account",
    updateHash?: string | null,
    accountID: string,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    accountNameId: string,
    homeValueTop?: string | null,
    letterSaluation: string,
    numberOfParticipants: number,
    primaryContact: string,
    lastModifiedDate: string,
    otherInterestsMotivation?: string | null,
    createdDate: string,
    controlFlag: boolean,
    hobbiesInterest?: string | null,
    primarySite?: string | null,
    hohNetRange?: string | null,
    homeValueRange?: string | null,
    hohNetWorthTop?: number | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    accountName: string,
    hohIncomeTop?: number | null,
    hohNetWorthBottom?: number | null,
    parentAccountID?: string | null,
    returnedMail: boolean,
    type: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteAccountMutationVariables = {
  input: DeleteAccountInput,
  condition?: ModelAccountConditionInput | null,
};

export type DeleteAccountMutation = {
  deleteAccount?:  {
    __typename: "Account",
    updateHash?: string | null,
    accountID: string,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    accountNameId: string,
    homeValueTop?: string | null,
    letterSaluation: string,
    numberOfParticipants: number,
    primaryContact: string,
    lastModifiedDate: string,
    otherInterestsMotivation?: string | null,
    createdDate: string,
    controlFlag: boolean,
    hobbiesInterest?: string | null,
    primarySite?: string | null,
    hohNetRange?: string | null,
    homeValueRange?: string | null,
    hohNetWorthTop?: number | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    accountName: string,
    hohIncomeTop?: number | null,
    hohNetWorthBottom?: number | null,
    parentAccountID?: string | null,
    returnedMail: boolean,
    type: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateContactMutationVariables = {
  input: CreateContactInput,
  condition?: ModelContactConditionInput | null,
};

export type CreateContactMutation = {
  createContact?:  {
    __typename: "Contact",
    doNotMail: boolean,
    deceasedDate?: string | null,
    birthDate?: string | null,
    lastName: string,
    status: string,
    emailBounceBack: boolean,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    letterSaluation: string,
    hohNetWorth?: string | null,
    contactID: string,
    hohAge?: number | null,
    primaryFlag: string,
    lastModifiedDate: string,
    mailingStreet: string,
    mailingState: string,
    preferredContactMethod?: string | null,
    epm2Score?: number | null,
    ilContactStatus: string,
    emailBounceBackDate?: string | null,
    fullName: string,
    primarySite?: string | null,
    homeValueRange?: string | null,
    maritalStatus?: string | null,
    mailingCountry: string,
    militaryService?: boolean | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    qasLongitude?: string | null,
    hasOptedOutOfEmail: boolean,
    mailingCountryCode: string,
    returnedMail: boolean,
    mobilePhone?: string | null,
    accountID: string,
    qasMailingValidationStatus: string,
    email?: string | null,
    homeValueTop?: number | null,
    firstName: string,
    mailingCity: string,
    doNotCall: boolean,
    salutation?: string | null,
    mlActive?: boolean | null,
    homePhone?: string | null,
    placeOfBirth?: string | null,
    masterRecordID?: string | null,
    emailOptOutDate?: string | null,
    gender?: string | null,
    qasLatitude?: string | null,
    hohNetWorthTop?: number | null,
    mailingZipCode: string,
    mailingNeighborhood?: string | null,
    contactType: string,
    hohNetWorthBottom?: number | null,
    epm2Decile?: number | null,
    mailingStateCode: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateContactMutationVariables = {
  input: UpdateContactInput,
  condition?: ModelContactConditionInput | null,
};

export type UpdateContactMutation = {
  updateContact?:  {
    __typename: "Contact",
    doNotMail: boolean,
    deceasedDate?: string | null,
    birthDate?: string | null,
    lastName: string,
    status: string,
    emailBounceBack: boolean,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    letterSaluation: string,
    hohNetWorth?: string | null,
    contactID: string,
    hohAge?: number | null,
    primaryFlag: string,
    lastModifiedDate: string,
    mailingStreet: string,
    mailingState: string,
    preferredContactMethod?: string | null,
    epm2Score?: number | null,
    ilContactStatus: string,
    emailBounceBackDate?: string | null,
    fullName: string,
    primarySite?: string | null,
    homeValueRange?: string | null,
    maritalStatus?: string | null,
    mailingCountry: string,
    militaryService?: boolean | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    qasLongitude?: string | null,
    hasOptedOutOfEmail: boolean,
    mailingCountryCode: string,
    returnedMail: boolean,
    mobilePhone?: string | null,
    accountID: string,
    qasMailingValidationStatus: string,
    email?: string | null,
    homeValueTop?: number | null,
    firstName: string,
    mailingCity: string,
    doNotCall: boolean,
    salutation?: string | null,
    mlActive?: boolean | null,
    homePhone?: string | null,
    placeOfBirth?: string | null,
    masterRecordID?: string | null,
    emailOptOutDate?: string | null,
    gender?: string | null,
    qasLatitude?: string | null,
    hohNetWorthTop?: number | null,
    mailingZipCode: string,
    mailingNeighborhood?: string | null,
    contactType: string,
    hohNetWorthBottom?: number | null,
    epm2Decile?: number | null,
    mailingStateCode: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteContactMutationVariables = {
  input: DeleteContactInput,
  condition?: ModelContactConditionInput | null,
};

export type DeleteContactMutation = {
  deleteContact?:  {
    __typename: "Contact",
    doNotMail: boolean,
    deceasedDate?: string | null,
    birthDate?: string | null,
    lastName: string,
    status: string,
    emailBounceBack: boolean,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    letterSaluation: string,
    hohNetWorth?: string | null,
    contactID: string,
    hohAge?: number | null,
    primaryFlag: string,
    lastModifiedDate: string,
    mailingStreet: string,
    mailingState: string,
    preferredContactMethod?: string | null,
    epm2Score?: number | null,
    ilContactStatus: string,
    emailBounceBackDate?: string | null,
    fullName: string,
    primarySite?: string | null,
    homeValueRange?: string | null,
    maritalStatus?: string | null,
    mailingCountry: string,
    militaryService?: boolean | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    qasLongitude?: string | null,
    hasOptedOutOfEmail: boolean,
    mailingCountryCode: string,
    returnedMail: boolean,
    mobilePhone?: string | null,
    accountID: string,
    qasMailingValidationStatus: string,
    email?: string | null,
    homeValueTop?: number | null,
    firstName: string,
    mailingCity: string,
    doNotCall: boolean,
    salutation?: string | null,
    mlActive?: boolean | null,
    homePhone?: string | null,
    placeOfBirth?: string | null,
    masterRecordID?: string | null,
    emailOptOutDate?: string | null,
    gender?: string | null,
    qasLatitude?: string | null,
    hohNetWorthTop?: number | null,
    mailingZipCode: string,
    mailingNeighborhood?: string | null,
    contactType: string,
    hohNetWorthBottom?: number | null,
    epm2Decile?: number | null,
    mailingStateCode: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateSalesOptionMutationVariables = {
  input: CreateSalesOptionInput,
  condition?: ModelSalesOptionConditionInput | null,
};

export type CreateSalesOptionMutation = {
  createSalesOption?:  {
    __typename: "SalesOption",
    lossReason?: string | null,
    createdDate: string,
    accountID: string,
    apartment?: string | null,
    apartmentName?: string | null,
    rating?: string | null,
    community: string,
    settledDate?: string | null,
    requestedMailOfBrochure: boolean,
    isDeleted: boolean,
    sourceID: string,
    reservationDate?: string | null,
    reservedMSP?: string | null,
    salesOptionName: string,
    priorityDepCommunity?: string | null,
    ltsScore?: number | null,
    ltsGrade?: number | null,
    lastModifiedDate: string,
    campaignID?: string | null,
    priorityDate?: string | null,
    segmentation?: string | null,
    levelOfCare: string,
    mergeFlag: boolean,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateSalesOptionMutationVariables = {
  input: UpdateSalesOptionInput,
  condition?: ModelSalesOptionConditionInput | null,
};

export type UpdateSalesOptionMutation = {
  updateSalesOption?:  {
    __typename: "SalesOption",
    lossReason?: string | null,
    createdDate: string,
    accountID: string,
    apartment?: string | null,
    apartmentName?: string | null,
    rating?: string | null,
    community: string,
    settledDate?: string | null,
    requestedMailOfBrochure: boolean,
    isDeleted: boolean,
    sourceID: string,
    reservationDate?: string | null,
    reservedMSP?: string | null,
    salesOptionName: string,
    priorityDepCommunity?: string | null,
    ltsScore?: number | null,
    ltsGrade?: number | null,
    lastModifiedDate: string,
    campaignID?: string | null,
    priorityDate?: string | null,
    segmentation?: string | null,
    levelOfCare: string,
    mergeFlag: boolean,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteSalesOptionMutationVariables = {
  input: DeleteSalesOptionInput,
  condition?: ModelSalesOptionConditionInput | null,
};

export type DeleteSalesOptionMutation = {
  deleteSalesOption?:  {
    __typename: "SalesOption",
    lossReason?: string | null,
    createdDate: string,
    accountID: string,
    apartment?: string | null,
    apartmentName?: string | null,
    rating?: string | null,
    community: string,
    settledDate?: string | null,
    requestedMailOfBrochure: boolean,
    isDeleted: boolean,
    sourceID: string,
    reservationDate?: string | null,
    reservedMSP?: string | null,
    salesOptionName: string,
    priorityDepCommunity?: string | null,
    ltsScore?: number | null,
    ltsGrade?: number | null,
    lastModifiedDate: string,
    campaignID?: string | null,
    priorityDate?: string | null,
    segmentation?: string | null,
    levelOfCare: string,
    mergeFlag: boolean,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateStaffSeedMutationVariables = {
  input: CreateStaffSeedInput,
  condition?: ModelStaffSeedConditionInput | null,
};

export type CreateStaffSeedMutation = {
  createStaffSeed?:  {
    __typename: "StaffSeed",
    id?: string | null,
    address?: string | null,
    city?: string | null,
    community?: string | null,
    createdby?: string | null,
    email?: string | null,
    firstName?: string | null,
    labelSalutation?: string | null,
    lastModifiedBy?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    loc?: string | null,
    owner?: string | null,
    postalCode?: string | null,
    seedDataName?: string | null,
    state?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateStaffSeedMutationVariables = {
  input: UpdateStaffSeedInput,
  condition?: ModelStaffSeedConditionInput | null,
};

export type UpdateStaffSeedMutation = {
  updateStaffSeed?:  {
    __typename: "StaffSeed",
    id?: string | null,
    address?: string | null,
    city?: string | null,
    community?: string | null,
    createdby?: string | null,
    email?: string | null,
    firstName?: string | null,
    labelSalutation?: string | null,
    lastModifiedBy?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    loc?: string | null,
    owner?: string | null,
    postalCode?: string | null,
    seedDataName?: string | null,
    state?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteStaffSeedMutationVariables = {
  input: DeleteStaffSeedInput,
  condition?: ModelStaffSeedConditionInput | null,
};

export type DeleteStaffSeedMutation = {
  deleteStaffSeed?:  {
    __typename: "StaffSeed",
    id?: string | null,
    address?: string | null,
    city?: string | null,
    community?: string | null,
    createdby?: string | null,
    email?: string | null,
    firstName?: string | null,
    labelSalutation?: string | null,
    lastModifiedBy?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    loc?: string | null,
    owner?: string | null,
    postalCode?: string | null,
    seedDataName?: string | null,
    state?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDistanceToSiteMutationVariables = {
  input: CreateDistanceToSiteInput,
  condition?: ModelDistanceToSiteConditionInput | null,
};

export type CreateDistanceToSiteMutation = {
  createDistanceToSite?:  {
    __typename: "DistanceToSite",
    distanceToSiteId?: string | null,
    distance?: number | null,
    site?: string | null,
    communityId?: string | null,
    createdDate?: string | null,
    isDeleted?: string | null,
    lastModifiedDate?: string | null,
    contactId?: string | null,
    name?: string | null,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateDistanceToSiteMutationVariables = {
  input: UpdateDistanceToSiteInput,
  condition?: ModelDistanceToSiteConditionInput | null,
};

export type UpdateDistanceToSiteMutation = {
  updateDistanceToSite?:  {
    __typename: "DistanceToSite",
    distanceToSiteId?: string | null,
    distance?: number | null,
    site?: string | null,
    communityId?: string | null,
    createdDate?: string | null,
    isDeleted?: string | null,
    lastModifiedDate?: string | null,
    contactId?: string | null,
    name?: string | null,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteDistanceToSiteMutationVariables = {
  input: DeleteDistanceToSiteInput,
  condition?: ModelDistanceToSiteConditionInput | null,
};

export type DeleteDistanceToSiteMutation = {
  deleteDistanceToSite?:  {
    __typename: "DistanceToSite",
    distanceToSiteId?: string | null,
    distance?: number | null,
    site?: string | null,
    communityId?: string | null,
    createdDate?: string | null,
    isDeleted?: string | null,
    lastModifiedDate?: string | null,
    contactId?: string | null,
    name?: string | null,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateFilterValueMutationVariables = {
  input: CreateFilterValueInput,
  condition?: ModelFilterValueConditionInput | null,
};

export type CreateFilterValueMutation = {
  createFilterValue?:  {
    __typename: "FilterValue",
    listType: string,
    fieldId: string,
    version: string,
    selectedValues: Array< string >,
    relationalOperator?: string | null,
    description?: string | null,
    changeReason?: string | null,
    changedBy: string,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFilterValueMutationVariables = {
  input: UpdateFilterValueInput,
  condition?: ModelFilterValueConditionInput | null,
};

export type UpdateFilterValueMutation = {
  updateFilterValue?:  {
    __typename: "FilterValue",
    listType: string,
    fieldId: string,
    version: string,
    selectedValues: Array< string >,
    relationalOperator?: string | null,
    description?: string | null,
    changeReason?: string | null,
    changedBy: string,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFilterValueMutationVariables = {
  input: DeleteFilterValueInput,
  condition?: ModelFilterValueConditionInput | null,
};

export type DeleteFilterValueMutation = {
  deleteFilterValue?:  {
    __typename: "FilterValue",
    listType: string,
    fieldId: string,
    version: string,
    selectedValues: Array< string >,
    relationalOperator?: string | null,
    description?: string | null,
    changeReason?: string | null,
    changedBy: string,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFlagDefinitionMutationVariables = {
  input: CreateFlagDefinitionInput,
  condition?: ModelFlagDefinitionConditionInput | null,
};

export type CreateFlagDefinitionMutation = {
  createFlagDefinition?:  {
    __typename: "FlagDefinition",
    id: string,
    listType: string,
    fieldName: string,
    flagValue: string,
    friendlyName: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFlagDefinitionMutationVariables = {
  input: UpdateFlagDefinitionInput,
  condition?: ModelFlagDefinitionConditionInput | null,
};

export type UpdateFlagDefinitionMutation = {
  updateFlagDefinition?:  {
    __typename: "FlagDefinition",
    id: string,
    listType: string,
    fieldName: string,
    flagValue: string,
    friendlyName: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFlagDefinitionMutationVariables = {
  input: DeleteFlagDefinitionInput,
  condition?: ModelFlagDefinitionConditionInput | null,
};

export type DeleteFlagDefinitionMutation = {
  deleteFlagDefinition?:  {
    __typename: "FlagDefinition",
    id: string,
    listType: string,
    fieldName: string,
    flagValue: string,
    friendlyName: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDataTransferStageMutationVariables = {
  input: CreateDataTransferStageInput,
  condition?: ModelDataTransferStageConditionInput | null,
};

export type CreateDataTransferStageMutation = {
  createDataTransferStage?:  {
    __typename: "DataTransferStage",
    id: string,
    traceId: string,
    fileKey?: string | null,
    totalInputRecords?: number | null,
    indexStart?: number | null,
    indexEnd?: number | null,
    addedCount?: number | null,
    updatedCount?: number | null,
    failedCount?: number | null,
    failureReason?: string | null,
    source?: string | null,
    expirationUnixTime?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDataTransferStageMutationVariables = {
  input: UpdateDataTransferStageInput,
  condition?: ModelDataTransferStageConditionInput | null,
};

export type UpdateDataTransferStageMutation = {
  updateDataTransferStage?:  {
    __typename: "DataTransferStage",
    id: string,
    traceId: string,
    fileKey?: string | null,
    totalInputRecords?: number | null,
    indexStart?: number | null,
    indexEnd?: number | null,
    addedCount?: number | null,
    updatedCount?: number | null,
    failedCount?: number | null,
    failureReason?: string | null,
    source?: string | null,
    expirationUnixTime?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDataTransferStageMutationVariables = {
  input: DeleteDataTransferStageInput,
  condition?: ModelDataTransferStageConditionInput | null,
};

export type DeleteDataTransferStageMutation = {
  deleteDataTransferStage?:  {
    __typename: "DataTransferStage",
    id: string,
    traceId: string,
    fileKey?: string | null,
    totalInputRecords?: number | null,
    indexStart?: number | null,
    indexEnd?: number | null,
    addedCount?: number | null,
    updatedCount?: number | null,
    failedCount?: number | null,
    failureReason?: string | null,
    source?: string | null,
    expirationUnixTime?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateExclusionRuleMutationVariables = {
  input: CreateExclusionRuleInput,
  condition?: ModelExclusionRuleConditionInput | null,
};

export type CreateExclusionRuleMutation = {
  createExclusionRule?:  {
    __typename: "ExclusionRule",
    id: string,
    listType: string,
    fieldName: string,
    excludedValues: Array< string >,
    operator: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateExclusionRuleMutationVariables = {
  input: UpdateExclusionRuleInput,
  condition?: ModelExclusionRuleConditionInput | null,
};

export type UpdateExclusionRuleMutation = {
  updateExclusionRule?:  {
    __typename: "ExclusionRule",
    id: string,
    listType: string,
    fieldName: string,
    excludedValues: Array< string >,
    operator: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteExclusionRuleMutationVariables = {
  input: DeleteExclusionRuleInput,
  condition?: ModelExclusionRuleConditionInput | null,
};

export type DeleteExclusionRuleMutation = {
  deleteExclusionRule?:  {
    __typename: "ExclusionRule",
    id: string,
    listType: string,
    fieldName: string,
    excludedValues: Array< string >,
    operator: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type InvokeFileManagerLambdaMutationVariables = {
  input: string,
};

export type InvokeFileManagerLambdaMutation = {
  invokeFileManagerLambda?: string | null,
};

export type GetAggregatedResultQueryVariables = {
  openSearchIndex: string,
  groupByText?: Array< string > | null,
  groupByNumeric?: Array< string > | null,
  filter?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type GetAggregatedResultQuery = {
  getAggregatedResult?:  {
    __typename: "AggregatedResult",
    items?:  Array< {
      __typename: "AggregationBucket",
      key?: string | null,
      doc_count?: number | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetBLConcurrencyLockQueryVariables = {
  community: string,
};

export type GetBLConcurrencyLockQuery = {
  getBLConcurrencyLock?:  {
    __typename: "BLConcurrencyLock",
    community: string,
    lockToken?: string | null,
    createdAt?: string | null,
    expirationUnixTime?: number | null,
    updatedAt: string,
  } | null,
};

export type ListBLConcurrencyLocksQueryVariables = {
  community?: string | null,
  filter?: ModelBLConcurrencyLockFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBLConcurrencyLocksQuery = {
  listBLConcurrencyLocks?:  {
    __typename: "ModelBLConcurrencyLockConnection",
    items:  Array< {
      __typename: "BLConcurrencyLock",
      community: string,
      lockToken?: string | null,
      createdAt?: string | null,
      expirationUnixTime?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBoughtListQueryVariables = {
  id: string,
};

export type GetBoughtListQuery = {
  getBoughtList?:  {
    __typename: "BoughtList",
    id: string,
    saluation?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    gender?: string | null,
    age?: number | null,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    county?: string | null,
    householdIncome?: string | null,
    householdIncomeBottom?: number | null,
    householdIncomeTop?: number | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    boatingSailing?: string | null,
    tennis?: string | null,
    golf?: string | null,
    boatOwner?: string | null,
    upscaleLiving?: string | null,
    suppress?: string | null,
    doNotMail?: string | null,
    dropDate?: string | null,
    zip5?: string | null,
    batchCode?: string | null,
    listDate?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    qseq?: number | null,
    expirationDate?: string | null,
    lastUpdated?: string | null,
    site1?: string | null,
    siteDistance1?: number | null,
    epm3Decile1?: number | null,
    epm3Score1?: number | null,
    epm3Tier1?: string | null,
    site2?: string | null,
    siteDistance2?: string | null,
    epm3Decile2?: number | null,
    epm3Score2?: number | null,
    epm3Tier2?: string | null,
    blSelect?: string | null,
    hlMatch?: string | null,
    randomNumber?: number | null,
    randomFlag?: number | null,
    netNewFlag?: number | null,
    staticControlFlag?: string | null,
    hlGrpRowList?: string | null,
    hlODateList?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    optOutUpdatedBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    expirationUnixTime?: number | null,
  } | null,
};

export type ListBoughtListsQueryVariables = {
  filter?: ModelBoughtListFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBoughtListsQuery = {
  listBoughtLists?:  {
    __typename: "ModelBoughtListConnection",
    items:  Array< {
      __typename: "BoughtList",
      id: string,
      saluation?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      gender?: string | null,
      age?: number | null,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      county?: string | null,
      householdIncome?: string | null,
      householdIncomeBottom?: number | null,
      householdIncomeTop?: number | null,
      homeValue?: string | null,
      homeValueBottom?: number | null,
      homeValueTop?: number | null,
      boatingSailing?: string | null,
      tennis?: string | null,
      golf?: string | null,
      boatOwner?: string | null,
      upscaleLiving?: string | null,
      suppress?: string | null,
      doNotMail?: string | null,
      dropDate?: string | null,
      zip5?: string | null,
      batchCode?: string | null,
      listDate?: string | null,
      listName?: string | null,
      listNameId?: string | null,
      qseq?: number | null,
      expirationDate?: string | null,
      lastUpdated?: string | null,
      site1?: string | null,
      siteDistance1?: number | null,
      epm3Decile1?: number | null,
      epm3Score1?: number | null,
      epm3Tier1?: string | null,
      site2?: string | null,
      siteDistance2?: string | null,
      epm3Decile2?: number | null,
      epm3Score2?: number | null,
      epm3Tier2?: string | null,
      blSelect?: string | null,
      hlMatch?: string | null,
      randomNumber?: number | null,
      randomFlag?: number | null,
      netNewFlag?: number | null,
      staticControlFlag?: string | null,
      hlGrpRowList?: string | null,
      hlODateList?: string | null,
      optOut?: boolean | null,
      optOutDateTime?: string | null,
      optOutUpdatedBy?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      expirationUnixTime?: number | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchBoughtListsQueryVariables = {
  filter?: SearchableBoughtListFilterInput | null,
  sort?: Array< SearchableBoughtListSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableBoughtListAggregationInput | null > | null,
};

export type SearchBoughtListsQuery = {
  searchBoughtLists?:  {
    __typename: "SearchableBoughtListConnection",
    items:  Array< {
      __typename: "BoughtList",
      id: string,
      saluation?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      gender?: string | null,
      age?: number | null,
      address?: string | null,
      city?: string | null,
      state?: string | null,
      zipcode?: string | null,
      county?: string | null,
      householdIncome?: string | null,
      householdIncomeBottom?: number | null,
      householdIncomeTop?: number | null,
      homeValue?: string | null,
      homeValueBottom?: number | null,
      homeValueTop?: number | null,
      boatingSailing?: string | null,
      tennis?: string | null,
      golf?: string | null,
      boatOwner?: string | null,
      upscaleLiving?: string | null,
      suppress?: string | null,
      doNotMail?: string | null,
      dropDate?: string | null,
      zip5?: string | null,
      batchCode?: string | null,
      listDate?: string | null,
      listName?: string | null,
      listNameId?: string | null,
      qseq?: number | null,
      expirationDate?: string | null,
      lastUpdated?: string | null,
      site1?: string | null,
      siteDistance1?: number | null,
      epm3Decile1?: number | null,
      epm3Score1?: number | null,
      epm3Tier1?: string | null,
      site2?: string | null,
      siteDistance2?: string | null,
      epm3Decile2?: number | null,
      epm3Score2?: number | null,
      epm3Tier2?: string | null,
      blSelect?: string | null,
      hlMatch?: string | null,
      randomNumber?: number | null,
      randomFlag?: number | null,
      netNewFlag?: number | null,
      staticControlFlag?: string | null,
      hlGrpRowList?: string | null,
      hlODateList?: string | null,
      optOut?: boolean | null,
      optOutDateTime?: string | null,
      optOutUpdatedBy?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      expirationUnixTime?: number | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetUserFilterQueryVariables = {
  id: string,
};

export type GetUserFilterQuery = {
  getUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    listType: string,
    name: string,
    filterDefinitions: string,
    filterSelections: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListUserFiltersQueryVariables = {
  filter?: ModelUserFilterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFiltersQuery = {
  listUserFilters?:  {
    __typename: "ModelUserFilterConnection",
    items:  Array< {
      __typename: "UserFilter",
      id: string,
      listType: string,
      name: string,
      filterDefinitions: string,
      filterSelections: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchUserFiltersQueryVariables = {
  filter?: SearchableUserFilterFilterInput | null,
  sort?: Array< SearchableUserFilterSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableUserFilterAggregationInput | null > | null,
};

export type SearchUserFiltersQuery = {
  searchUserFilters?:  {
    __typename: "SearchableUserFilterConnection",
    items:  Array< {
      __typename: "UserFilter",
      id: string,
      listType: string,
      name: string,
      filterDefinitions: string,
      filterSelections: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetExportJobQueryVariables = {
  id: string,
};

export type GetExportJobQuery = {
  getExportJob?:  {
    __typename: "ExportJob",
    id: string,
    exportName: string,
    listType: string,
    reportId?: string | null,
    status: string,
    statusMessage?: string | null,
    filterInput: string,
    filterFields?: string | null,
    outputFormat?: string | null,
    s3Key?: string | null,
    totalRecords?: number | null,
    fileSize?: number | null,
    startedAt?: string | null,
    expiresAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
    authorizedReaders?: Array< string > | null,
    debugInfo?: string | null,
  } | null,
};

export type ListExportJobsQueryVariables = {
  filter?: ModelExportJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListExportJobsQuery = {
  listExportJobs?:  {
    __typename: "ModelExportJobConnection",
    items:  Array< {
      __typename: "ExportJob",
      id: string,
      exportName: string,
      listType: string,
      reportId?: string | null,
      status: string,
      statusMessage?: string | null,
      filterInput: string,
      filterFields?: string | null,
      outputFormat?: string | null,
      s3Key?: string | null,
      totalRecords?: number | null,
      fileSize?: number | null,
      startedAt?: string | null,
      expiresAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      owner?: string | null,
      authorizedReaders?: Array< string > | null,
      debugInfo?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchExportJobsQueryVariables = {
  filter?: SearchableExportJobFilterInput | null,
  sort?: Array< SearchableExportJobSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableExportJobAggregationInput | null > | null,
};

export type SearchExportJobsQuery = {
  searchExportJobs?:  {
    __typename: "SearchableExportJobConnection",
    items:  Array< {
      __typename: "ExportJob",
      id: string,
      exportName: string,
      listType: string,
      reportId?: string | null,
      status: string,
      statusMessage?: string | null,
      filterInput: string,
      filterFields?: string | null,
      outputFormat?: string | null,
      s3Key?: string | null,
      totalRecords?: number | null,
      fileSize?: number | null,
      startedAt?: string | null,
      expiresAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      owner?: string | null,
      authorizedReaders?: Array< string > | null,
      debugInfo?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetReportRunScheduleQueryVariables = {
  id: string,
};

export type GetReportRunScheduleQuery = {
  getReportRunSchedule?:  {
    __typename: "ReportRunSchedule",
    id: string,
    reportId: string,
    scheduleExpression: string,
    enabled: boolean,
    subscribers: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListReportRunSchedulesQueryVariables = {
  id?: string | null,
  filter?: ModelReportRunScheduleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListReportRunSchedulesQuery = {
  listReportRunSchedules?:  {
    __typename: "ModelReportRunScheduleConnection",
    items:  Array< {
      __typename: "ReportRunSchedule",
      id: string,
      reportId: string,
      scheduleExpression: string,
      enabled: boolean,
      subscribers: Array< string >,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ReportRunSchedulesByReportIdQueryVariables = {
  reportId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelReportRunScheduleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ReportRunSchedulesByReportIdQuery = {
  reportRunSchedulesByReportId?:  {
    __typename: "ModelReportRunScheduleConnection",
    items:  Array< {
      __typename: "ReportRunSchedule",
      id: string,
      reportId: string,
      scheduleExpression: string,
      enabled: boolean,
      subscribers: Array< string >,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHouselistNewQueryVariables = {
  id: string,
};

export type GetHouselistNewQuery = {
  getHouselistNew?:  {
    __typename: "HouselistNew",
    id: string,
    accountID?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    control?: string | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    hohIncome?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    hohNetWorth?: string | null,
    hohNetWorthBottom?: number | null,
    hohNetWorthTop?: number | null,
    groupName?: string | null,
    birthDate?: string | null,
    deceasedDate?: string | null,
    distanceToSite?: number | null,
    doNotCall?: boolean | null,
    email?: string | null,
    emailBounceDate?: string | null,
    epm2Grade?: number | null,
    epm2Score?: number | null,
    epm2Tier?: string | null,
    firstName?: string | null,
    gender?: string | null,
    hasOptedOutOfEmail?: boolean | null,
    hohAge?: number | null,
    homePhone?: string | null,
    contactId?: string | null,
    ilContactStatus?: string | null,
    labelSalutation?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    neighborhood?: string | null,
    city?: string | null,
    zip5?: string | null,
    zipcode?: string | null,
    state?: string | null,
    address?: string | null,
    maritalStatus?: string | null,
    mlActive?: boolean | null,
    cellPhone?: string | null,
    primaryContact?: string | null,
    primarySite?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    qasValidationStatus?: string | null,
    contactType?: string | null,
    returnedMail?: boolean | null,
    ccContactStatus?: string | null,
    opportunitySite?: string | null,
    opportunityId?: string | null,
    loc?: string | null,
    ltsGrade?: number | null,
    ltsScore?: number | null,
    primaryMotivation?: string | null,
    communityName?: string | null,
    rating?: string | null,
    segmentation?: string | null,
    settledDate?: string | null,
    salesStage?: string | null,
    priorityDate?: string | null,
    reservationDate?: string | null,
    businessType?: string | null,
    salesOptionDate?: string | null,
    apartmentName?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    mlContactInactiveReasons?: Array< string > | null,
    mlSOInactiveReasons?: Array< string > | null,
    mlInactiveReasons?: Array< string > | null,
    priorityType?: string | null,
    nextStep?: string | null,
    salesCounselor?: string | null,
    salesCounselorName?: string | null,
    timeframe?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListHouselistNewsQueryVariables = {
  filter?: ModelHouselistNewFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHouselistNewsQuery = {
  listHouselistNews?:  {
    __typename: "ModelHouselistNewConnection",
    items:  Array< {
      __typename: "HouselistNew",
      id: string,
      accountID?: string | null,
      listName?: string | null,
      listNameId?: string | null,
      control?: string | null,
      homeValue?: string | null,
      homeValueBottom?: number | null,
      homeValueTop?: number | null,
      hohIncome?: string | null,
      hohIncomeBottom?: number | null,
      hohIncomeTop?: number | null,
      hohNetWorth?: string | null,
      hohNetWorthBottom?: number | null,
      hohNetWorthTop?: number | null,
      groupName?: string | null,
      birthDate?: string | null,
      deceasedDate?: string | null,
      distanceToSite?: number | null,
      doNotCall?: boolean | null,
      email?: string | null,
      emailBounceDate?: string | null,
      epm2Grade?: number | null,
      epm2Score?: number | null,
      epm2Tier?: string | null,
      firstName?: string | null,
      gender?: string | null,
      hasOptedOutOfEmail?: boolean | null,
      hohAge?: number | null,
      homePhone?: string | null,
      contactId?: string | null,
      ilContactStatus?: string | null,
      labelSalutation?: string | null,
      lastName?: string | null,
      letterSalutation?: string | null,
      neighborhood?: string | null,
      city?: string | null,
      zip5?: string | null,
      zipcode?: string | null,
      state?: string | null,
      address?: string | null,
      maritalStatus?: string | null,
      mlActive?: boolean | null,
      cellPhone?: string | null,
      primaryContact?: string | null,
      primarySite?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      qasValidationStatus?: string | null,
      contactType?: string | null,
      returnedMail?: boolean | null,
      ccContactStatus?: string | null,
      opportunitySite?: string | null,
      opportunityId?: string | null,
      loc?: string | null,
      ltsGrade?: number | null,
      ltsScore?: number | null,
      primaryMotivation?: string | null,
      communityName?: string | null,
      rating?: string | null,
      segmentation?: string | null,
      settledDate?: string | null,
      salesStage?: string | null,
      priorityDate?: string | null,
      reservationDate?: string | null,
      businessType?: string | null,
      salesOptionDate?: string | null,
      apartmentName?: string | null,
      optOut?: boolean | null,
      optOutDateTime?: string | null,
      mlContactInactiveReasons?: Array< string > | null,
      mlSOInactiveReasons?: Array< string > | null,
      mlInactiveReasons?: Array< string > | null,
      priorityType?: string | null,
      nextStep?: string | null,
      salesCounselor?: string | null,
      salesCounselorName?: string | null,
      timeframe?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchHouselistNewsQueryVariables = {
  filter?: SearchableHouselistNewFilterInput | null,
  sort?: Array< SearchableHouselistNewSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableHouselistNewAggregationInput | null > | null,
};

export type SearchHouselistNewsQuery = {
  searchHouselistNews?:  {
    __typename: "SearchableHouselistNewConnection",
    items:  Array< {
      __typename: "HouselistNew",
      id: string,
      accountID?: string | null,
      listName?: string | null,
      listNameId?: string | null,
      control?: string | null,
      homeValue?: string | null,
      homeValueBottom?: number | null,
      homeValueTop?: number | null,
      hohIncome?: string | null,
      hohIncomeBottom?: number | null,
      hohIncomeTop?: number | null,
      hohNetWorth?: string | null,
      hohNetWorthBottom?: number | null,
      hohNetWorthTop?: number | null,
      groupName?: string | null,
      birthDate?: string | null,
      deceasedDate?: string | null,
      distanceToSite?: number | null,
      doNotCall?: boolean | null,
      email?: string | null,
      emailBounceDate?: string | null,
      epm2Grade?: number | null,
      epm2Score?: number | null,
      epm2Tier?: string | null,
      firstName?: string | null,
      gender?: string | null,
      hasOptedOutOfEmail?: boolean | null,
      hohAge?: number | null,
      homePhone?: string | null,
      contactId?: string | null,
      ilContactStatus?: string | null,
      labelSalutation?: string | null,
      lastName?: string | null,
      letterSalutation?: string | null,
      neighborhood?: string | null,
      city?: string | null,
      zip5?: string | null,
      zipcode?: string | null,
      state?: string | null,
      address?: string | null,
      maritalStatus?: string | null,
      mlActive?: boolean | null,
      cellPhone?: string | null,
      primaryContact?: string | null,
      primarySite?: string | null,
      latitude?: number | null,
      longitude?: number | null,
      qasValidationStatus?: string | null,
      contactType?: string | null,
      returnedMail?: boolean | null,
      ccContactStatus?: string | null,
      opportunitySite?: string | null,
      opportunityId?: string | null,
      loc?: string | null,
      ltsGrade?: number | null,
      ltsScore?: number | null,
      primaryMotivation?: string | null,
      communityName?: string | null,
      rating?: string | null,
      segmentation?: string | null,
      settledDate?: string | null,
      salesStage?: string | null,
      priorityDate?: string | null,
      reservationDate?: string | null,
      businessType?: string | null,
      salesOptionDate?: string | null,
      apartmentName?: string | null,
      optOut?: boolean | null,
      optOutDateTime?: string | null,
      mlContactInactiveReasons?: Array< string > | null,
      mlSOInactiveReasons?: Array< string > | null,
      mlInactiveReasons?: Array< string > | null,
      priorityType?: string | null,
      nextStep?: string | null,
      salesCounselor?: string | null,
      salesCounselorName?: string | null,
      timeframe?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetAccountQueryVariables = {
  id: string,
};

export type GetAccountQuery = {
  getAccount?:  {
    __typename: "Account",
    updateHash?: string | null,
    accountID: string,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    accountNameId: string,
    homeValueTop?: string | null,
    letterSaluation: string,
    numberOfParticipants: number,
    primaryContact: string,
    lastModifiedDate: string,
    otherInterestsMotivation?: string | null,
    createdDate: string,
    controlFlag: boolean,
    hobbiesInterest?: string | null,
    primarySite?: string | null,
    hohNetRange?: string | null,
    homeValueRange?: string | null,
    hohNetWorthTop?: number | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    accountName: string,
    hohIncomeTop?: number | null,
    hohNetWorthBottom?: number | null,
    parentAccountID?: string | null,
    returnedMail: boolean,
    type: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListAccountsQueryVariables = {
  filter?: ModelAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAccountsQuery = {
  listAccounts?:  {
    __typename: "ModelAccountConnection",
    items:  Array< {
      __typename: "Account",
      updateHash?: string | null,
      accountID: string,
      isDeleted: boolean,
      labelSaluation: string,
      homeValueBottom?: number | null,
      accountNameId: string,
      homeValueTop?: string | null,
      letterSaluation: string,
      numberOfParticipants: number,
      primaryContact: string,
      lastModifiedDate: string,
      otherInterestsMotivation?: string | null,
      createdDate: string,
      controlFlag: boolean,
      hobbiesInterest?: string | null,
      primarySite?: string | null,
      hohNetRange?: string | null,
      homeValueRange?: string | null,
      hohNetWorthTop?: number | null,
      hohIncomeRange?: string | null,
      hohIncomeBottom?: number | null,
      accountName: string,
      hohIncomeTop?: number | null,
      hohNetWorthBottom?: number | null,
      parentAccountID?: string | null,
      returnedMail: boolean,
      type: string,
      id: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetContactQueryVariables = {
  id: string,
};

export type GetContactQuery = {
  getContact?:  {
    __typename: "Contact",
    doNotMail: boolean,
    deceasedDate?: string | null,
    birthDate?: string | null,
    lastName: string,
    status: string,
    emailBounceBack: boolean,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    letterSaluation: string,
    hohNetWorth?: string | null,
    contactID: string,
    hohAge?: number | null,
    primaryFlag: string,
    lastModifiedDate: string,
    mailingStreet: string,
    mailingState: string,
    preferredContactMethod?: string | null,
    epm2Score?: number | null,
    ilContactStatus: string,
    emailBounceBackDate?: string | null,
    fullName: string,
    primarySite?: string | null,
    homeValueRange?: string | null,
    maritalStatus?: string | null,
    mailingCountry: string,
    militaryService?: boolean | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    qasLongitude?: string | null,
    hasOptedOutOfEmail: boolean,
    mailingCountryCode: string,
    returnedMail: boolean,
    mobilePhone?: string | null,
    accountID: string,
    qasMailingValidationStatus: string,
    email?: string | null,
    homeValueTop?: number | null,
    firstName: string,
    mailingCity: string,
    doNotCall: boolean,
    salutation?: string | null,
    mlActive?: boolean | null,
    homePhone?: string | null,
    placeOfBirth?: string | null,
    masterRecordID?: string | null,
    emailOptOutDate?: string | null,
    gender?: string | null,
    qasLatitude?: string | null,
    hohNetWorthTop?: number | null,
    mailingZipCode: string,
    mailingNeighborhood?: string | null,
    contactType: string,
    hohNetWorthBottom?: number | null,
    epm2Decile?: number | null,
    mailingStateCode: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListContactsQueryVariables = {
  filter?: ModelContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListContactsQuery = {
  listContacts?:  {
    __typename: "ModelContactConnection",
    items:  Array< {
      __typename: "Contact",
      doNotMail: boolean,
      deceasedDate?: string | null,
      birthDate?: string | null,
      lastName: string,
      status: string,
      emailBounceBack: boolean,
      isDeleted: boolean,
      labelSaluation: string,
      homeValueBottom?: number | null,
      letterSaluation: string,
      hohNetWorth?: string | null,
      contactID: string,
      hohAge?: number | null,
      primaryFlag: string,
      lastModifiedDate: string,
      mailingStreet: string,
      mailingState: string,
      preferredContactMethod?: string | null,
      epm2Score?: number | null,
      ilContactStatus: string,
      emailBounceBackDate?: string | null,
      fullName: string,
      primarySite?: string | null,
      homeValueRange?: string | null,
      maritalStatus?: string | null,
      mailingCountry: string,
      militaryService?: boolean | null,
      hohIncomeRange?: string | null,
      hohIncomeBottom?: number | null,
      hohIncomeTop?: number | null,
      qasLongitude?: string | null,
      hasOptedOutOfEmail: boolean,
      mailingCountryCode: string,
      returnedMail: boolean,
      mobilePhone?: string | null,
      accountID: string,
      qasMailingValidationStatus: string,
      email?: string | null,
      homeValueTop?: number | null,
      firstName: string,
      mailingCity: string,
      doNotCall: boolean,
      salutation?: string | null,
      mlActive?: boolean | null,
      homePhone?: string | null,
      placeOfBirth?: string | null,
      masterRecordID?: string | null,
      emailOptOutDate?: string | null,
      gender?: string | null,
      qasLatitude?: string | null,
      hohNetWorthTop?: number | null,
      mailingZipCode: string,
      mailingNeighborhood?: string | null,
      contactType: string,
      hohNetWorthBottom?: number | null,
      epm2Decile?: number | null,
      mailingStateCode: string,
      id: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSalesOptionQueryVariables = {
  id: string,
};

export type GetSalesOptionQuery = {
  getSalesOption?:  {
    __typename: "SalesOption",
    lossReason?: string | null,
    createdDate: string,
    accountID: string,
    apartment?: string | null,
    apartmentName?: string | null,
    rating?: string | null,
    community: string,
    settledDate?: string | null,
    requestedMailOfBrochure: boolean,
    isDeleted: boolean,
    sourceID: string,
    reservationDate?: string | null,
    reservedMSP?: string | null,
    salesOptionName: string,
    priorityDepCommunity?: string | null,
    ltsScore?: number | null,
    ltsGrade?: number | null,
    lastModifiedDate: string,
    campaignID?: string | null,
    priorityDate?: string | null,
    segmentation?: string | null,
    levelOfCare: string,
    mergeFlag: boolean,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListSalesOptionsQueryVariables = {
  filter?: ModelSalesOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSalesOptionsQuery = {
  listSalesOptions?:  {
    __typename: "ModelSalesOptionConnection",
    items:  Array< {
      __typename: "SalesOption",
      lossReason?: string | null,
      createdDate: string,
      accountID: string,
      apartment?: string | null,
      apartmentName?: string | null,
      rating?: string | null,
      community: string,
      settledDate?: string | null,
      requestedMailOfBrochure: boolean,
      isDeleted: boolean,
      sourceID: string,
      reservationDate?: string | null,
      reservedMSP?: string | null,
      salesOptionName: string,
      priorityDepCommunity?: string | null,
      ltsScore?: number | null,
      ltsGrade?: number | null,
      lastModifiedDate: string,
      campaignID?: string | null,
      priorityDate?: string | null,
      segmentation?: string | null,
      levelOfCare: string,
      mergeFlag: boolean,
      id: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStaffSeedQueryVariables = {
  id: string,
};

export type GetStaffSeedQuery = {
  getStaffSeed?:  {
    __typename: "StaffSeed",
    id?: string | null,
    address?: string | null,
    city?: string | null,
    community?: string | null,
    createdby?: string | null,
    email?: string | null,
    firstName?: string | null,
    labelSalutation?: string | null,
    lastModifiedBy?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    loc?: string | null,
    owner?: string | null,
    postalCode?: string | null,
    seedDataName?: string | null,
    state?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListStaffSeedsQueryVariables = {
  filter?: ModelStaffSeedFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStaffSeedsQuery = {
  listStaffSeeds?:  {
    __typename: "ModelStaffSeedConnection",
    items:  Array< {
      __typename: "StaffSeed",
      id?: string | null,
      address?: string | null,
      city?: string | null,
      community?: string | null,
      createdby?: string | null,
      email?: string | null,
      firstName?: string | null,
      labelSalutation?: string | null,
      lastModifiedBy?: string | null,
      lastName?: string | null,
      letterSalutation?: string | null,
      loc?: string | null,
      owner?: string | null,
      postalCode?: string | null,
      seedDataName?: string | null,
      state?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchStaffSeedsQueryVariables = {
  filter?: SearchableStaffSeedFilterInput | null,
  sort?: Array< SearchableStaffSeedSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableStaffSeedAggregationInput | null > | null,
};

export type SearchStaffSeedsQuery = {
  searchStaffSeeds?:  {
    __typename: "SearchableStaffSeedConnection",
    items:  Array< {
      __typename: "StaffSeed",
      id?: string | null,
      address?: string | null,
      city?: string | null,
      community?: string | null,
      createdby?: string | null,
      email?: string | null,
      firstName?: string | null,
      labelSalutation?: string | null,
      lastModifiedBy?: string | null,
      lastName?: string | null,
      letterSalutation?: string | null,
      loc?: string | null,
      owner?: string | null,
      postalCode?: string | null,
      seedDataName?: string | null,
      state?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetDistanceToSiteQueryVariables = {
  id: string,
};

export type GetDistanceToSiteQuery = {
  getDistanceToSite?:  {
    __typename: "DistanceToSite",
    distanceToSiteId?: string | null,
    distance?: number | null,
    site?: string | null,
    communityId?: string | null,
    createdDate?: string | null,
    isDeleted?: string | null,
    lastModifiedDate?: string | null,
    contactId?: string | null,
    name?: string | null,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListDistanceToSitesQueryVariables = {
  filter?: ModelDistanceToSiteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDistanceToSitesQuery = {
  listDistanceToSites?:  {
    __typename: "ModelDistanceToSiteConnection",
    items:  Array< {
      __typename: "DistanceToSite",
      distanceToSiteId?: string | null,
      distance?: number | null,
      site?: string | null,
      communityId?: string | null,
      createdDate?: string | null,
      isDeleted?: string | null,
      lastModifiedDate?: string | null,
      contactId?: string | null,
      name?: string | null,
      id: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFilterValueQueryVariables = {
  id: string,
};

export type GetFilterValueQuery = {
  getFilterValue?:  {
    __typename: "FilterValue",
    listType: string,
    fieldId: string,
    version: string,
    selectedValues: Array< string >,
    relationalOperator?: string | null,
    description?: string | null,
    changeReason?: string | null,
    changedBy: string,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFilterValuesQueryVariables = {
  filter?: ModelFilterValueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFilterValuesQuery = {
  listFilterValues?:  {
    __typename: "ModelFilterValueConnection",
    items:  Array< {
      __typename: "FilterValue",
      listType: string,
      fieldId: string,
      version: string,
      selectedValues: Array< string >,
      relationalOperator?: string | null,
      description?: string | null,
      changeReason?: string | null,
      changedBy: string,
      id: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchFilterValuesQueryVariables = {
  filter?: SearchableFilterValueFilterInput | null,
  sort?: Array< SearchableFilterValueSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableFilterValueAggregationInput | null > | null,
};

export type SearchFilterValuesQuery = {
  searchFilterValues?:  {
    __typename: "SearchableFilterValueConnection",
    items:  Array< {
      __typename: "FilterValue",
      listType: string,
      fieldId: string,
      version: string,
      selectedValues: Array< string >,
      relationalOperator?: string | null,
      description?: string | null,
      changeReason?: string | null,
      changedBy: string,
      id: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetFlagDefinitionQueryVariables = {
  id: string,
};

export type GetFlagDefinitionQuery = {
  getFlagDefinition?:  {
    __typename: "FlagDefinition",
    id: string,
    listType: string,
    fieldName: string,
    flagValue: string,
    friendlyName: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFlagDefinitionsQueryVariables = {
  filter?: ModelFlagDefinitionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFlagDefinitionsQuery = {
  listFlagDefinitions?:  {
    __typename: "ModelFlagDefinitionConnection",
    items:  Array< {
      __typename: "FlagDefinition",
      id: string,
      listType: string,
      fieldName: string,
      flagValue: string,
      friendlyName: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchFlagDefinitionsQueryVariables = {
  filter?: SearchableFlagDefinitionFilterInput | null,
  sort?: Array< SearchableFlagDefinitionSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableFlagDefinitionAggregationInput | null > | null,
};

export type SearchFlagDefinitionsQuery = {
  searchFlagDefinitions?:  {
    __typename: "SearchableFlagDefinitionConnection",
    items:  Array< {
      __typename: "FlagDefinition",
      id: string,
      listType: string,
      fieldName: string,
      flagValue: string,
      friendlyName: string,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetDataTransferStageQueryVariables = {
  id: string,
};

export type GetDataTransferStageQuery = {
  getDataTransferStage?:  {
    __typename: "DataTransferStage",
    id: string,
    traceId: string,
    fileKey?: string | null,
    totalInputRecords?: number | null,
    indexStart?: number | null,
    indexEnd?: number | null,
    addedCount?: number | null,
    updatedCount?: number | null,
    failedCount?: number | null,
    failureReason?: string | null,
    source?: string | null,
    expirationUnixTime?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDataTransferStagesQueryVariables = {
  id?: string | null,
  filter?: ModelDataTransferStageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDataTransferStagesQuery = {
  listDataTransferStages?:  {
    __typename: "ModelDataTransferStageConnection",
    items:  Array< {
      __typename: "DataTransferStage",
      id: string,
      traceId: string,
      fileKey?: string | null,
      totalInputRecords?: number | null,
      indexStart?: number | null,
      indexEnd?: number | null,
      addedCount?: number | null,
      updatedCount?: number | null,
      failedCount?: number | null,
      failureReason?: string | null,
      source?: string | null,
      expirationUnixTime?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DataTransferStagesByTraceIdQueryVariables = {
  traceId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDataTransferStageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DataTransferStagesByTraceIdQuery = {
  dataTransferStagesByTraceId?:  {
    __typename: "ModelDataTransferStageConnection",
    items:  Array< {
      __typename: "DataTransferStage",
      id: string,
      traceId: string,
      fileKey?: string | null,
      totalInputRecords?: number | null,
      indexStart?: number | null,
      indexEnd?: number | null,
      addedCount?: number | null,
      updatedCount?: number | null,
      failedCount?: number | null,
      failureReason?: string | null,
      source?: string | null,
      expirationUnixTime?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetExclusionRuleQueryVariables = {
  id: string,
};

export type GetExclusionRuleQuery = {
  getExclusionRule?:  {
    __typename: "ExclusionRule",
    id: string,
    listType: string,
    fieldName: string,
    excludedValues: Array< string >,
    operator: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListExclusionRulesQueryVariables = {
  filter?: ModelExclusionRuleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListExclusionRulesQuery = {
  listExclusionRules?:  {
    __typename: "ModelExclusionRuleConnection",
    items:  Array< {
      __typename: "ExclusionRule",
      id: string,
      listType: string,
      fieldName: string,
      excludedValues: Array< string >,
      operator: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchExclusionRulesQueryVariables = {
  filter?: SearchableExclusionRuleFilterInput | null,
  sort?: Array< SearchableExclusionRuleSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableExclusionRuleAggregationInput | null > | null,
};

export type SearchExclusionRulesQuery = {
  searchExclusionRules?:  {
    __typename: "SearchableExclusionRuleConnection",
    items:  Array< {
      __typename: "ExclusionRule",
      id: string,
      listType: string,
      fieldName: string,
      excludedValues: Array< string >,
      operator: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type OnCreateBLConcurrencyLockSubscriptionVariables = {
  filter?: ModelSubscriptionBLConcurrencyLockFilterInput | null,
};

export type OnCreateBLConcurrencyLockSubscription = {
  onCreateBLConcurrencyLock?:  {
    __typename: "BLConcurrencyLock",
    community: string,
    lockToken?: string | null,
    createdAt?: string | null,
    expirationUnixTime?: number | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateBLConcurrencyLockSubscriptionVariables = {
  filter?: ModelSubscriptionBLConcurrencyLockFilterInput | null,
};

export type OnUpdateBLConcurrencyLockSubscription = {
  onUpdateBLConcurrencyLock?:  {
    __typename: "BLConcurrencyLock",
    community: string,
    lockToken?: string | null,
    createdAt?: string | null,
    expirationUnixTime?: number | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteBLConcurrencyLockSubscriptionVariables = {
  filter?: ModelSubscriptionBLConcurrencyLockFilterInput | null,
};

export type OnDeleteBLConcurrencyLockSubscription = {
  onDeleteBLConcurrencyLock?:  {
    __typename: "BLConcurrencyLock",
    community: string,
    lockToken?: string | null,
    createdAt?: string | null,
    expirationUnixTime?: number | null,
    updatedAt: string,
  } | null,
};

export type OnCreateBoughtListSubscriptionVariables = {
  filter?: ModelSubscriptionBoughtListFilterInput | null,
};

export type OnCreateBoughtListSubscription = {
  onCreateBoughtList?:  {
    __typename: "BoughtList",
    id: string,
    saluation?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    gender?: string | null,
    age?: number | null,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    county?: string | null,
    householdIncome?: string | null,
    householdIncomeBottom?: number | null,
    householdIncomeTop?: number | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    boatingSailing?: string | null,
    tennis?: string | null,
    golf?: string | null,
    boatOwner?: string | null,
    upscaleLiving?: string | null,
    suppress?: string | null,
    doNotMail?: string | null,
    dropDate?: string | null,
    zip5?: string | null,
    batchCode?: string | null,
    listDate?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    qseq?: number | null,
    expirationDate?: string | null,
    lastUpdated?: string | null,
    site1?: string | null,
    siteDistance1?: number | null,
    epm3Decile1?: number | null,
    epm3Score1?: number | null,
    epm3Tier1?: string | null,
    site2?: string | null,
    siteDistance2?: string | null,
    epm3Decile2?: number | null,
    epm3Score2?: number | null,
    epm3Tier2?: string | null,
    blSelect?: string | null,
    hlMatch?: string | null,
    randomNumber?: number | null,
    randomFlag?: number | null,
    netNewFlag?: number | null,
    staticControlFlag?: string | null,
    hlGrpRowList?: string | null,
    hlODateList?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    optOutUpdatedBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    expirationUnixTime?: number | null,
  } | null,
};

export type OnUpdateBoughtListSubscriptionVariables = {
  filter?: ModelSubscriptionBoughtListFilterInput | null,
};

export type OnUpdateBoughtListSubscription = {
  onUpdateBoughtList?:  {
    __typename: "BoughtList",
    id: string,
    saluation?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    gender?: string | null,
    age?: number | null,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    county?: string | null,
    householdIncome?: string | null,
    householdIncomeBottom?: number | null,
    householdIncomeTop?: number | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    boatingSailing?: string | null,
    tennis?: string | null,
    golf?: string | null,
    boatOwner?: string | null,
    upscaleLiving?: string | null,
    suppress?: string | null,
    doNotMail?: string | null,
    dropDate?: string | null,
    zip5?: string | null,
    batchCode?: string | null,
    listDate?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    qseq?: number | null,
    expirationDate?: string | null,
    lastUpdated?: string | null,
    site1?: string | null,
    siteDistance1?: number | null,
    epm3Decile1?: number | null,
    epm3Score1?: number | null,
    epm3Tier1?: string | null,
    site2?: string | null,
    siteDistance2?: string | null,
    epm3Decile2?: number | null,
    epm3Score2?: number | null,
    epm3Tier2?: string | null,
    blSelect?: string | null,
    hlMatch?: string | null,
    randomNumber?: number | null,
    randomFlag?: number | null,
    netNewFlag?: number | null,
    staticControlFlag?: string | null,
    hlGrpRowList?: string | null,
    hlODateList?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    optOutUpdatedBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    expirationUnixTime?: number | null,
  } | null,
};

export type OnDeleteBoughtListSubscriptionVariables = {
  filter?: ModelSubscriptionBoughtListFilterInput | null,
};

export type OnDeleteBoughtListSubscription = {
  onDeleteBoughtList?:  {
    __typename: "BoughtList",
    id: string,
    saluation?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    gender?: string | null,
    age?: number | null,
    address?: string | null,
    city?: string | null,
    state?: string | null,
    zipcode?: string | null,
    county?: string | null,
    householdIncome?: string | null,
    householdIncomeBottom?: number | null,
    householdIncomeTop?: number | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    boatingSailing?: string | null,
    tennis?: string | null,
    golf?: string | null,
    boatOwner?: string | null,
    upscaleLiving?: string | null,
    suppress?: string | null,
    doNotMail?: string | null,
    dropDate?: string | null,
    zip5?: string | null,
    batchCode?: string | null,
    listDate?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    qseq?: number | null,
    expirationDate?: string | null,
    lastUpdated?: string | null,
    site1?: string | null,
    siteDistance1?: number | null,
    epm3Decile1?: number | null,
    epm3Score1?: number | null,
    epm3Tier1?: string | null,
    site2?: string | null,
    siteDistance2?: string | null,
    epm3Decile2?: number | null,
    epm3Score2?: number | null,
    epm3Tier2?: string | null,
    blSelect?: string | null,
    hlMatch?: string | null,
    randomNumber?: number | null,
    randomFlag?: number | null,
    netNewFlag?: number | null,
    staticControlFlag?: string | null,
    hlGrpRowList?: string | null,
    hlODateList?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    optOutUpdatedBy?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    expirationUnixTime?: number | null,
  } | null,
};

export type OnCreateUserFilterSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterFilterInput | null,
  owner?: string | null,
};

export type OnCreateUserFilterSubscription = {
  onCreateUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    listType: string,
    name: string,
    filterDefinitions: string,
    filterSelections: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateUserFilterSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterFilterInput | null,
  owner?: string | null,
};

export type OnUpdateUserFilterSubscription = {
  onUpdateUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    listType: string,
    name: string,
    filterDefinitions: string,
    filterSelections: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteUserFilterSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterFilterInput | null,
  owner?: string | null,
};

export type OnDeleteUserFilterSubscription = {
  onDeleteUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    listType: string,
    name: string,
    filterDefinitions: string,
    filterSelections: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateExportJobSubscriptionVariables = {
  filter?: ModelSubscriptionExportJobFilterInput | null,
  owner?: string | null,
};

export type OnCreateExportJobSubscription = {
  onCreateExportJob?:  {
    __typename: "ExportJob",
    id: string,
    exportName: string,
    listType: string,
    reportId?: string | null,
    status: string,
    statusMessage?: string | null,
    filterInput: string,
    filterFields?: string | null,
    outputFormat?: string | null,
    s3Key?: string | null,
    totalRecords?: number | null,
    fileSize?: number | null,
    startedAt?: string | null,
    expiresAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
    authorizedReaders?: Array< string > | null,
    debugInfo?: string | null,
  } | null,
};

export type OnUpdateExportJobSubscriptionVariables = {
  filter?: ModelSubscriptionExportJobFilterInput | null,
  owner?: string | null,
};

export type OnUpdateExportJobSubscription = {
  onUpdateExportJob?:  {
    __typename: "ExportJob",
    id: string,
    exportName: string,
    listType: string,
    reportId?: string | null,
    status: string,
    statusMessage?: string | null,
    filterInput: string,
    filterFields?: string | null,
    outputFormat?: string | null,
    s3Key?: string | null,
    totalRecords?: number | null,
    fileSize?: number | null,
    startedAt?: string | null,
    expiresAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
    authorizedReaders?: Array< string > | null,
    debugInfo?: string | null,
  } | null,
};

export type OnDeleteExportJobSubscriptionVariables = {
  filter?: ModelSubscriptionExportJobFilterInput | null,
  owner?: string | null,
};

export type OnDeleteExportJobSubscription = {
  onDeleteExportJob?:  {
    __typename: "ExportJob",
    id: string,
    exportName: string,
    listType: string,
    reportId?: string | null,
    status: string,
    statusMessage?: string | null,
    filterInput: string,
    filterFields?: string | null,
    outputFormat?: string | null,
    s3Key?: string | null,
    totalRecords?: number | null,
    fileSize?: number | null,
    startedAt?: string | null,
    expiresAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    owner?: string | null,
    authorizedReaders?: Array< string > | null,
    debugInfo?: string | null,
  } | null,
};

export type OnCreateReportRunScheduleSubscriptionVariables = {
  filter?: ModelSubscriptionReportRunScheduleFilterInput | null,
};

export type OnCreateReportRunScheduleSubscription = {
  onCreateReportRunSchedule?:  {
    __typename: "ReportRunSchedule",
    id: string,
    reportId: string,
    scheduleExpression: string,
    enabled: boolean,
    subscribers: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateReportRunScheduleSubscriptionVariables = {
  filter?: ModelSubscriptionReportRunScheduleFilterInput | null,
};

export type OnUpdateReportRunScheduleSubscription = {
  onUpdateReportRunSchedule?:  {
    __typename: "ReportRunSchedule",
    id: string,
    reportId: string,
    scheduleExpression: string,
    enabled: boolean,
    subscribers: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteReportRunScheduleSubscriptionVariables = {
  filter?: ModelSubscriptionReportRunScheduleFilterInput | null,
};

export type OnDeleteReportRunScheduleSubscription = {
  onDeleteReportRunSchedule?:  {
    __typename: "ReportRunSchedule",
    id: string,
    reportId: string,
    scheduleExpression: string,
    enabled: boolean,
    subscribers: Array< string >,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateHouselistNewSubscriptionVariables = {
  filter?: ModelSubscriptionHouselistNewFilterInput | null,
};

export type OnCreateHouselistNewSubscription = {
  onCreateHouselistNew?:  {
    __typename: "HouselistNew",
    id: string,
    accountID?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    control?: string | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    hohIncome?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    hohNetWorth?: string | null,
    hohNetWorthBottom?: number | null,
    hohNetWorthTop?: number | null,
    groupName?: string | null,
    birthDate?: string | null,
    deceasedDate?: string | null,
    distanceToSite?: number | null,
    doNotCall?: boolean | null,
    email?: string | null,
    emailBounceDate?: string | null,
    epm2Grade?: number | null,
    epm2Score?: number | null,
    epm2Tier?: string | null,
    firstName?: string | null,
    gender?: string | null,
    hasOptedOutOfEmail?: boolean | null,
    hohAge?: number | null,
    homePhone?: string | null,
    contactId?: string | null,
    ilContactStatus?: string | null,
    labelSalutation?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    neighborhood?: string | null,
    city?: string | null,
    zip5?: string | null,
    zipcode?: string | null,
    state?: string | null,
    address?: string | null,
    maritalStatus?: string | null,
    mlActive?: boolean | null,
    cellPhone?: string | null,
    primaryContact?: string | null,
    primarySite?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    qasValidationStatus?: string | null,
    contactType?: string | null,
    returnedMail?: boolean | null,
    ccContactStatus?: string | null,
    opportunitySite?: string | null,
    opportunityId?: string | null,
    loc?: string | null,
    ltsGrade?: number | null,
    ltsScore?: number | null,
    primaryMotivation?: string | null,
    communityName?: string | null,
    rating?: string | null,
    segmentation?: string | null,
    settledDate?: string | null,
    salesStage?: string | null,
    priorityDate?: string | null,
    reservationDate?: string | null,
    businessType?: string | null,
    salesOptionDate?: string | null,
    apartmentName?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    mlContactInactiveReasons?: Array< string > | null,
    mlSOInactiveReasons?: Array< string > | null,
    mlInactiveReasons?: Array< string > | null,
    priorityType?: string | null,
    nextStep?: string | null,
    salesCounselor?: string | null,
    salesCounselorName?: string | null,
    timeframe?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateHouselistNewSubscriptionVariables = {
  filter?: ModelSubscriptionHouselistNewFilterInput | null,
};

export type OnUpdateHouselistNewSubscription = {
  onUpdateHouselistNew?:  {
    __typename: "HouselistNew",
    id: string,
    accountID?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    control?: string | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    hohIncome?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    hohNetWorth?: string | null,
    hohNetWorthBottom?: number | null,
    hohNetWorthTop?: number | null,
    groupName?: string | null,
    birthDate?: string | null,
    deceasedDate?: string | null,
    distanceToSite?: number | null,
    doNotCall?: boolean | null,
    email?: string | null,
    emailBounceDate?: string | null,
    epm2Grade?: number | null,
    epm2Score?: number | null,
    epm2Tier?: string | null,
    firstName?: string | null,
    gender?: string | null,
    hasOptedOutOfEmail?: boolean | null,
    hohAge?: number | null,
    homePhone?: string | null,
    contactId?: string | null,
    ilContactStatus?: string | null,
    labelSalutation?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    neighborhood?: string | null,
    city?: string | null,
    zip5?: string | null,
    zipcode?: string | null,
    state?: string | null,
    address?: string | null,
    maritalStatus?: string | null,
    mlActive?: boolean | null,
    cellPhone?: string | null,
    primaryContact?: string | null,
    primarySite?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    qasValidationStatus?: string | null,
    contactType?: string | null,
    returnedMail?: boolean | null,
    ccContactStatus?: string | null,
    opportunitySite?: string | null,
    opportunityId?: string | null,
    loc?: string | null,
    ltsGrade?: number | null,
    ltsScore?: number | null,
    primaryMotivation?: string | null,
    communityName?: string | null,
    rating?: string | null,
    segmentation?: string | null,
    settledDate?: string | null,
    salesStage?: string | null,
    priorityDate?: string | null,
    reservationDate?: string | null,
    businessType?: string | null,
    salesOptionDate?: string | null,
    apartmentName?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    mlContactInactiveReasons?: Array< string > | null,
    mlSOInactiveReasons?: Array< string > | null,
    mlInactiveReasons?: Array< string > | null,
    priorityType?: string | null,
    nextStep?: string | null,
    salesCounselor?: string | null,
    salesCounselorName?: string | null,
    timeframe?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteHouselistNewSubscriptionVariables = {
  filter?: ModelSubscriptionHouselistNewFilterInput | null,
};

export type OnDeleteHouselistNewSubscription = {
  onDeleteHouselistNew?:  {
    __typename: "HouselistNew",
    id: string,
    accountID?: string | null,
    listName?: string | null,
    listNameId?: string | null,
    control?: string | null,
    homeValue?: string | null,
    homeValueBottom?: number | null,
    homeValueTop?: number | null,
    hohIncome?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    hohNetWorth?: string | null,
    hohNetWorthBottom?: number | null,
    hohNetWorthTop?: number | null,
    groupName?: string | null,
    birthDate?: string | null,
    deceasedDate?: string | null,
    distanceToSite?: number | null,
    doNotCall?: boolean | null,
    email?: string | null,
    emailBounceDate?: string | null,
    epm2Grade?: number | null,
    epm2Score?: number | null,
    epm2Tier?: string | null,
    firstName?: string | null,
    gender?: string | null,
    hasOptedOutOfEmail?: boolean | null,
    hohAge?: number | null,
    homePhone?: string | null,
    contactId?: string | null,
    ilContactStatus?: string | null,
    labelSalutation?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    neighborhood?: string | null,
    city?: string | null,
    zip5?: string | null,
    zipcode?: string | null,
    state?: string | null,
    address?: string | null,
    maritalStatus?: string | null,
    mlActive?: boolean | null,
    cellPhone?: string | null,
    primaryContact?: string | null,
    primarySite?: string | null,
    latitude?: number | null,
    longitude?: number | null,
    qasValidationStatus?: string | null,
    contactType?: string | null,
    returnedMail?: boolean | null,
    ccContactStatus?: string | null,
    opportunitySite?: string | null,
    opportunityId?: string | null,
    loc?: string | null,
    ltsGrade?: number | null,
    ltsScore?: number | null,
    primaryMotivation?: string | null,
    communityName?: string | null,
    rating?: string | null,
    segmentation?: string | null,
    settledDate?: string | null,
    salesStage?: string | null,
    priorityDate?: string | null,
    reservationDate?: string | null,
    businessType?: string | null,
    salesOptionDate?: string | null,
    apartmentName?: string | null,
    optOut?: boolean | null,
    optOutDateTime?: string | null,
    mlContactInactiveReasons?: Array< string > | null,
    mlSOInactiveReasons?: Array< string > | null,
    mlInactiveReasons?: Array< string > | null,
    priorityType?: string | null,
    nextStep?: string | null,
    salesCounselor?: string | null,
    salesCounselorName?: string | null,
    timeframe?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAccountSubscriptionVariables = {
  filter?: ModelSubscriptionAccountFilterInput | null,
  owner?: string | null,
};

export type OnCreateAccountSubscription = {
  onCreateAccount?:  {
    __typename: "Account",
    updateHash?: string | null,
    accountID: string,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    accountNameId: string,
    homeValueTop?: string | null,
    letterSaluation: string,
    numberOfParticipants: number,
    primaryContact: string,
    lastModifiedDate: string,
    otherInterestsMotivation?: string | null,
    createdDate: string,
    controlFlag: boolean,
    hobbiesInterest?: string | null,
    primarySite?: string | null,
    hohNetRange?: string | null,
    homeValueRange?: string | null,
    hohNetWorthTop?: number | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    accountName: string,
    hohIncomeTop?: number | null,
    hohNetWorthBottom?: number | null,
    parentAccountID?: string | null,
    returnedMail: boolean,
    type: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateAccountSubscriptionVariables = {
  filter?: ModelSubscriptionAccountFilterInput | null,
  owner?: string | null,
};

export type OnUpdateAccountSubscription = {
  onUpdateAccount?:  {
    __typename: "Account",
    updateHash?: string | null,
    accountID: string,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    accountNameId: string,
    homeValueTop?: string | null,
    letterSaluation: string,
    numberOfParticipants: number,
    primaryContact: string,
    lastModifiedDate: string,
    otherInterestsMotivation?: string | null,
    createdDate: string,
    controlFlag: boolean,
    hobbiesInterest?: string | null,
    primarySite?: string | null,
    hohNetRange?: string | null,
    homeValueRange?: string | null,
    hohNetWorthTop?: number | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    accountName: string,
    hohIncomeTop?: number | null,
    hohNetWorthBottom?: number | null,
    parentAccountID?: string | null,
    returnedMail: boolean,
    type: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteAccountSubscriptionVariables = {
  filter?: ModelSubscriptionAccountFilterInput | null,
  owner?: string | null,
};

export type OnDeleteAccountSubscription = {
  onDeleteAccount?:  {
    __typename: "Account",
    updateHash?: string | null,
    accountID: string,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    accountNameId: string,
    homeValueTop?: string | null,
    letterSaluation: string,
    numberOfParticipants: number,
    primaryContact: string,
    lastModifiedDate: string,
    otherInterestsMotivation?: string | null,
    createdDate: string,
    controlFlag: boolean,
    hobbiesInterest?: string | null,
    primarySite?: string | null,
    hohNetRange?: string | null,
    homeValueRange?: string | null,
    hohNetWorthTop?: number | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    accountName: string,
    hohIncomeTop?: number | null,
    hohNetWorthBottom?: number | null,
    parentAccountID?: string | null,
    returnedMail: boolean,
    type: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateContactSubscriptionVariables = {
  filter?: ModelSubscriptionContactFilterInput | null,
  owner?: string | null,
};

export type OnCreateContactSubscription = {
  onCreateContact?:  {
    __typename: "Contact",
    doNotMail: boolean,
    deceasedDate?: string | null,
    birthDate?: string | null,
    lastName: string,
    status: string,
    emailBounceBack: boolean,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    letterSaluation: string,
    hohNetWorth?: string | null,
    contactID: string,
    hohAge?: number | null,
    primaryFlag: string,
    lastModifiedDate: string,
    mailingStreet: string,
    mailingState: string,
    preferredContactMethod?: string | null,
    epm2Score?: number | null,
    ilContactStatus: string,
    emailBounceBackDate?: string | null,
    fullName: string,
    primarySite?: string | null,
    homeValueRange?: string | null,
    maritalStatus?: string | null,
    mailingCountry: string,
    militaryService?: boolean | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    qasLongitude?: string | null,
    hasOptedOutOfEmail: boolean,
    mailingCountryCode: string,
    returnedMail: boolean,
    mobilePhone?: string | null,
    accountID: string,
    qasMailingValidationStatus: string,
    email?: string | null,
    homeValueTop?: number | null,
    firstName: string,
    mailingCity: string,
    doNotCall: boolean,
    salutation?: string | null,
    mlActive?: boolean | null,
    homePhone?: string | null,
    placeOfBirth?: string | null,
    masterRecordID?: string | null,
    emailOptOutDate?: string | null,
    gender?: string | null,
    qasLatitude?: string | null,
    hohNetWorthTop?: number | null,
    mailingZipCode: string,
    mailingNeighborhood?: string | null,
    contactType: string,
    hohNetWorthBottom?: number | null,
    epm2Decile?: number | null,
    mailingStateCode: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateContactSubscriptionVariables = {
  filter?: ModelSubscriptionContactFilterInput | null,
  owner?: string | null,
};

export type OnUpdateContactSubscription = {
  onUpdateContact?:  {
    __typename: "Contact",
    doNotMail: boolean,
    deceasedDate?: string | null,
    birthDate?: string | null,
    lastName: string,
    status: string,
    emailBounceBack: boolean,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    letterSaluation: string,
    hohNetWorth?: string | null,
    contactID: string,
    hohAge?: number | null,
    primaryFlag: string,
    lastModifiedDate: string,
    mailingStreet: string,
    mailingState: string,
    preferredContactMethod?: string | null,
    epm2Score?: number | null,
    ilContactStatus: string,
    emailBounceBackDate?: string | null,
    fullName: string,
    primarySite?: string | null,
    homeValueRange?: string | null,
    maritalStatus?: string | null,
    mailingCountry: string,
    militaryService?: boolean | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    qasLongitude?: string | null,
    hasOptedOutOfEmail: boolean,
    mailingCountryCode: string,
    returnedMail: boolean,
    mobilePhone?: string | null,
    accountID: string,
    qasMailingValidationStatus: string,
    email?: string | null,
    homeValueTop?: number | null,
    firstName: string,
    mailingCity: string,
    doNotCall: boolean,
    salutation?: string | null,
    mlActive?: boolean | null,
    homePhone?: string | null,
    placeOfBirth?: string | null,
    masterRecordID?: string | null,
    emailOptOutDate?: string | null,
    gender?: string | null,
    qasLatitude?: string | null,
    hohNetWorthTop?: number | null,
    mailingZipCode: string,
    mailingNeighborhood?: string | null,
    contactType: string,
    hohNetWorthBottom?: number | null,
    epm2Decile?: number | null,
    mailingStateCode: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteContactSubscriptionVariables = {
  filter?: ModelSubscriptionContactFilterInput | null,
  owner?: string | null,
};

export type OnDeleteContactSubscription = {
  onDeleteContact?:  {
    __typename: "Contact",
    doNotMail: boolean,
    deceasedDate?: string | null,
    birthDate?: string | null,
    lastName: string,
    status: string,
    emailBounceBack: boolean,
    isDeleted: boolean,
    labelSaluation: string,
    homeValueBottom?: number | null,
    letterSaluation: string,
    hohNetWorth?: string | null,
    contactID: string,
    hohAge?: number | null,
    primaryFlag: string,
    lastModifiedDate: string,
    mailingStreet: string,
    mailingState: string,
    preferredContactMethod?: string | null,
    epm2Score?: number | null,
    ilContactStatus: string,
    emailBounceBackDate?: string | null,
    fullName: string,
    primarySite?: string | null,
    homeValueRange?: string | null,
    maritalStatus?: string | null,
    mailingCountry: string,
    militaryService?: boolean | null,
    hohIncomeRange?: string | null,
    hohIncomeBottom?: number | null,
    hohIncomeTop?: number | null,
    qasLongitude?: string | null,
    hasOptedOutOfEmail: boolean,
    mailingCountryCode: string,
    returnedMail: boolean,
    mobilePhone?: string | null,
    accountID: string,
    qasMailingValidationStatus: string,
    email?: string | null,
    homeValueTop?: number | null,
    firstName: string,
    mailingCity: string,
    doNotCall: boolean,
    salutation?: string | null,
    mlActive?: boolean | null,
    homePhone?: string | null,
    placeOfBirth?: string | null,
    masterRecordID?: string | null,
    emailOptOutDate?: string | null,
    gender?: string | null,
    qasLatitude?: string | null,
    hohNetWorthTop?: number | null,
    mailingZipCode: string,
    mailingNeighborhood?: string | null,
    contactType: string,
    hohNetWorthBottom?: number | null,
    epm2Decile?: number | null,
    mailingStateCode: string,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateSalesOptionSubscriptionVariables = {
  filter?: ModelSubscriptionSalesOptionFilterInput | null,
  owner?: string | null,
};

export type OnCreateSalesOptionSubscription = {
  onCreateSalesOption?:  {
    __typename: "SalesOption",
    lossReason?: string | null,
    createdDate: string,
    accountID: string,
    apartment?: string | null,
    apartmentName?: string | null,
    rating?: string | null,
    community: string,
    settledDate?: string | null,
    requestedMailOfBrochure: boolean,
    isDeleted: boolean,
    sourceID: string,
    reservationDate?: string | null,
    reservedMSP?: string | null,
    salesOptionName: string,
    priorityDepCommunity?: string | null,
    ltsScore?: number | null,
    ltsGrade?: number | null,
    lastModifiedDate: string,
    campaignID?: string | null,
    priorityDate?: string | null,
    segmentation?: string | null,
    levelOfCare: string,
    mergeFlag: boolean,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateSalesOptionSubscriptionVariables = {
  filter?: ModelSubscriptionSalesOptionFilterInput | null,
  owner?: string | null,
};

export type OnUpdateSalesOptionSubscription = {
  onUpdateSalesOption?:  {
    __typename: "SalesOption",
    lossReason?: string | null,
    createdDate: string,
    accountID: string,
    apartment?: string | null,
    apartmentName?: string | null,
    rating?: string | null,
    community: string,
    settledDate?: string | null,
    requestedMailOfBrochure: boolean,
    isDeleted: boolean,
    sourceID: string,
    reservationDate?: string | null,
    reservedMSP?: string | null,
    salesOptionName: string,
    priorityDepCommunity?: string | null,
    ltsScore?: number | null,
    ltsGrade?: number | null,
    lastModifiedDate: string,
    campaignID?: string | null,
    priorityDate?: string | null,
    segmentation?: string | null,
    levelOfCare: string,
    mergeFlag: boolean,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteSalesOptionSubscriptionVariables = {
  filter?: ModelSubscriptionSalesOptionFilterInput | null,
  owner?: string | null,
};

export type OnDeleteSalesOptionSubscription = {
  onDeleteSalesOption?:  {
    __typename: "SalesOption",
    lossReason?: string | null,
    createdDate: string,
    accountID: string,
    apartment?: string | null,
    apartmentName?: string | null,
    rating?: string | null,
    community: string,
    settledDate?: string | null,
    requestedMailOfBrochure: boolean,
    isDeleted: boolean,
    sourceID: string,
    reservationDate?: string | null,
    reservedMSP?: string | null,
    salesOptionName: string,
    priorityDepCommunity?: string | null,
    ltsScore?: number | null,
    ltsGrade?: number | null,
    lastModifiedDate: string,
    campaignID?: string | null,
    priorityDate?: string | null,
    segmentation?: string | null,
    levelOfCare: string,
    mergeFlag: boolean,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateStaffSeedSubscriptionVariables = {
  filter?: ModelSubscriptionStaffSeedFilterInput | null,
  owner?: string | null,
};

export type OnCreateStaffSeedSubscription = {
  onCreateStaffSeed?:  {
    __typename: "StaffSeed",
    id?: string | null,
    address?: string | null,
    city?: string | null,
    community?: string | null,
    createdby?: string | null,
    email?: string | null,
    firstName?: string | null,
    labelSalutation?: string | null,
    lastModifiedBy?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    loc?: string | null,
    owner?: string | null,
    postalCode?: string | null,
    seedDataName?: string | null,
    state?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateStaffSeedSubscriptionVariables = {
  filter?: ModelSubscriptionStaffSeedFilterInput | null,
  owner?: string | null,
};

export type OnUpdateStaffSeedSubscription = {
  onUpdateStaffSeed?:  {
    __typename: "StaffSeed",
    id?: string | null,
    address?: string | null,
    city?: string | null,
    community?: string | null,
    createdby?: string | null,
    email?: string | null,
    firstName?: string | null,
    labelSalutation?: string | null,
    lastModifiedBy?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    loc?: string | null,
    owner?: string | null,
    postalCode?: string | null,
    seedDataName?: string | null,
    state?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteStaffSeedSubscriptionVariables = {
  filter?: ModelSubscriptionStaffSeedFilterInput | null,
  owner?: string | null,
};

export type OnDeleteStaffSeedSubscription = {
  onDeleteStaffSeed?:  {
    __typename: "StaffSeed",
    id?: string | null,
    address?: string | null,
    city?: string | null,
    community?: string | null,
    createdby?: string | null,
    email?: string | null,
    firstName?: string | null,
    labelSalutation?: string | null,
    lastModifiedBy?: string | null,
    lastName?: string | null,
    letterSalutation?: string | null,
    loc?: string | null,
    owner?: string | null,
    postalCode?: string | null,
    seedDataName?: string | null,
    state?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateDistanceToSiteSubscriptionVariables = {
  filter?: ModelSubscriptionDistanceToSiteFilterInput | null,
  owner?: string | null,
};

export type OnCreateDistanceToSiteSubscription = {
  onCreateDistanceToSite?:  {
    __typename: "DistanceToSite",
    distanceToSiteId?: string | null,
    distance?: number | null,
    site?: string | null,
    communityId?: string | null,
    createdDate?: string | null,
    isDeleted?: string | null,
    lastModifiedDate?: string | null,
    contactId?: string | null,
    name?: string | null,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateDistanceToSiteSubscriptionVariables = {
  filter?: ModelSubscriptionDistanceToSiteFilterInput | null,
  owner?: string | null,
};

export type OnUpdateDistanceToSiteSubscription = {
  onUpdateDistanceToSite?:  {
    __typename: "DistanceToSite",
    distanceToSiteId?: string | null,
    distance?: number | null,
    site?: string | null,
    communityId?: string | null,
    createdDate?: string | null,
    isDeleted?: string | null,
    lastModifiedDate?: string | null,
    contactId?: string | null,
    name?: string | null,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteDistanceToSiteSubscriptionVariables = {
  filter?: ModelSubscriptionDistanceToSiteFilterInput | null,
  owner?: string | null,
};

export type OnDeleteDistanceToSiteSubscription = {
  onDeleteDistanceToSite?:  {
    __typename: "DistanceToSite",
    distanceToSiteId?: string | null,
    distance?: number | null,
    site?: string | null,
    communityId?: string | null,
    createdDate?: string | null,
    isDeleted?: string | null,
    lastModifiedDate?: string | null,
    contactId?: string | null,
    name?: string | null,
    id: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateFilterValueSubscriptionVariables = {
  filter?: ModelSubscriptionFilterValueFilterInput | null,
};

export type OnCreateFilterValueSubscription = {
  onCreateFilterValue?:  {
    __typename: "FilterValue",
    listType: string,
    fieldId: string,
    version: string,
    selectedValues: Array< string >,
    relationalOperator?: string | null,
    description?: string | null,
    changeReason?: string | null,
    changedBy: string,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFilterValueSubscriptionVariables = {
  filter?: ModelSubscriptionFilterValueFilterInput | null,
};

export type OnUpdateFilterValueSubscription = {
  onUpdateFilterValue?:  {
    __typename: "FilterValue",
    listType: string,
    fieldId: string,
    version: string,
    selectedValues: Array< string >,
    relationalOperator?: string | null,
    description?: string | null,
    changeReason?: string | null,
    changedBy: string,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFilterValueSubscriptionVariables = {
  filter?: ModelSubscriptionFilterValueFilterInput | null,
};

export type OnDeleteFilterValueSubscription = {
  onDeleteFilterValue?:  {
    __typename: "FilterValue",
    listType: string,
    fieldId: string,
    version: string,
    selectedValues: Array< string >,
    relationalOperator?: string | null,
    description?: string | null,
    changeReason?: string | null,
    changedBy: string,
    id: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFlagDefinitionSubscriptionVariables = {
  filter?: ModelSubscriptionFlagDefinitionFilterInput | null,
};

export type OnCreateFlagDefinitionSubscription = {
  onCreateFlagDefinition?:  {
    __typename: "FlagDefinition",
    id: string,
    listType: string,
    fieldName: string,
    flagValue: string,
    friendlyName: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFlagDefinitionSubscriptionVariables = {
  filter?: ModelSubscriptionFlagDefinitionFilterInput | null,
};

export type OnUpdateFlagDefinitionSubscription = {
  onUpdateFlagDefinition?:  {
    __typename: "FlagDefinition",
    id: string,
    listType: string,
    fieldName: string,
    flagValue: string,
    friendlyName: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFlagDefinitionSubscriptionVariables = {
  filter?: ModelSubscriptionFlagDefinitionFilterInput | null,
};

export type OnDeleteFlagDefinitionSubscription = {
  onDeleteFlagDefinition?:  {
    __typename: "FlagDefinition",
    id: string,
    listType: string,
    fieldName: string,
    flagValue: string,
    friendlyName: string,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateDataTransferStageSubscriptionVariables = {
  filter?: ModelSubscriptionDataTransferStageFilterInput | null,
};

export type OnCreateDataTransferStageSubscription = {
  onCreateDataTransferStage?:  {
    __typename: "DataTransferStage",
    id: string,
    traceId: string,
    fileKey?: string | null,
    totalInputRecords?: number | null,
    indexStart?: number | null,
    indexEnd?: number | null,
    addedCount?: number | null,
    updatedCount?: number | null,
    failedCount?: number | null,
    failureReason?: string | null,
    source?: string | null,
    expirationUnixTime?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateDataTransferStageSubscriptionVariables = {
  filter?: ModelSubscriptionDataTransferStageFilterInput | null,
};

export type OnUpdateDataTransferStageSubscription = {
  onUpdateDataTransferStage?:  {
    __typename: "DataTransferStage",
    id: string,
    traceId: string,
    fileKey?: string | null,
    totalInputRecords?: number | null,
    indexStart?: number | null,
    indexEnd?: number | null,
    addedCount?: number | null,
    updatedCount?: number | null,
    failedCount?: number | null,
    failureReason?: string | null,
    source?: string | null,
    expirationUnixTime?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteDataTransferStageSubscriptionVariables = {
  filter?: ModelSubscriptionDataTransferStageFilterInput | null,
};

export type OnDeleteDataTransferStageSubscription = {
  onDeleteDataTransferStage?:  {
    __typename: "DataTransferStage",
    id: string,
    traceId: string,
    fileKey?: string | null,
    totalInputRecords?: number | null,
    indexStart?: number | null,
    indexEnd?: number | null,
    addedCount?: number | null,
    updatedCount?: number | null,
    failedCount?: number | null,
    failureReason?: string | null,
    source?: string | null,
    expirationUnixTime?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateExclusionRuleSubscriptionVariables = {
  filter?: ModelSubscriptionExclusionRuleFilterInput | null,
};

export type OnCreateExclusionRuleSubscription = {
  onCreateExclusionRule?:  {
    __typename: "ExclusionRule",
    id: string,
    listType: string,
    fieldName: string,
    excludedValues: Array< string >,
    operator: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateExclusionRuleSubscriptionVariables = {
  filter?: ModelSubscriptionExclusionRuleFilterInput | null,
};

export type OnUpdateExclusionRuleSubscription = {
  onUpdateExclusionRule?:  {
    __typename: "ExclusionRule",
    id: string,
    listType: string,
    fieldName: string,
    excludedValues: Array< string >,
    operator: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteExclusionRuleSubscriptionVariables = {
  filter?: ModelSubscriptionExclusionRuleFilterInput | null,
};

export type OnDeleteExclusionRuleSubscription = {
  onDeleteExclusionRule?:  {
    __typename: "ExclusionRule",
    id: string,
    listType: string,
    fieldName: string,
    excludedValues: Array< string >,
    operator: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};
